import React, {
    useCallback,
    useEffect,
    useLayoutEffect,
    useRef,
    useState,
} from "react";
import {
    Accordion,
    Container,
    Dropdown,
    InputGroup,
    Overlay,
    Tooltip,
} from "react-bootstrap";
import homeImage from "../../assets/images/home.svg";
import { json, useLocation, useNavigate, useParams } from "react-router-dom";
import { default as infoIcon } from "../../assets/images/Info icon.svg";
import WorflowDescription from "../common-component/WorflowDescription";
import { ENUMS } from "../../services/Enums";
import { toast } from "react-toastify";
import { commonservices, TIMEZONE_LIST } from "../../services/CommonServices";
import profileicon from "../../assets/images/dummy-profile-pic.jpg";
import { useDispatch, useSelector } from "react-redux";
import WorflowContactList from "../common-component/WorflowContactList";
import dots from "../../assets/images/dots.svg";
import grid from "../../assets/images/grid.svg";
import notification from "../../assets/images/notification.svg";
import schedular from "../../assets/images/schedular.svg";
import dollar from "../../assets/images/dollar.svg";
import workflowSetting from "../../assets/images/workflowSetting.svg";
import supportmodule from "../../assets/images/supportmodule.svg";
import configmodule from "../../assets/images/configmodule.svg";
import wfMain from "../../assets/images/WFMain.svg";
import fileGrey from "../../assets/images/fileGrey.svg";
import clockhistory from "../../assets/images/clockhistory.svg";
import contacts from "../../assets/images/contacts.svg";
import ConfigModel from "./FlowNewModels/ConfigModel";
import closeImage from "../../assets/images/close-white.svg";
import CostAndUsagePopup from "../common-component/CostAndUsagePopup";
import NotificationPopup from "../common-component/NotificationPopup";
import SchedularPopup from "../common-component/SchedularPopup";
import searchicon from "../../assets/images/searchicon.svg";
import pinned from "../../assets/images/Pinned.svg";
import unpinned from "../../assets/images/Unpin.svg";
import Loader, { LoaderType } from "../common-component/Loader";
import DemoLogo from "../../assets/images/quantummain.svg";
import notmachineavaliable from "../../assets/images/notmachineavaliable.png";
import buymoremachine from "../../assets/images/buymoremachine.svg";
import Form from "react-bootstrap/Form";
import WorkFlowStatusModel from "../../Modals/WorkFlowStatusModel";
import WorkflowCostSummaryModel from "../../Modals/WorkflowCostSummaryModel";
import ReactFlow, {
    addEdge,
    Background,
    Controls,
    MiniMap,
    StepEdge,
    useEdgesState,
    useNodesState,
} from "react-flow-renderer";
import dagre from "dagre";
import WorkFlowMachineSetupModel from "../../Modals/WorkFlowMachineSetupModel";
import robot from "../../assets/images/robot.gif";
import analatics from "../../assets/images/analytics.svg";
import blackrightupicon from "../../assets/images/blackrightupicon.svg";
import charticon from "../../assets/images/charticon.svg";
import toprightgreen from "../../assets/images/toprightgreen.svg";
import dounlefticon from "../../assets/images/dounlefticon.svg";

import playicon from "../../assets/images/FlowButtonSVG/play.svg";
import Suspendicon from "../../assets/images/FlowButtonSVG/Suspend.svg";
import Stopicon from "../../assets/images/FlowButtonSVG/Stop.svg";
import Deleteicon from "../../assets/images/FlowButtonSVG/Delete.svg";
import Resumeicon from "../../assets/images/FlowButtonSVG/Resume.svg";
import viewAction from "../../assets/images/FlowButtonSVG/view.svg";

import actionLog from "../../assets/images/actionLog.svg";
import moment from "moment";
import { WorkTeamGetTeamList } from "../../services/ReduxTookit/Slice/WorkflowTeamRedux";
import {
    GetWorkFlowByID,
    GetWorkflowPrompt,
    GetWorkspaceListByID,
    SaveWorkflowPrompt,
    setGetWorkFlowByID,
    UpdateWorkFlowRunningStatus,
    UpdateWorkFlowStatus,
    WorkFlowCopy,
    WorkFlowSave,
} from "../../services/ReduxTookit/Slice/WorkFlowRedux";
import { getMonthlycostbydatabyWorkflowId } from "../../services/ReduxTookit/Slice/ReportRedux";
import StackedBarChart from "../common-component/StackedBarChart";
import Nodata from "../common-component/Nodata";
import { WorkflowScheduleLogGetList } from "../../services/ReduxTookit/Slice/AllLogRedux";
import WorkFlowMachineLogDetailModal from "../common-component/WorkFlowMachineLogDetailModal";
import viewActionIcon from "../../assets/images/viewaction.svg";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { MyMachineGetList } from "../../services/ReduxTookit/Slice/MachineRedux";
import WorkFlowLogModal from "../common-component/WorkFlowLogModal";
import SupportModel from "./FlowNewModels/SupportModel";
import SaveAsCopyModal from "./SaveAsCopyModal";
import DeleteModal from "../../Modals/DeleteModal";
import { API_URL } from "../../services/APIRoute";
import FlowSaveConfirmPopup from "../../Modals/FlowSaveConfirmPopup";
import Walkthrough from "../common-component/Walkthrough";
import ManageStatusBar from "../../Modals/ManageStatusBar";
import ManageStatusBarBlank from "../../Modals/ManageStatusBarBlank";
import MainpageLoader from "../common-component/Loaders/MainpageLoader";
import CounterPage from "./CounterPage";
import { AmountLoader } from "../common-component/AmountLoader";
import { ProjectTermGetList } from "../../services/ReduxTookit/Slice/ProjectTermRedux";
import {
    GetMachines,
    SuggestMachines,
    VectorStore,
} from "../../services/ReduxTookit/Slice/AIAPI";
import MarketPlaceDetailPopup from "../common-component/MarketPlaceDetailPopup";
import DataMapping from "./DataMapping";
import ButtonEdge from "./ButtonEdge";

import workflow_invalid from "../../assets/images/workflow_invalid.svg";
import workflow_suspend from "../../assets/images/workflow_suspend.svg";
import workflow_active from "../../assets/images/workflow_active.svg";

export function CalculateMachineDurationSec({ Seconds }) {
    if (Seconds) {
        if (Seconds <= 60) {
            return (
                <p>
                    <span>{String(Seconds).padStart(2, "0")}</span>s
                </p>
            );
        } else if (Seconds < 3600) {
            const minutes = Math.floor(Seconds / 60);
            const seconds = Seconds % 60;
            return (
                <p>
                    <span>{String(minutes).padStart(2, "0")}</span>m
                    <span> {String(seconds).padStart(2, "0")}</span>s
                </p>
            );
        } else {
            const hours = Math.floor(Seconds / 3600);
            const minutes = Math.floor((Seconds % 3600) / 60);
            const seconds = Seconds % 60;
            return (
                <p>
                    <span>{String(hours).padStart(2, "0")}</span>h
                    <span> {String(minutes).padStart(2, "0")}</span>m
                </p>
            );
        }
    } else {
        return (
            <p>
                <span>{"00"}</span>s
            </p>
        );
    }
}

export const CalculateMachineDurationSecInOtherFormat = ({ Seconds }) => {
    if (Seconds) {
        if (Seconds <= 60) {
            return (
                <p>
                    <span>00:{String(Seconds).padStart(2, "0")}</span>
                </p>
            );
        } else if (Seconds < 3600) {
            const minutes = Math.floor(Seconds / 60);
            const seconds = Seconds % 60;
            return (
                <p>
                    <span>{String(minutes).padStart(2, "0")}</span>:
                    <span> {String(seconds).padStart(2, "0")}</span>
                </p>
            );
        } else {
            const hours = Math.floor(Seconds / 3600);
            const minutes = Math.floor((Seconds % 3600) / 60);
            const seconds = Seconds % 60;

            return (
                <p>
                    <span>{String(hours).padStart(2, "0")}</span>:
                    <span>{String(minutes).padStart(2, "0")}</span>
                </p>
            );
        }
    } else {
        return (
            <p>
                <span>{"00:00"}</span>
            </p>
        );
    }
};

export const CalculateWorkflowDurationSecInOtherFormat = ({ Seconds }) => {
    if (Seconds) {
        if (Seconds <= 60) {
            return <>00:{String(Seconds).padStart(2, "0")}</>;
        } else if (Seconds < 3600) {
            const minutes = Math.floor(Seconds / 60);
            const seconds = Seconds % 60;
            return (
                <>
                    {String(minutes).padStart(2, "0")}:{String(seconds).padStart(2, "0")}
                </>
            );
        } else {
            const hours = Math.floor(Seconds / 3600);
            const minutes = Math.floor((Seconds % 3600) / 60);
            const seconds = Seconds % 60;

            return (
                <>
                    {String(hours).padStart(2, "0")}:{String(minutes).padStart(2, "0")}
                </>
            );
        }
    } else {
        return <>{"00:00"}</>;
    }
};

const DataNewFlowPage = () => {
    const dropdownToggleRef = useRef(null);
    const nodeWidth = 300;
    const nodeHeight = 180;
    const LOOP_NODE_SHORT_NAMES = ["loopstart-0-0-0", "loopend-0-0-0"];

    const getNodeIdsToRemove = (nodeId, nodeList) => {
        const selectedNode = nodeList.find((node) => node.id === nodeId);

        if (!selectedNode) {
            return [nodeId];
        }

        if (!LOOP_NODE_SHORT_NAMES.includes(selectedNode.shortName)) {
            return [nodeId];
        }

        return nodeList
            .filter((node) => LOOP_NODE_SHORT_NAMES.includes(node.shortName))
            .map((node) => node.id);
    };

    function CalculateNodePositionAndWidthHeight(event, assemblyname) {
        let x = 0,
            y = 0;
        let w = nodeWidth,
            h = nodeHeight,
            s = 1;

        // Get node width and height if any node is selected
        const _node = document.querySelector(".react-flow__node.selectable");
        if (_node) {
            const rect = _node.getBoundingClientRect();
            w = rect.width;
            h = rect.height;

            if (
                assemblyname === "loopstart-0-0-0" ||
                assemblyname === "loopend-0-0-0"
            ) {
                h = h / 2;
            }
        }

        if (event) {
            // Get left panel width safely
            let leftPanelWidth =
                document.querySelector(".left-panel")?.clientWidth || 0;
            let topPanelHeight =
                document.querySelector(".flow-chart-container")?.clientHeight || 0;

            // Get viewport transformations
            let viewportPosition = { x: 0, y: 0, s: 1 };
            const reactFlowWrapper = document.getElementById(
                "canvas-workflow-wrapper-ReactFlow",
            );
            if (reactFlowWrapper) {
                const viewport = reactFlowWrapper.querySelector(
                    ".react-flow__viewport",
                );
                if (viewport) {
                    const style = window.getComputedStyle(viewport);
                    if (style.transform !== "none") {
                        const matrix = new DOMMatrixReadOnly(style.transform);
                        viewportPosition.x = matrix.m41;
                        viewportPosition.y = matrix.m42;
                        viewportPosition.s = matrix.m11; // Scale factor
                    }
                }
            }

            s = viewportPosition.s;
            // Adjust position with scaling correction
            x = (event.clientX - leftPanelWidth - viewportPosition.x) / s - w / 2;
            y = (event.clientY - topPanelHeight - viewportPosition.y) / s - h / 2;
        }

        return { x, y, w, h, s };
    }

    const steps = [
        {
            target: ".tourWorkflowMachines",
            title: "Machines",
            content:
                "Search or browse machines by category and drag them from here to build your workflow. Also, Explore marketplace to buy and add new machines if required.",
            disableBeacon: true,
            placement: "right",
            customProp: {
                classname: "position-right",
            },
            height: "79px",
            width: "43px",
            className: "",
        },
        {
            target: ".tourWorkflowName",
            title: "Workflow Name",
            content:
                "Give your workflow a unique name, then click 'Save' to keep your design.",
            placement: "bottom",
            customProp: {
                classname: "position-bottom",
            },
            className: "workflowname",
        },
        {
            target: ".tourWorkflowButtons",
            title: "Workflow Manage",
            content:
                "Add Workflow, Save Workflow, Publish Workflow, Delete Workflow, Save As Workflow, Suspend Workflow.",
            placement: "bottom",
            customProp: {
                classname: "position-bottom",
            },
            className: "workflowbtn",
        },

        {
            target: ".tourWorkflowCollaborators",
            title: "Collaborators",
            content:
                "Add members to collaborate on this workflow by assigning them role that fits them best. You can also update designations or remove members as needed to keep your team organized.",
            placement: "bottom",
            customProp: {
                classname: "position-bottom",
            },
            className: "workflowbtn2",
        },

        {
            target: ".tourWorkflowNotifications",
            title: "Notifications",
            content:
                "Stay updated with important alerts and reminders. Click here to view your notifications and keep track of recent activities.",
            placement: "bottom",
            customProp: {
                classname: "position-bottom",
            },
        },
        {
            target: ".tourWorkflowSchedular",
            title: "Scheduler",
            content:
                "Easily schedule workflows by setting the time and frequency to automate tasks.",
            placement: "bottom",
            customProp: {
                classname: "position-bottom",
            },
        },
        {
            target: ".tourWorkflowCostAndUsgae",
            title: "Cost & Usage",
            content:
                "Track your costs and usage in real-time to monitor your spending and optimize resources.",
            placement: "bottom",
            customProp: {
                classname: "position-bottom",
            },
        },
        {
            target: ".tourWorkflowLogs",
            title: "Logs",
            content:
                "View detailed logs of your workflows to track progress, identify issues, and ensure smooth operation.",
            placement: "left",
            customProp: {
                classname: "position-cross-right",
            },
        },
        {
            target: ".tourWorkflowSupport",
            title: "Support",
            content:
                "Utilize support section for workflow related query or complain.",
            placement: "left",
            customProp: {
                classname: "position-cross-right",
            },
        },
        {
            target: ".tourWorkflowConfig",
            title: "Config",
            content: "Set up your workflow by configuring its necessary settings.",
            placement: "left",
            customProp: {
                classname: "position-cross-right",
            },
        },
        {
            target: ".tourWorkflowMachineSetup",
            title: "Machine Setup",
            content:
                "Set up your machine by configuring its necessary settings. Like its parameters and also can upgrade machine default configuration",
            placement: "left",
            customProp: {
                classname: "position-left",
            },
            className: "panelmachinesetup",
        },
        {
            target: ".tourWorkflowStatus",
            title: "Status",
            content:
                "View workflow status indicators and the scheduled next run here. Use Run Now or Suspend buttons to control the workflow manually. Monitor CPU, memory and network usage to keep track of performance.",
            placement: "left",
            customProp: {
                classname: "position-left",
            },
            className: "panelstatus",
        },
        {
            target: ".tourWorkflowCostSummary",
            title: "Cost Summary",
            content:
                "Review the cost summary to understand expenses related to your workflow, helping you manage and optimize budget efficiently.",
            placement: "left",
            customProp: {
                classname: "position-left",
            },
            className: "panelsummary",
        },
        {
            target: ".tourWorkflowAI",
            title: "AI-Enhnaced Machine",
            content:
                "Explore AI-powered machine recommendations tailored to optimize your workflow and enhance performance.",
            placement: "top",
            customProp: {
                classname: "position-top",
            },
            className: "ai-enhnaced-machine",
        },
    ];

    const stepsActive = [
        {
            target: ".tourWorkflowMachines",
            title: "Machines",
            content:
                "Search or browse machines by category and drag them from here to build your workflow. Also, Explore marketplace to buy and add new machines if required.",
            disableBeacon: true,
            placement: "right",
            customProp: {
                classname: "position-right",
            },
            height: "79px",
            width: "43px",
            className: "",
        },
        {
            target: ".tourWorkflowName",
            title: "Workflow Name",
            content:
                "Give your workflow a unique name, then click 'Save' to keep your design.",
            placement: "bottom",
            customProp: {
                classname: "position-bottom",
            },
            className: "workflowname",
        },
        {
            target: ".tourWorkflowButtons",
            title: "Workflow Manage",
            content:
                "Add Workflow, Save Workflow, Publish Workflow, Delete Workflow, Save As Workflow, Suspend Workflow.",
            placement: "bottom",
            customProp: {
                classname: "position-bottom",
            },
            className: "workflowbtn",
        },
        {
            target: ".tourWorkflowButtonsStartWorkflow",
            title: "Workflow Run-Time Manage",
            content: "For Run, Suspend, Delete, Stop Workflow",
            placement: "bottom",
            customProp: {
                classname: "position-bottom",
            },
            className: "workflowbtn2",
        },
        {
            target: ".tourWorkflowCollaborators",
            title: "Collaborators",
            content:
                "Add members to collaborate on this workflow by assigning them role that fits them best. You can also update designations or remove members as needed to keep your team organized.",
            placement: "bottom",
            customProp: {
                classname: "position-bottom",
            },
        },

        {
            target: ".tourWorkflowNotifications",
            title: "Notifications",
            content:
                "Stay updated with important alerts and reminders. Click here to view your notifications and keep track of recent activities.",
            placement: "bottom",
            customProp: {
                classname: "position-bottom",
            },
        },
        {
            target: ".tourWorkflowSchedular",
            title: "Scheduler",
            content:
                "Easily schedule workflows by setting the time and frequency to automate tasks.",
            placement: "bottom",
            customProp: {
                classname: "position-bottom",
            },
        },
        {
            target: ".tourWorkflowCostAndUsgae",
            title: "Cost & Usage",
            content:
                "Track your costs and usage in real-time to monitor your spending and optimize resources.",
            placement: "bottom",
            customProp: {
                classname: "position-bottom",
            },
        },
        {
            target: ".tourWorkflowLogs",
            title: "Logs",
            content:
                "View detailed logs of your workflows to track progress, identify issues, and ensure smooth operation.",
            placement: "left",
            customProp: {
                classname: "position-cross-right",
            },
        },
        {
            target: ".tourWorkflowSupport",
            title: "Support",
            content:
                "Utilize support section for workflow related query or complain.",
            placement: "left",
            customProp: {
                classname: "position-cross-right",
            },
        },
        {
            target: ".tourWorkflowConfig",
            title: "Config",
            content: "Set up your workflow by configuring its necessary settings.",
            placement: "left",
            customProp: {
                classname: "position-cross-right",
            },
        },
        {
            target: ".tourWorkflowMachineSetup",
            title: "Machine Setup",
            content:
                "Set up your machine by configuring its necessary settings. Like its parameters and also can upgrade machine default configuration",
            placement: "left",
            customProp: {
                classname: "position-left",
            },
            className: "panelmachinesetup",
        },
        {
            target: ".tourWorkflowStatus",
            title: "Status",
            content:
                "View workflow status indicators and the scheduled next run here. Use Run Now or Suspend buttons to control the workflow manually. Monitor CPU, memory and network usage to keep track of performance.",
            placement: "left",
            customProp: {
                classname: "position-left",
            },
            className: "panelstatus",
        },
        {
            target: ".tourWorkflowCostSummary",
            title: "Cost Summary",
            content:
                "Review the cost summary to understand expenses related to your workflow, helping you manage and optimize budget efficiently.",
            placement: "left",
            customProp: {
                classname: "position-left",
            },
            className: "panelsummary",
        },
        {
            target: ".tourWorkflowAI",
            title: "AI-Enhnaced Machine",
            content:
                "Explore AI-powered machine recommendations tailored to optimize your workflow and enhance performance.",
            placement: "top",
            customProp: {
                classname: "position-top",
            },
            className: "ai-enhnaced-machine",
        },
    ];
    let EncID = useParams();

    const edgeTypes = {
        custom: ButtonEdge,
    };

    let Edgetype = "custom";
    let Defaultedgetype = "bezier";
    let Userdata = useSelector((state) => state.userinfo.UserInfo);
    const id = commonservices.bodyDecryption(EncID?.id)?.split("?")[0];
    let AIPromptData = useSelector(
        (state) => state?.workflowredux?.GetWorkflowPromptData?.data?.data?.data,
    );

    // setId(parseInt(decData?.));
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const target1 = useRef(null);
    const location = useLocation();
    const state = location.state;
    const isWorkflowViewDashboard =
        state?.isViewMode === true ||
        location.pathname.includes("/flow-new-view");

    const target2 = useRef(null);
    const overlayCont_Ref = useRef(null);
    const notification1 = useRef(null);
    const targetSchedular = useRef(null);
    const target = useRef(null);
    const divRef = useRef(null); // Ref for the div
    const targetConfig = useRef(null);
    const overlayCostusage_Ref = useRef(null);
    const overlayNoti_Ref = useRef(null);
    const overlayDesc_Ref = useRef(null);
    const GetWorkFlowIDData = useSelector(
        (state) => state?.workflowredux?.GetWorkFlowByIDData?.data,
    );

    const AIMachineList = useSelector(
        (state) => state?.aiapi?.SuggestMachinesData?.data,
    );
    const AIMachineListOnNodes = useSelector(
        (state) => state?.aiapi?.GetMachinesData?.data,
    );

    const [UsageTrendChartData, setUsageTrendChartData] = useState({
        labels: [],
        datasets: [],
    });
    const [UsageTrendChartLoader, setUsageTrendChartLoader] = useState(false);

    const [RecentRunsList, setRecentRunsList] = useState([]);
    const [RecentRunsLoader, setRecentRunsLoader] = useState(false);
    const [recentRunDetailShow, setRecentRunDetailShow] = useState(false);
    const [recentRunLogId, setRecentRunLogId] = useState(0);

    const [IdData, setIdData] = useState();
    const [activeBottomSidePanel, setActiveBottomSidePanel] = useState(false);
    const [reload, setReload] = useState();
    const [nodes, setNodes, onNodesChange] = useNodesState([]);
    const nodesRef = useRef(nodes);
    useEffect(() => {
        nodesRef.current = nodes;
    }, [nodes]);


    const [aiEnhanceState, setAiEnhanceState] = useState(false);
    const [machineDataLoading, setMachineDataLoading] = useState(false);
    const [CroneExpressionValue, setCroneExpressionValue] = useState("0 0 1 1 *");
    const [selectedNode, setSelectedNode] = useState(null);
    const [edges, setEdges, onEdgesChange] = useEdgesState([]);
    const [WorkFlowStatus, setWorkFlowStatus] = useState([]);

    const [ProjectTermList, setProjectTermList] = useState({
        CPU: [],
        RAM: [],
    });

    const [AIEnhanceLoader, setAIEnhanceLoader] = useState(false);

    const [getWorkflowPopup, setWorkflowPopup] = useState(false);

    const [showContact, setShowContact] = useState(false);

    const [contactList, setContactList] = useState([]);

    const [schedularData, setSchedularData] = useState(null);

    const FnForSetNodes = (data) => {
        setNodes(data);
    };

    const walkthroughDetail = commonservices.getWalkthroughDetail();

    const [NetworkUsageChart, setNetworkUsageChart] = useState({
        labels: [],
        datasets: [],
    });

    const [NewMachineInfo, setNewMachineInfo] = useState({
        name: "",
        ID: "",
        desc: "",
    });

    const [loadingState, setLoadingState] = useState(false);

    const [allMachineList, setAllMachineList] = useState(null);

    const [flowDetails, setFlowDetails] = useState("");
    console.log("flowDetails", flowDetails);

    const [variant, setVariant] = useState("dotted");

    const [supportShowModel, setSupportShowModel] = useState(false);

    const [FlowLoader, setFlowLoader] = useState(false);

    const [trackState, setTrackState] = useState(false);

    const [showNotification, setShowNotification] = useState(false);

    const [showSchedularPopup, setShowSchedularPopup] = useState(false);

    const [modalShow1, setModalShow1] = useState(false);

    const [trackStatePopup, setTrackStatePopup] = useState(false);

    const [activeBottomSidePanelPinned, setActiveBottomSidePanelPinned] =
        useState(false);

    const [workFlowDiscriptionPopupstate, setworkFlowDiscriptionPopupstate] =
        useState(false);

    const [MemoryUsageChart, setMemoryUsageChart] = useState({
        labels: [],
        datasets: [],
    });

    const [CPUUsageChart, setCPUUsageChart] = useState({
        labels: [],
        datasets: [],
    });

    const [descriptionName, setDescriptionName] = useState("");
    const [tag, settag] = useState("");

    const [IsWorkFlowIsRunning, setIsWorkFlowIsRunning] = useState(false);
    const [isDiagramFullScreen, setIsDiagramFullScreen] = useState(false);

    const isCurrentlyRunning = Boolean(
        IsWorkFlowIsRunning ||
        (flowDetails?.runningworkflows &&
            flowDetails.runningworkflows.indexOf("[") >= 0 &&
            (() => {
                try {
                    return JSON.parse(flowDetails.runningworkflows).length > 0;
                } catch (e) {
                    return false;
                }
            })()) ||
        flowDetails?.laststatus?.toLowerCase() === "start" ||
        flowDetails?.laststatus?.toLowerCase() === "running"
    );

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape" && isDiagramFullScreen) {
                setIsDiagramFullScreen(false);
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [isDiagramFullScreen]);

    useEffect(() => {
        const timer = setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
        }, 150);
        return () => clearTimeout(timer);
    }, [isDiagramFullScreen]);

    const [selOption, setSelOption] = useState({
        btnTitle: id === "0" ? "Draft" : "Save",
        backColor: id === "0" ? "#20C997" : "#9A9A9A",
        foreColor: id === "0" ? "#dcecf9" : "#dcecf9",
    });

    const searchParams = new URLSearchParams(IdData);

    const ViewParam = searchParams.get("v");

    const RedirectParam = searchParams.get("r");

    const [callApi, setCallApi] = useState(
        walkthroughDetail?.workflowEngineering
            ? walkthroughDetail?.workflowEngineering
            : false,
    );

    const [connection, setConnection] = useState(null);

    const [flowName, setFlowName] = useState("");

    const [parallelism, setParallelism] = useState(2);
    const [retrystrategy, setRetrystrategy] = useState(3);
    const [parametersforworkflow, setParametersForWorkflow] = useState([]);
    const [loop_sample_data, setLoop_sample_data] = useState([]);
    const [workspaceForWorkflow, setWorkspaceForWorkflow] = useState([]);
    const [workspaceInput, setWorkspaceInput] = useState([]);
    const [eksnodegroup, setEksnodegroup] = useState("");
    const [subscribersinfrastructureautomationid, setSubscribersinfrastructureautomationid] = useState("");

    const [isActiveWorkFlowBtn, setIsActiveWorkFlowBtn] = useState(
        id === "0" ? "Draft" : "Save",
    );

    const [ai_ActiveBox, setAI_ActiveBox] = useState(1);

    const [WorkFlowMachineStatus, setWorkFlowMachineStatus] = useState([]);

    const [editstatusfordes, setEditstatusfordes] = useState(false);

    const [show, setShow] = useState(false);

    const [showConfigPopup, setShowConfigPopup] = useState(false);

    const [machineList, setMachineList] = useState(null);

    const [showSaveAsCopyModel, setShowSaveAsCopyModel] = useState(false);

    const [modalShow, setModalShow] = useState(false);

    const [activeSidePanel, setActiveSidePanel] = useState(false);

    const [activeSidePanelPinned, setActiveSidePanelPinned] = useState(false);

    const [DeletePayload, setDeletePayload] = useState({
        workflowid: "",
        status: "",
    });

    const [WorkFlowMachineUse, setWorkFlowMachineUse] = useState([]);

    const [activeTab, setActiveTab] = useState(0);

    const [allMachineDetails, setAllMachineDetails] = useState();

    const [marketPlacePopup, setMarketPlacePopup] = useState(false);

    const [marketPlacePopupID, setMarketPlacePopupID] = useState(null);

    const [roleAccess, setRoleAccess] = useState([]);

    const [CronParseValues, setCronParseValues] = useState([]);

    const [searchInput, setSearchInput] = useState("");

    const [connectingNode, setConnectingNode] = useState(null);

    const [hoveredNode, setHoveredNode] = useState(null);

    const [activeRightSidePanel, setActiveRightSidePanel] = useState("sm-panel");

    const [activeRightSidePinnedPanel, setActiveRightSidePinnedPanel] =
        useState("sm-panel");

    const machineDrawerRef = useRef(null);
    useEffect(() => {
        const isPanelOpen =
            isWorkflowViewDashboard &&
            (activeRightSidePanel === "machine" ||
                activeRightSidePanel === "summary" ||
                activeRightSidePanel === "costSummary");

        const handleOutsideClick = (event) => {
            if (
                isPanelOpen &&
                machineDrawerRef.current &&
                !machineDrawerRef.current.contains(event.target)
            ) {
                if (event.target.closest && event.target.closest(".flowcard-detail")) {
                    return;
                }
                setActiveRightSidePanel("sm-panel");
            }
        };

        if (isPanelOpen) {
            document.addEventListener("mousedown", handleOutsideClick);
        }

        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [isWorkflowViewDashboard, activeRightSidePanel]);

    const FnForsetActiveRightSidePanel = (data) => {
        setTimeout(() => {
            setActiveRightSidePanel(data);
        }, 120);
    };

    const GetSecondCounts = (startTime, endTime) => {
        // If endTime is missing, use current time
        if (!endTime) {
            endTime = new Date();
        }

        // Parse a timestamp (string or Date object)
        const parseTimestamp = (timestamp) => {
            if (!timestamp) return null;

            // If it's a Date object
            if (timestamp instanceof Date) {
                return {
                    hours: timestamp.getHours(),
                    minutes: timestamp.getMinutes(),
                    seconds: timestamp.getSeconds(),
                };
            }

            // If it's a string e.g. "2025-11-17T12:34:56"
            if (typeof timestamp === "string" && timestamp.includes("T")) {
                const [datePart, timePart] = timestamp.split("T");
                if (!timePart) return null;

                const [hh = "0", mm = "0", ss = "0"] = timePart.split(":");

                return {
                    hours: parseInt(hh, 10) || 0,
                    minutes: parseInt(mm, 10) || 0,
                    seconds: parseInt(ss, 10) || 0,
                };
            }

            return null;
        };

        const start = parseTimestamp(startTime);
        const end = parseTimestamp(endTime);

        if (!start || !end) {
            return 0;
        }

        const startTotalSeconds =
            start.hours * 3600 + start.minutes * 60 + start.seconds;
        const endTotalSeconds = end.hours * 3600 + end.minutes * 60 + end.seconds;

        return endTotalSeconds - startTotalSeconds;
    };

    const AddApplyButton = ({ machineid }) => {
        let a = allMachineDetails?.find((item) => item?.machineid == machineid);

        const position = { x: 300, y: 200 };
        let mockType;
        if (a) {
            mockType = {
                machineid: a?.machineid,
                machinename: a?.machinename,
                machinelogo: a?.machinelogo,
                dockerimagename: a?.dockerimagename,
                assemblyname: a?.assemblyname,
                price: a?.price,
                versionnumber: a?.versionnumber,
                entrypointcommand: a?.entrypointcommand,
                cpu: a?.cpu,
                ram: a?.ram,
                osrequirmet: a?.osrequirmet,
                cloud: a?.cloud,
                PROXY_ENABLED: a?.PROXY_ENABLED || false,
                PROXY_ROTATE_PER_REQUEST: a?.PROXY_ROTATE_PER_REQUEST || true,
            };
        }

        return (
            <>
                {ViewParam === "0" && a ? (
                    <button
                        className="blue-btn mw-fit-content"
                        onClick={() => addNodeManually(mockType, position)}
                    >
                        Add
                    </button>
                ) : (
                    <button
                        className="blue-btn mw-fit-content"
                        onClick={() => {
                            let Data = commonservices.bodyEncryption(String(machineid));
                            setMarketPlacePopup(true);
                            setMarketPlacePopupID(Data);
                        }}
                    >
                        Apply
                    </button>
                )}
            </>
        );
    };

    async function getProjectTermList() {
        dispatch(ProjectTermGetList({}))?.then((response) => {
            if (response?.payload?.isValidate) {
                if (response?.payload?.data?.data?.length > 0) {
                    let cloudarray = [];
                    response?.payload?.data?.data.forEach((element) => {
                        if (element?.category === "Cloud") {
                            cloudarray.push({
                                value: element?.term,
                                label: element?.term,
                            });
                        }
                    });
                    setProjectTermList({
                        CPU: response?.payload?.data?.data.filter(
                            (f) => f.category === "CPU",
                        ),
                        RAM: response?.payload?.data?.data.filter(
                            (f) => f.category === "RAM",
                        ),
                    });
                }
            }
            if (!response?.payload?.isValidate) {
            }
        });
    }

    const GetPersentageCount = ({ lastweek, thisweek }) => {
        let Caluculation = commonservices?.CalculateUseInPersentage(
            parseInt(lastweek || 0),
            parseInt(thisweek || 0),
        );
        return (
            <div className="datamonthinner-span">
                {isNaN(Caluculation) ? (
                    <>
                        <span className="nan-error">{"--"}</span>
                    </>
                ) : (
                    <>
                        {Caluculation > 0 ? (
                            <>
                                {" "}
                                <span style={{ color: "#E00" }}>{Caluculation + "%"}</span>
                                <img src={dounlefticon} alt="dounlefticon" />
                            </>
                        ) : (
                            <>
                                {" "}
                                <span>{Math.abs(Caluculation) + "%"}</span>
                                <img src={toprightgreen} alt="toprightgreen" />
                            </>
                        )}
                    </>
                )}
            </div>
        );
    };

    const getTimeZoneObj = (timezone) => {
        let filterdData = TIMEZONE_LIST?.filter((x) => x?.value === timezone);

        return filterdData;
    };

    const CreateModel = (
        image,
        id,
        name,
        shortName,
        WorkFlowIsRunning,
        sameMachineNo,
        statusdata,
        extra,
        flowDetails,
    ) => {
        let isValidMachine = true;
        let WorkflowMachineDetailsImg = workflow_invalid;
        let M = allMachineDetails?.filter((m) =>
            shortName.includes(m.assemblyname),
        );

        if (M && M.length > 0) {
            image = M[0].machinelogo;
        } else {
            isValidMachine = false;
        }

        let WorkFlowIsRunningData = WorkFlowIsRunning;

        const ExtraData = statusdata?.filter(
            (item) =>
                item.workflowmachinename?.toUpperCase() === shortName?.toUpperCase(),
        );

        if (shortName === "loopstart-0-0-0" || shortName === "loopend-0-0-0") {
            return (
                <div className={`node-content main-machine-startercard`}>
                    <div className="machine-startercard">
                        {shortName === "loopstart-0-0-0" && (
                            <button title="Loop Start" className="loop-start-icon loop-btn">
                                <svg
                                    width="49"
                                    height="44"
                                    viewBox="0 0 49 44"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M5.10929 9.24383C15.8273 -5.42664 38.8968 -0.621485 43.1919 16.7105L45.7658 11.7779C45.9635 11.4038 46.3016 11.1236 46.7058 10.9988C47.1101 10.874 47.5473 10.9149 47.9214 11.1125C48.2955 11.3101 48.5757 11.6482 48.7005 12.0525C48.8253 12.4567 48.7844 12.894 48.5868 13.268L43.6302 22.6632C43.4645 22.9706 43.2025 23.2151 42.8843 23.3591C42.5661 23.5031 42.2094 23.5386 41.8691 23.4601C41.7334 23.4206 41.6004 23.3727 41.4707 23.3166L32.0357 18.376C31.6606 18.1731 31.3814 17.8295 31.2596 17.4208C31.1378 17.0121 31.1833 16.5717 31.3862 16.1966C31.5891 15.8214 31.9327 15.5423 32.3415 15.4205C32.7502 15.2987 33.1906 15.3442 33.5657 15.5471L40.4188 19.1649C38.0282 3.2832 17.3094 -1.98414 7.68319 11.1245C-1.17009 22.9341 7.61147 40.2821 22.3855 40.1546C26.2684 40.1622 30.0509 38.9219 33.1752 36.6165C33.3431 36.4849 33.5358 36.3883 33.7417 36.3325C33.9477 36.2767 34.1627 36.2629 34.3741 36.2917C34.5855 36.3206 34.7889 36.3916 34.9724 36.5006C35.1558 36.6096 35.3155 36.7543 35.442 36.9261C35.5685 37.0979 35.6591 37.2934 35.7087 37.5009C35.7582 37.7085 35.7655 37.9238 35.7302 38.1343C35.695 38.3447 35.6178 38.5459 35.5033 38.7259C35.3889 38.906 35.2394 39.0612 35.0638 39.1824C31.3952 41.8966 26.949 43.3554 22.3855 43.3421C5.0296 43.4935 -5.28993 23.1174 5.10929 9.24383Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            </button>
                        )}
                        {shortName === "loopend-0-0-0" && (
                            <button title="Loop End" className="loop-end-icon loop-btn">
                                <svg
                                    width="49"
                                    height="43"
                                    viewBox="0 0 49 43"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M44.3106 34.1785C33.5927 48.849 10.5231 44.0438 6.22798 26.7118L3.65408 31.6445C3.45647 32.0186 3.11835 32.2988 2.71411 32.4236C2.30987 32.5484 1.87261 32.5075 1.49853 32.3099C1.12445 32.1123 0.844192 31.7741 0.719407 31.3699C0.594622 30.9657 0.635533 30.5284 0.83314 30.1543L5.7897 20.7592C5.95539 20.4517 6.21747 20.2072 6.53565 20.0633C6.85383 19.9193 7.21049 19.8838 7.5508 19.9623C7.68648 20.0017 7.81955 20.0496 7.94923 20.1057L17.3842 25.0463C17.7594 25.2492 18.0385 25.5928 18.1603 26.0016C18.2821 26.4103 18.2366 26.8507 18.0337 27.2258C17.8308 27.6009 17.4872 27.8801 17.0785 28.0019C16.6697 28.1237 16.2294 28.0781 15.8542 27.8753L9.00111 24.2574C11.3917 40.1392 32.1105 45.4065 41.7367 32.2979C50.59 20.4882 41.8084 3.14025 27.0344 3.26775C23.1516 3.26016 19.3691 4.50051 16.2447 6.80588C16.0768 6.9375 15.8841 7.03407 15.6782 7.08986C15.4723 7.14564 15.2572 7.15951 15.0458 7.13063C14.8344 7.10176 14.631 7.03073 14.4475 6.92177C14.2641 6.8128 14.1044 6.66811 13.9779 6.49628C13.8515 6.32444 13.7608 6.12896 13.7113 5.92143C13.6617 5.71389 13.6544 5.49853 13.6897 5.2881C13.7249 5.07768 13.8021 4.87648 13.9166 4.69643C14.0311 4.51638 14.1805 4.36115 14.3561 4.23994C18.0247 1.52573 22.4709 0.0669731 27.0344 0.0802528C44.3903 -0.0711534 54.7099 20.3049 44.3106 34.1785Z"
                                        fill="currentColor"
                                    />
                                    <rect
                                        x="23.0137"
                                        y="13.7715"
                                        width="3.45568"
                                        height="15.4545"
                                        rx="1.72784"
                                        fill="currentColor"
                                    />
                                    <rect
                                        x="29.4883"
                                        y="13.7715"
                                        width="3.45568"
                                        height="15.4545"
                                        rx="1.72784"
                                        fill="currentColor"
                                    />
                                </svg>
                            </button>
                        )}

                        <button
                            title="Close"
                            className="close-button"
                            disabled={isWorkflowViewDashboard}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (
                                    shortName === "loopend-0-0-0" ||
                                    shortName === "loopstart-0-0-0"
                                ) {
                                    handleRemoveNode(id);
                                } else {
                                    handleRemoveNode(id);
                                }
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="7"
                                height="7"
                                viewBox="0 0 7 7"
                                fill="none"
                            >
                                <path
                                    d="M0.796898 1.04297L5.53253 5.77861M5.5325 1.04297L0.796875 5.77861"
                                    stroke="currentColor"
                                    stroke-width="1.57855"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            );
        } else if (shortName.toUpperCase().indexOf("QD#SYSTEM#SUBWORKFLOW-") >= 0) {
            if (M?.[0]?.versionnumber === "Active") {
                WorkflowMachineDetailsImg = workflow_active;
            } else if (M?.[0]?.versionnumber === "Suspend") {
                WorkflowMachineDetailsImg = workflow_suspend;
            }

            return (
                <div
                    className={`node-content subworkflow-container newflow-node-content ${M?.[0]?.versionnumber ? M?.[0]?.versionnumber : ""}`}
                >
                    <div
                        className={`subworkflow-title ${M?.[0]?.versionnumber ? M?.[0]?.versionnumber : ""}`}
                    >
                        <img
                            className="subworkflow-img"
                            src={image || DemoLogo}
                            alt={name}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = DemoLogo;
                            }}
                        />
                        {commonservices.truncateText(name, 30)}{" "}
                        {sameMachineNo !== 0 ? "-" + sameMachineNo : ""}
                        <button
                            title="Close"
                            disabled={isWorkflowViewDashboard}
                            className="close-button"
                            onClick={(e) => {
                                e.stopPropagation();
                                if (
                                    shortName === "loopend-0-0-0" ||
                                    shortName === "loopstart-0-0-0"
                                ) {
                                    handleRemoveNode(id);
                                } else {
                                    handleRemoveNode(id);
                                }
                            }}
                        >
                            <svg
                                fill="#111111"
                                width="20px"
                                height="20px"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z" />
                            </svg>
                        </button>
                    </div>
                    <div className={`subworkflow-details`}>
                        <img src={WorkflowMachineDetailsImg} alt="Workflow" />
                    </div>
                </div>
            );
        } else {
            return (
                <div className={`node-content newflow-node-content`}>
                    <div className={`flownew-detail-title`}>
                        <span className="mt-0">
                            <h4
                                title={name + (sameMachineNo !== 0 ? "-" + sameMachineNo : "")}
                            >
                                {" "}
                                {commonservices.truncateText(name, 30)}{" "}
                                {sameMachineNo !== 0 ? "-" + sameMachineNo : ""}
                            </h4>
                        </span>
                    </div>
                    <div className="flowcard-detail-block">
                        <div className="flowcard-versionplay">
                            <img
                                src={image || DemoLogo}
                                alt={name}
                                onError={(e) => {
                                    e.target.onerror = null; // Prevents infinite loop in case fallback also fails
                                    e.target.src = DemoLogo;
                                }}
                            />
                            <span className=" versionmachine mt-1">
                                {M?.[0]?.versionnumber ? M?.[0]?.versionnumber : ""}
                            </span>
                        </div>
                        <div className="flowcard-detail">
                            <span
                                className="cursor-pointer"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleMachineDetailsClick(id, name, shortName, sameMachineNo);
                                }}
                            >
                                Details
                            </span>
                            <img
                                className="cursor-pointer"
                                src={blackrightupicon}
                                alt="blackrightupicon"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleMachineDetailsClick(id, name, shortName, sameMachineNo);
                                }}
                            />
                            <img
                                className="cursor-pointer"
                                src={charticon}
                                alt="charticon"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleMachineSummaryClick(id, name, shortName, sameMachineNo);
                                }}
                            />
                        </div>
                    </div>
                    <div
                        className=" d-flex align-items-center gap-1"
                        style={{ width: "100%" }}
                    >
                        <div style={{ width: "100%" }}>
                            {ExtraData.length > 0 && parseInt(ExtraData[0]?.stepno) ? (
                                <ManageStatusBar
                                    step={parseInt(ExtraData[0]?.stepno)}
                                    status={ExtraData[0]?.status}
                                />
                            ) : (
                                <ManageStatusBarBlank />
                            )}
                        </div>
                        {WorkFlowIsRunningData && (
                            <div className="progress-second">
                                <span>
                                    {ExtraData[0]?.starton &&
                                        ExtraData[0]?.endon &&
                                        (ExtraData[0]?.status === "end" ||
                                            ExtraData[0]?.status === "fail") ? (
                                        <CalculateMachineDurationSecInOtherFormat
                                            Seconds={GetSecondCounts(ExtraData[0]?.starton, null)}
                                        />
                                    ) : (
                                        <>
                                            {ExtraData[0]?.starton && (
                                                <CounterPage start={ExtraData[0]?.starton} type="sub" />
                                            )}
                                        </>
                                    )}
                                </span>
                            </div>
                        )}
                    </div>

                    {WorkFlowIsRunningData ? (
                        <>
                            {ExtraData[0]?.status.toLowerCase() === "start" ? (
                                <div className="datashow-machine-main">
                                    <div className="Preprocessing-flow">
                                        <p>
                                            {ExtraData[0]?.starton &&
                                                commonservices.convertTimeToLocal(
                                                    WorkFlowStatus[0]?.starton,
                                                )}{" "}
                                            {ExtraData[0]?.logdata
                                                ?.substring(
                                                    ExtraData[0]?.logdata?.lastIndexOf("\n") + 1,
                                                    ExtraData[0]?.logdata?.length,
                                                )
                                                .trim()}
                                        </p>
                                        <img
                                            className="cursor-pointer"
                                            src={actionLog}
                                            alt="actionLog"
                                            onClick={() => setModalShow1(true)}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className="datashow-machine-main">
                                    {ExtraData[0]?.noofrun ? (
                                        <div className="success-ratio-block">
                                            <h4>Success Ratio</h4>
                                            <p>
                                                {parseInt(ExtraData[0]?.noofsuccess)}/
                                                {parseInt(ExtraData[0]?.noofrun)}{" "}
                                                <span className="seccess-doticon"></span>{" "}
                                                <span>
                                                    {(
                                                        (parseInt(ExtraData[0]?.noofsuccess) * 100) /
                                                        parseInt(ExtraData[0]?.noofrun)
                                                    ).toFixed(2)}
                                                    %
                                                </span>
                                            </p>
                                        </div>
                                    ) : (
                                        <div className="success-ratio-block"></div>
                                    )}

                                    <div>
                                        {!ExtraData[0]?.status ? (
                                            <button className="yellow-badge mt-2">To Do</button>
                                        ) : (
                                            <></>
                                        )}
                                        {ExtraData[0]?.status.toLowerCase() === "failed" ? (
                                            <button className="red-badge mt-2">Fail</button>
                                        ) : (
                                            <></>
                                        )}
                                        {ExtraData[0]?.status.toLowerCase() === "end" ? (
                                            <button className="green-badge-flow mt-2">Success</button>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="datashow-machine-main">
                            <div className="datamonthly">
                                <p className="title">This week</p>

                                <CalculateMachineDurationSec
                                    Seconds={parseInt(ExtraData[0]?.thisweek)}
                                />

                                <GetPersentageCount
                                    lastweek={parseInt(ExtraData[0]?.lastweek || 0)}
                                    thisweek={parseInt(ExtraData[0]?.thisweek || 0)}
                                />
                            </div>
                            <div className="datamonthly">
                                <p className="title">This Month</p>

                                <CalculateMachineDurationSec
                                    Seconds={parseInt(ExtraData[0]?.thismonth)}
                                />

                                <GetPersentageCount
                                    lastweek={parseInt(ExtraData[0]?.lastmonth || 0)}
                                    thisweek={parseInt(ExtraData[0]?.thismonth || 0)}
                                />
                            </div>
                            <div className="datamonthly">
                                <p className="title">This year</p>

                                <CalculateMachineDurationSec
                                    Seconds={parseInt(ExtraData[0]?.thisyear)}
                                />

                                <GetPersentageCount
                                    lastweek={parseInt(ExtraData[0]?.lastyear || 0)}
                                    thisweek={parseInt(ExtraData[0]?.thisyear || 0)}
                                />
                            </div>
                        </div>
                    )}
                    {shortName === "Starter" ? (
                        <></>
                    ) : (
                        <button
                            title="Close"
                            disabled={isWorkflowViewDashboard}
                            className="close-button"
                            onClick={(e) => {
                                e.stopPropagation();
                                if (
                                    shortName === "loopend-0-0-0" ||
                                    shortName === "loopstart-0-0-0"
                                ) {
                                    handleRemoveNode(id);
                                } else {
                                    handleRemoveNode(id);
                                }
                            }}
                        >
                            <svg
                                fill="#111111"
                                width="20px"
                                height="20px"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z" />
                            </svg>
                        </button>
                    )}
                </div>
            );
        }
    };

    const handleWalkthroughCallback = () => {
        setCallApi(true);
    };

    useEffect(() => {
        if (ViewParam == 1) {
            handleWalkthroughCallback();
        }
    }, [ViewParam]);

    useEffect(() => {
        if (!nodes) return;

        let updatedNodes = nodes.map((node) =>
            node.typeName === "Starter" && node.ram === "" && node.cpu === ""
                ? { ...node, ram: "256Mi", cpu: "500m" }
                : node,
        );

        if (JSON.stringify(updatedNodes) !== JSON.stringify(nodes)) {
            setNodes(updatedNodes);
        }
    }, [nodes]);

    const handleWorkFlowCopy = async (newflowName) => {
        if (edges?.length > 0 && nodes?.length > 0 && flowName !== "") {
            setFlowLoader(true);

            const currentDate = new Date();
            const futureFiveYearsPlusDate = new Date(
                currentDate.setFullYear(currentDate.getFullYear() + 5),
            );

            let payload = {
                oldworkflowid: id,
                newworkflowname: newflowName ? newflowName?.trim() : newflowName, // flowName,
                "WorkFlowSchedule.timezone": schedularData?.[
                    "WorkFlowSchedule.timezone"
                ]
                    ? schedularData?.["WorkFlowSchedule.timezone"]
                    : Userdata.timezone,
                "WorkFlowSchedule.startondatetime": schedularData?.[
                    "WorkFlowSchedule.startondatetime"
                ]
                    ? schedularData?.["WorkFlowSchedule.startondatetime"]
                    : commonservices.getDateInDBFormat(new Date()),
                "WorkFlowSchedule.endondatetime": schedularData?.[
                    "WorkFlowSchedule.endondatetime"
                ]
                    ? schedularData?.["WorkFlowSchedule.endondatetime"]
                    : commonservices.getDateInDBFormat(futureFiveYearsPlusDate),
                "WorkFlowSchedule.scheduledays": schedularData?.[
                    "WorkFlowSchedule.scheduledays"
                ]
                    ? schedularData?.["WorkFlowSchedule.scheduledays"]
                    : "",
                "WorkFlowSchedule.schedulemonth": schedularData?.[
                    "WorkFlowSchedule.schedulemonth"
                ]
                    ? schedularData?.["WorkFlowSchedule.schedulemonth"]
                    : "",
                "WorkFlowSchedule.hour": schedularData?.["WorkFlowSchedule.hour"]
                    ? schedularData?.["WorkFlowSchedule.hour"]
                    : "",
                "WorkFlowSchedule.minute": schedularData?.["WorkFlowSchedule.minute"]
                    ? schedularData?.["WorkFlowSchedule.minute"]
                    : "",
                "WorkFlowSchedule.weekdays": schedularData?.[
                    "WorkFlowSchedule.weekdays"
                ]
                    ? schedularData?.["WorkFlowSchedule.weekdays"]
                    : "",
                "WorkFlowSchedule.cronexpression": schedularData?.[
                    "WorkFlowSchedule.cronexpression"
                ]
                    ? schedularData?.["WorkFlowSchedule.cronexpression"]
                    : "0 0 1 1 *",
            };

            dispatch(WorkFlowCopy(payload)).then((response) => {
                if (response?.payload?.isValidate) {
                    setFlowLoader(false);
                    let data = commonservices.bodyEncryption(
                        `${response?.payload?.data?.data?.workflowid}?v=0&r=dc`,
                    );
                    window.open(`/flow-new/${data}`, "_blank");
                }
                if (!response?.payload?.isValidate) {
                    setFlowLoader(false);
                }
            });
        } else {
            setFlowLoader(false);
            toast.error("Please provide proper data for save");
        }
    };

    const handleEdgeMouseEnter = (event, edge) => {
        setConnectingNode(edge.source);
    };

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
    };

    const handleEdgeMouseLeave = () => {
        setConnectingNode(null);
    };

    const onDragOver = useCallback((event) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = "move";
        setTrackState(true);
    }, []);

    const onConnectStart = (event, { nodeId }) => {
        setConnectingNode(nodeId);
    };

    const handleNodeMouseLeave = () => {
        setHoveredNode(null);
    };

    const fnRunworkflow = async (
        state,
        key,
        id,
        workflowulogid,
        currentdataworkflowulogid,
    ) => {
        FunForsetActiveSidePanelPinned(false);
        FunForsetActiveSidePanel(false);
        if (key) {
            let body = {
                workflowid: id,
                status: state,
                workflowulogid: workflowulogid,
            };

            if (state === "run") {
                if (
                    flowDetails &&
                    flowDetails.runningworkflows &&
                    flowDetails.runningworkflows.indexOf("[")
                ) {
                    if (JSON.parse(flowDetails.runningworkflows).length > 0) {
                    } else {
                        currentdataworkflowulogid = "";
                    }
                } else {
                    currentdataworkflowulogid = "";
                }

                setIsWorkFlowIsRunning(true);
                setLoadingState(true);
                dispatch(UpdateWorkFlowStatus(body)).then((res) => {
                    if (res?.payload?.isValidate) {
                        BindDataByID(id, "");
                        setLoadingState(false);
                    } else {
                        setIsWorkFlowIsRunning(false);
                        setLoadingState(false);
                    }
                });
            } else {
                dispatch(UpdateWorkFlowRunningStatus(body)).then((res) => {
                    if (res?.payload?.isValidate) {
                        BindDataByID(id, currentdataworkflowulogid);
                    }
                });
            }
        } else {
            toast.error("Workflow Key Is Missing!!");
        }
    };

    const onConnectEnd = (event) => {
        if (connectingNode && hoveredNode && connectingNode !== hoveredNode.id) {
            let connectingNodeData = nodes.find((n) => n.id === connectingNode);
            if (connectingNodeData) {
                if (
                    connectingNodeData.shortName
                        .toUpperCase()
                        .indexOf("QD#SYSTEM#SUBWORKFLOW-") < 0
                ) {
                    const newEdge = {
                        id: `${GenerateGUID()}`,
                        source_machineid: `${connectingNodeData.typeid}`,
                        source_machinename: `${connectingNodeData.typeName}`,
                        source_image: `${connectingNodeData.dockerimagename}`,
                        source_shortname: `${connectingNodeData.shortName}`,
                        source: connectingNode,
                        target: hoveredNode.id,
                        target_machineid: `${hoveredNode.typeid}`,
                        target_machinename: `${hoveredNode.typeName}`,
                        target_image: `${hoveredNode.dockerimagename}`,
                        target_shortname: `${hoveredNode.shortName}`,
                        type:
                            hoveredNode.shortName !== "loopend-0-0-0" &&
                                hoveredNode.shortName !== "loopstart-0-0-0"
                                ? Edgetype
                                : Defaultedgetype,
                    };

                    // Check if edge already exists
                    const edgeExists = edges.some(
                        (edge) =>
                            edge.source === newEdge.source && edge.target === newEdge.target,
                    );

                    if (!edgeExists) {
                        setEdges((prevEdges) => [...prevEdges, newEdge]);
                    }
                }
            }
        }
        setConnectingNode(null);
        setHoveredNode(null);
    };

    const handleNodeMouseEnter = (event, node) => {
        setHoveredNode(node);
    };

    function fnGetMachineLog(shortName, WFMData, WFMUData, IsWFIsRunning) {
        setMemoryUsageChart({
            labels: [],
            datasets: [],
        });
        setCPUUsageChart({
            labels: [],
            datasets: [],
        });
        setNetworkUsageChart({
            labels: [],
            datasets: [],
        });

        if (!isWorkflowViewDashboard) {
            if (WFMData && WFMData?.length !== 0) {
                if (IsWFIsRunning) {
                    setTimeout(() => {
                        setActiveRightSidePinnedPanel("summary");
                        setActiveRightSidePanel("summary");
                    }, 100);
                } else {
                    setTimeout(() => {
                        setActiveRightSidePanel("machine");
                    }, 100);
                }
            }
        }

        if (WFMUData && WFMUData?.length !== 0) {
            let data = WFMUData?.filter(
                (i) =>
                    i?.workflowmachinename?.toUpperCase() === shortName?.toUpperCase(),
            );
            let memorylable = [];
            let memorydata = [];
            let cpulable = [];
            let cpudata = [];
            let networklable = [];
            let networkdata = [];
            if (data?.length > 0) {
                data?.forEach((element, index) => {
                    if (element["memory_usage_per"]) {
                        if (index === 0) {
                            memorylable.push(
                                moment.utc(element?.createdon).format("HH:mm:ss"),
                            );
                            memorydata.push(0);
                        }
                        memorylable.push(moment.utc(element?.createdon).format("HH:mm:ss"));
                        memorydata.push(
                            element?.memory_usage_per !== "" ? element?.memory_usage_per : 0,
                        );
                    }
                    if (element["cpu_usage"]) {
                        if (index === 0) {
                            cpulable.push(moment.utc(element?.createdon).format("HH:mm:ss"));
                            cpudata.push(0);
                        }
                        cpulable.push(moment.utc(element?.createdon).format("HH:mm:ss"));
                        cpudata.push(
                            element["cpu_usage"] !== "" ? element["cpu_usage"] : 0,
                        );
                    }
                    if (
                        element["network_bytes_received_mb"] &&
                        element["network_bytes_sent_mb"]
                    ) {
                        let tempresult =
                            element["network_bytes_received_mb"] +
                            element["network_bytes_sent_mb"];
                        if (index === 0) {
                            networklable.push(
                                moment.utc(element?.createdon).format("HH:mm:ss"),
                            );
                            networkdata.push(0);
                        }

                        networklable.push(
                            moment.utc(element?.createdon).format("HH:mm:ss"),
                        );
                        networkdata.push(tempresult);
                    }
                });
            }

            setMemoryUsageChart({
                labels: memorylable,
                datasets: [
                    {
                        label: "Memory Usage",
                        data: memorydata,
                        borderColor: "#bc6cd4",
                        backgroundColor: "#bc6cd420",
                        borderWidth: 1.5,
                        fill: true,
                        tension: 0,
                    },
                ],
            });
            setCPUUsageChart({
                labels: cpulable,
                datasets: [
                    {
                        label: "CPU Usage",
                        data: cpudata,
                        borderColor: "#62b4e3",
                        backgroundColor: "#62b4e320",
                        borderWidth: 1,
                        fill: true,
                        tension: 0,
                    },
                ],
            });
            setNetworkUsageChart({
                labels: networklable,
                datasets: [
                    {
                        label: "Network Usage",
                        data: networkdata,
                        borderColor: "#d48e55",
                        backgroundColor: "#d48e5520",
                        borderWidth: 1,
                        fill: true,
                        tension: 0,
                    },
                ],
            });
        }
    }

    function BindWorkFlowAsMachine(dataFromApi) {
        if (dataFromApi.dataList5) {
            let newDataList1 = dataFromApi.dataList1 || [];
            // let newDataList1 = [
            //     ...(dataFromApi.dataList1 || []),
            //     ...dataFromApi.dataList5.map(workflow => ({
            //         machineid: workflow.workflowid,
            //         machinename: workflow.workflowname,
            //         assemblyname: "QD#SYSTEM#SUBWORKFLOW-" + workflow.workflowid,
            //         isactive: true,
            //         createdon: null,
            //         createdby: 0,
            //         updatedon: null,
            //         updatedby: 0,
            //         machinelogo: workflowsvg,
            //         documentpath: null,
            //         status: workflow.argoworkflowstatus,
            //         refmachineid: 0,
            //         versionnumber: workflow.argoworkflowstatus,
            //         dockerimagename: "SUBWORKFLOW",
            //         dockerimagepath: "SUBWORKFLOW",
            //         price: 0,
            //         subscriberid: workflow.subscriberid,
            //         lastupdatedon: null,
            //         lastversion: workflow.argoworkflowstatus,
            //         publishon: null,
            //         categoryid: 99999999,
            //         subcategoryid: 0,
            //         industryid: 0,
            //         reviewreason: null,
            //         reviewby: 0,
            //         reviewon: null,
            //         inputsamplefile: "",
            //         outputsamplefile: "",
            //         isprivate: false,
            //         isdeprecated: null,
            //         isdiscontinued: null,
            //         discontinueddate: null,
            //         deprecateddate: null,
            //         deprecatedreason: null,
            //         discontinuereason: null,
            //         isdefault: false,
            //         entrypointcommand: "",
            //         categoryname: "My Workflow",
            //         subscribername: "",
            //         shortdescription: "",
            //         cpu: "500m",
            //         ram: "256Mi",
            //         osrequirmet: "Linux",
            //         cloud: "AWS",
            //         isdisplayversionnumber: 1,
            //         isdisplayinmenu: workflow.isdisplayinmenu
            //     }))
            // ];

            let newDataList3 = dataFromApi.dataList3 || [];
            // let newDataList3 = [
            //     ...(dataFromApi.dataList3 || []),
            //     ...dataFromApi.dataList5.map(workflow => ({
            //         "machinedetailid": workflow.workflowid,
            //         "machineid": workflow.workflowid,
            //         "title": workflow.workflowname,
            //         "shortdescription": null,
            //         "detaildescription": null,
            //         "subcategoryid": 0,
            //         "dependentmachineids": null,
            //         "compatiblemachineids": null,
            //         "inputdescription": null,
            //         "outputdescription": null,
            //         "osrequirmet": "Linux",
            //         "storage": "500m",
            //         "cpu": "500m",
            //         "cloud": "AWS",
            //         "ram": "256Mi",
            //         "refmachineid": null,
            //         "totalreview": null,
            //         "totalrating": null,
            //         "averagerating": null,
            //         "5star": null,
            //         "4star": null,
            //         "3star": null,
            //         "2star": null,
            //         "1star": null,
            //         "totlworkflows": null,
            //         "activeworkflows": null,
            //         "successrate": null,
            //         "failrate": null,
            //         "lastusedinworkflowon": null,
            //         "subscriberid": null,
            //         "categoryid": null,
            //         "industryid": null
            //     }))
            // ];

            let newDataList4 = dataFromApi.dataList4 || [];
            // let newDataList4 = [
            //     ...(dataFromApi.dataList4 || []),
            //     ...[{
            //         "categoryid": 99999999,
            //         "categoryname": "My Workflow"
            //     }]
            // ];

            if (id) {
                newDataList1 = newDataList1.filter(
                    (item) => item.machineid !== parseInt(id) * 10000,
                );
                newDataList3 = newDataList3.filter(
                    (item) => item.machineid !== parseInt(id) * 10000,
                );
            }

            dataFromApi = {
                ...dataFromApi,
                dataList1: newDataList1,
                dataList3: newDataList3,
                dataList4: newDataList4,
            };
        }

        return dataFromApi;
    }

    const getMachineListBySubscriberId = async () => {
        setMachineDataLoading(true);
        dispatch(MyMachineGetList())?.then((response) => {
            setMachineDataLoading(false);
            if (response?.payload?.isValidate) {
                let groupingJson = {};
                let dataFromApi = response?.payload?.data?.data;
                dataFromApi = BindWorkFlowAsMachine(dataFromApi);

                setAllMachineDetails(dataFromApi?.dataList1);
                dataFromApi?.dataList4?.forEach((categoryItem) => {
                    let findMachineList = dataFromApi?.dataList1?.filter((x) => {
                        return (
                            x?.categoryid === categoryItem?.categoryid &&
                            x?.assemblyname !== "Starter" &&
                            x?.isdisplayinmenu === true
                        );
                    });

                    groupingJson = {
                        ...groupingJson,
                        [categoryItem?.categoryname]: findMachineList,
                    };
                });

                let StarterMachine = dataFromApi?.dataList1?.find(
                    (f) => f.machinename === "Starter",
                );

                if (StarterMachine && id?.toString() === "0") {
                    const position = {
                        x: 0,
                        y: 0,
                    };

                    const reactFlowWrapper = document.getElementById(
                        "canvas-workflow-wrapper-ReactFlow",
                    );
                    if (reactFlowWrapper) {
                        position.x = reactFlowWrapper.clientWidth / 2 - nodeWidth;
                    }

                    const id = GenerateGUID();
                    const typeid = StarterMachine?.machineid;
                    const typeName = StarterMachine?.machinename;
                    const image = StarterMachine?.machinelogo;
                    const dockerimagename = StarterMachine?.dockerimagename;
                    let shortName = StarterMachine?.assemblyname;
                    const template = StarterMachine?.assemblyname;
                    let sameMachineNo = 0;

                    let NoOfMachineExist = nodes.filter(
                        (x) => x.dockerimagename === dockerimagename,
                    );
                    if (NoOfMachineExist !== null && NoOfMachineExist.length !== 0) {
                        NoOfMachineExist.sort((a, b) =>
                            a.sameMachineNo > b.sameMachineNo
                                ? 1
                                : b.sameMachineNo > a.sameMachineNo
                                    ? -1
                                    : 0,
                        );

                        sameMachineNo =
                            NoOfMachineExist[NoOfMachineExist.length - 1].sameMachineNo + 1;
                        shortName = shortName + sameMachineNo;
                    }
                    const entrypointcommand = StarterMachine?.entrypointcommand;
                    const cpu = StarterMachine?.cpu || "500m";
                    const ram = StarterMachine?.ram || "256Mi";
                    const osrequirmet = StarterMachine?.osrequirmet;
                    const cloud = StarterMachine?.cloud;
                    const configList = allMachineList?.dataList2?.filter(
                        (x) => x?.machineid == StarterMachine?.machineid,
                    );
                    const infoDetail = allMachineList?.dataList3?.filter(
                        (x) => x?.machineid == StarterMachine?.machineid,
                    );
                    const PROXY_ENABLED = StarterMachine?.PROXY_ENABLED || false;
                    const PROXY_ROTATE_PER_REQUEST =
                        StarterMachine?.PROXY_ROTATE_PER_REQUEST || true;

                    const newNode = {
                        id,
                        typeid,
                        typeName,
                        position,
                        image,
                        dockerimagename,
                        shortName,
                        machine_version: StarterMachine?.versionnumber,
                        template: template,
                        sameMachineNo: sameMachineNo,
                        className: fnGetMachineStatus(
                            shortName,
                            WorkFlowMachineStatus,
                            WorkFlowStatus,
                        ),
                        data: {
                            label: CreateModel(
                                StarterMachine.machinelogo,
                                id,
                                StarterMachine.machinename,
                                shortName,
                                IsWorkFlowIsRunning,
                                sameMachineNo,
                                WorkFlowMachineStatus,
                                WorkFlowStatus,
                                flowDetails,
                            ),
                        },
                        configData: configList,
                        infoData: infoDetail,
                        entrypointcommand,
                        cpu,
                        ram,
                        osrequirmet,
                        cloud,
                        PROXY_ENABLED,
                        PROXY_ROTATE_PER_REQUEST,
                    };

                    setNodes((nds) => [...nds, newNode]);
                }

                setMachineList(groupingJson);

                setAllMachineList(dataFromApi);
            }
            if (!response?.payload?.isValidate) {
                setMachineList(null);
                setMachineDataLoading(false);
                setAllMachineList(null);
            }
        });
    };

    const getMachineListBySubscriberIdAgain = async () => {
        setMachineDataLoading(true);
        dispatch(MyMachineGetList())?.then((response) => {
            setMachineDataLoading(false);
            if (response?.payload?.isValidate) {
                let groupingJson = {};
                let dataFromApi = response?.payload?.data?.data;
                dataFromApi = BindWorkFlowAsMachine(dataFromApi);

                setAllMachineDetails(dataFromApi?.dataList1);
                dataFromApi?.dataList4?.forEach((categoryItem) => {
                    let findMachineList = dataFromApi?.dataList1?.filter((x) => {
                        return (
                            x?.categoryid === categoryItem?.categoryid &&
                            x?.assemblyname !== "Starter" &&
                            x?.isdisplayinmenu === true
                        );
                    });

                    groupingJson = {
                        ...groupingJson,
                        [categoryItem?.categoryname]: findMachineList,
                    };
                });

                let StarterMachine = dataFromApi?.dataList1?.find(
                    (f) => f.machinename === "Starter",
                );

                if (StarterMachine && id?.toString() === "0") {
                    const position = {
                        x: 0,
                        y: 0,
                    };

                    const reactFlowWrapper = document.getElementById(
                        "canvas-workflow-wrapper-ReactFlow",
                    );
                    if (reactFlowWrapper) {
                        position.x = reactFlowWrapper.clientWidth / 2 - nodeWidth;
                    }
                }
                setMachineList(groupingJson);
            }
            if (!response?.payload?.isValidate) {
                setMachineList(null);
                setMachineDataLoading(false);
                setAllMachineList(null);
            }
        });
    };

    const GetMachineDescription = (id) => {
        let a = allMachineList?.dataList1?.filter((m) => m.machineid === id)[0]
            ?.shortdescription;
        return a;
    };

    const handleNodeClick = (
        event,
        _node,
        _IsWorkFlowIsRunning,
        _WorkFlowMachineStatus,
        _WorkFlowMachineUse,
    ) => {
        if (_node.shortName.toUpperCase().indexOf("QD#SYSTEM#SUBWORKFLOW-") < 0) {
            setNewMachineInfo({
                name: commonservices.makeMachineDisplayName(
                    _node?.typeName,
                    _node?.sameMachineNo,
                    _node?.assemblyname,
                    "",
                ),
                ID: _node?.typeid,
                desc: GetMachineDescription(_node?.typeid),
            });
            setSelectedNode(_node);
            if (_IsWorkFlowIsRunning) {
                setTimeout(() => {
                    setActiveRightSidePinnedPanel("summary");
                }, 100);
            } else {
                setTimeout(() => {
                    setActiveRightSidePanel("machine");
                }, 100);
            }
            handleTabClick(0);
            if (_node?.shortName) {
                fnGetMachineLog(
                    _node?.shortName,
                    _WorkFlowMachineStatus,
                    _WorkFlowMachineUse,
                    _IsWorkFlowIsRunning,
                );
            }
        }
    };

    const handleMachineDetailsClick = (
        nodeId,
        fallbackName,
        fallbackShortName,
        fallbackSameMachineNo,
    ) => {
        const currentNodes = nodesRef.current?.length ? nodesRef.current : nodes;
        let targetNode = currentNodes?.find((item) => String(item.id) === String(nodeId));

        if (!targetNode && fallbackShortName) {
            targetNode = currentNodes?.find((item) => item.shortName === fallbackShortName);
        }

        if (targetNode) {
            setNewMachineInfo({
                name: commonservices.makeMachineDisplayName(
                    targetNode?.typeName || fallbackName,
                    targetNode?.sameMachineNo || fallbackSameMachineNo,
                    targetNode?.assemblyname || fallbackShortName,
                    "",
                ),
                ID: targetNode?.typeid,
                desc: GetMachineDescription(targetNode?.typeid),
            });
            setSelectedNode(targetNode);
        } else {
            setNewMachineInfo({
                name: commonservices.makeMachineDisplayName(
                    fallbackName,
                    fallbackSameMachineNo,
                    fallbackShortName,
                    "",
                ),
                ID: "",
                desc: "",
            });
            setSelectedNode({
                id: nodeId,
                typeName: fallbackName,
                shortName: fallbackShortName,
                sameMachineNo: fallbackSameMachineNo,
                configData: [],
            });
        }

        setActiveRightSidePanel("machine");
        handleTabClick(0);

        if (targetNode?.shortName || fallbackShortName) {
            fnGetMachineLog(
                targetNode?.shortName || fallbackShortName,
                WorkFlowMachineStatus,
                WorkFlowMachineUse,
                IsWorkFlowIsRunning,
            );
        }
    };

    const handleMachineSummaryClick = (
        nodeId,
        fallbackName,
        fallbackShortName,
        fallbackSameMachineNo,
    ) => {
        const currentNodes = nodesRef.current?.length ? nodesRef.current : nodes;
        let targetNode = currentNodes?.find((item) => String(item.id) === String(nodeId));

        if (!targetNode && fallbackShortName) {
            targetNode = currentNodes?.find((item) => item.shortName === fallbackShortName);
        }

        if (targetNode) {
            setNewMachineInfo({
                name: commonservices.makeMachineDisplayName(
                    targetNode?.typeName || fallbackName,
                    targetNode?.sameMachineNo || fallbackSameMachineNo,
                    targetNode?.assemblyname || fallbackShortName,
                    "",
                ),
                ID: targetNode?.typeid,
                desc: GetMachineDescription(targetNode?.typeid),
            });
            setSelectedNode(targetNode);
        } else {
            setNewMachineInfo({
                name: commonservices.makeMachineDisplayName(
                    fallbackName,
                    fallbackSameMachineNo,
                    fallbackShortName,
                    "",
                ),
                ID: "",
                desc: "",
            });
            setSelectedNode({
                id: nodeId,
                typeName: fallbackName,
                shortName: fallbackShortName,
                sameMachineNo: fallbackSameMachineNo,
                configData: [],
            });
        }

        setActiveRightSidePanel("summary");

        if (targetNode?.shortName || fallbackShortName) {
            fnGetMachineLog(
                targetNode?.shortName || fallbackShortName,
                WorkFlowMachineStatus,
                WorkFlowMachineUse,
                IsWorkFlowIsRunning,
            );
        }
    };

    const handleEdgeClick = (event, Edge) => {
        if (event) {
            if (event.target.getAttribute("alt") === "Data Profiles") {
                //FnOpenDataProfileMappingPopup(_node.id);
                FnOpenDataProfileMappingPopup(Edge.target);
            }
        }
        //
        //Edge   ---->>>> //target //source //source_machinename //target_machinename
        //Machine ---->> //dataList1	//machinelogo //inputsamplefile	//outputsamplefile
    };

    const FnForsetActiveRightSidePinnedPanel = (data) => {
        setActiveRightSidePinnedPanel(data);
    };

    const handleRemoveNode = (id) => {
        setNodes((nodes) => {
            const nodeIdsToRemove = new Set(getNodeIdsToRemove(id, nodes));
            const updatedNodes = nodes.filter(
                (node) => !nodeIdsToRemove.has(node.id),
            );

            setEdges((edges) =>
                edges.filter(
                    (edge) =>
                        !nodeIdsToRemove.has(edge.source) &&
                        !nodeIdsToRemove.has(edge.target),
                ),
            );

            return updatedNodes;
        });
    };

    const handleWorkflowNodesChange = useCallback(
        (changes) => {
            const removedNodeIds = changes
                .filter((change) => change.type === "remove")
                .map((change) => change.id);

            if (!removedNodeIds.length) {
                onNodesChange(changes);
                return;
            }

            const nodeIdsToRemove = new Set(
                removedNodeIds.flatMap((nodeId) => getNodeIdsToRemove(nodeId, nodes)),
            );

            const additionalRemoveChanges = Array.from(nodeIdsToRemove)
                .filter((nodeId) => !removedNodeIds.includes(nodeId))
                .map((nodeId) => ({ id: nodeId, type: "remove" }));

            onNodesChange([...changes, ...additionalRemoveChanges]);
            setEdges((edges) =>
                edges.filter(
                    (edge) =>
                        !nodeIdsToRemove.has(edge.source) &&
                        !nodeIdsToRemove.has(edge.target),
                ),
            );
        },
        [nodes, onNodesChange, setEdges],
    );

    const FnForSetTrackState = (data) => {
        setTrackState(data);
    };

    const FunForsetActiveSidePanel = (data) => {
        setActiveSidePanel(data);
    };

    const FunForsetActiveSidePanelPinned = (data) => {
        setActiveSidePanelPinned(data);
    };

    const FnForsetSelectedNode = (data) => {
        if (data) {
            if (data.template.toUpperCase() === "LOOPSTART-0-0-0") {
                if (data.configData && data.configData.length > 0) {
                    let loop_type = data.configData.filter(
                        (x) => x?.parakey === "loop_type",
                    );
                    let loop_key = data.configData.filter(
                        (x) => x?.parakey === "loop_key",
                    );
                    let loop_list = data.configData.filter(
                        (x) => x?.parakey === "loop_list",
                    );
                    if (
                        loop_type &&
                        loop_type.length > 0 &&
                        loop_key &&
                        loop_key.length > 0 &&
                        loop_list &&
                        loop_list.length > 0
                    ) {
                        if (
                            loop_type[0].value &&
                            loop_type[0].value !== undefined &&
                            loop_type[0].value !== null &&
                            loop_type[0].value !== ""
                        ) {
                            let _LoopData = [];
                            if (loop_type[0].value.toUpperCase() === "BASED ON OUTPUT") {
                                if (
                                    data?.loopKeySampleData &&
                                    data?.loopKeySampleData !== undefined &&
                                    data?.loopKeySampleData !== null &&
                                    data?.loopKeySampleData !== ""
                                ) {
                                    try {
                                        let loopList = JSON.parse(data?.loopKeySampleData);

                                        const isArrayData = Array.isArray(loopList);
                                        const isObjectArray =
                                            isArrayData &&
                                            loopList.every(
                                                (item) =>
                                                    typeof item === "object" &&
                                                    !Array.isArray(item) &&
                                                    item !== null,
                                            );
                                        const isPrimitiveArray =
                                            isArrayData &&
                                            loopList.every((item) =>
                                                ["string", "number", "boolean"].includes(typeof item),
                                            );

                                        if (!isArrayData || (!isObjectArray && !isPrimitiveArray)) {
                                        } else {
                                            _LoopData = loopList;
                                        }
                                    } catch (err) { }
                                }
                            } else if (loop_type[0].value.toUpperCase() === "FIX") {
                                if (
                                    loop_list[0].value &&
                                    loop_list[0].value !== undefined &&
                                    loop_list[0].value !== null &&
                                    loop_list[0].value !== ""
                                ) {
                                    try {
                                        let loopList = JSON.parse(loop_list[0].value);

                                        const isArrayData = Array.isArray(loopList);
                                        const isObjectArray =
                                            isArrayData &&
                                            loopList.every(
                                                (item) =>
                                                    typeof item === "object" &&
                                                    !Array.isArray(item) &&
                                                    item !== null,
                                            );
                                        const isPrimitiveArray =
                                            isArrayData &&
                                            loopList.every((item) =>
                                                ["string", "number", "boolean"].includes(typeof item),
                                            );

                                        if (!isArrayData || (!isObjectArray && !isPrimitiveArray)) {
                                        } else {
                                            _LoopData = loopList;
                                        }
                                    } catch (err) { }
                                }
                            }

                            let LoopDataKeys = [];

                            if (_LoopData && _LoopData.length > 0) {
                                const keyPathSet =
                                    commonservices.getJsonPathsWithType_WithouArrayKayWherePosition(
                                        _LoopData[0],
                                    );
                                Array.from(keyPathSet).forEach((keyPath) => {
                                    LoopDataKeys.push({
                                        name: keyPath.key,
                                        value: "",
                                        inputType: commonservices.getQDDataTypeBaseOnType(
                                            keyPath.type,
                                        ),
                                    });
                                });
                            } else {
                                LoopDataKeys.push({
                                    name: "data",
                                    value: "",
                                    inputType: "Text Box",
                                });
                            }
                            setLoop_sample_data(LoopDataKeys);
                        }
                    }
                }
            }
        }
        setSelectedNode(data);
    };

    // const FnForsetSelectedNode = (data) => {
    //     setSelectedNode(data);
    // };

    function fnGetMachineStatus(shortName, WFMData, WFData) {
        let status = "";
        if (WFMData && WFMData.length !== 0) {
            let data = WFMData.filter(
                (i) =>
                    i.workflowmachinename?.toUpperCase() === shortName?.toUpperCase(),
            );
            if (data && data.length > 0) {
                status = data[0].status;
            }
        }

        if (shortName === "loopend-0-0-0" || shortName === "loopstart-0-0-0") {
            status = "node-opration";
        }
        return status;
    }

    const FindRelatedMachine = (assemblyname) => {
        let relatedMachine = allMachineDetails.filter(
            (x) => x.assemblyname === assemblyname,
        );
        return relatedMachine;
    };

    const AddLoopComponent = (StarterMachine, x, y) => {
        let nc = CalculateNodePositionAndWidthHeight(
            null,
            StarterMachine.assemblyname,
        );
        let position = {
            x: x,
            y: y + nc.h + 20,
        };
        const id = GenerateGUID();
        const typeid = StarterMachine?.machineid;
        const typeName = StarterMachine?.machinename;
        const image = StarterMachine?.machinelogo;
        const dockerimagename = StarterMachine?.dockerimagename;
        let shortName = StarterMachine?.assemblyname;
        const template = StarterMachine?.assemblyname;
        let sameMachineNo = 0;

        let NoOfMachineExist = nodes.filter(
            (x) => x.dockerimagename === dockerimagename,
        );
        if (NoOfMachineExist !== null && NoOfMachineExist.length !== 0) {
            NoOfMachineExist.sort((a, b) =>
                a.sameMachineNo > b.sameMachineNo
                    ? 1
                    : b.sameMachineNo > a.sameMachineNo
                        ? -1
                        : 0,
            );

            sameMachineNo =
                NoOfMachineExist[NoOfMachineExist.length - 1].sameMachineNo + 1;
            shortName = shortName + sameMachineNo;
        }
        const entrypointcommand = StarterMachine?.entrypointcommand;
        const cpu = StarterMachine?.cpu;
        const ram = StarterMachine?.ram;
        const osrequirmet = StarterMachine?.osrequirmet;
        const cloud = StarterMachine?.cloud;
        const configList = allMachineList?.dataList2?.filter(
            (x) => x?.machineid == StarterMachine?.machineid,
        );
        const infoDetail = allMachineList?.dataList3?.filter(
            (x) => x?.machineid == StarterMachine?.machineid,
        );
        const PROXY_ENABLED = StarterMachine?.PROXY_ENABLED || false;
        const PROXY_ROTATE_PER_REQUEST =
            StarterMachine?.PROXY_ROTATE_PER_REQUEST || true;

        const newNode = {
            id,
            typeid,
            typeName,
            position,
            image,
            dockerimagename,
            shortName,
            machine_version: StarterMachine?.versionnumber,
            template: template,
            sameMachineNo: sameMachineNo,
            className: fnGetMachineStatus(
                shortName,
                WorkFlowMachineStatus,
                WorkFlowStatus,
            ),
            data: {
                label: CreateModel(
                    StarterMachine.machinelogo,
                    id,
                    StarterMachine.machinename,
                    shortName,
                    IsWorkFlowIsRunning,
                    sameMachineNo,
                    WorkFlowMachineStatus,
                    WorkFlowStatus,
                    flowDetails,
                ),
            },
            configData: configList,
            infoData: infoDetail,
            entrypointcommand,
            cpu,
            ram,
            osrequirmet,
            cloud,
            PROXY_ENABLED,
            PROXY_ROTATE_PER_REQUEST,
        };
        setNodes((nds) => [...nds, newNode]);
    };

    const addNodeManually = (type, position) => {
        const id = GenerateGUID();
        const typeid = type?.machineid;
        const typeName = type?.machinename;
        const price = type?.price;
        const image = type?.machinelogo;
        const dockerimagename = type?.dockerimagename;
        let shortName = type?.assemblyname;
        const template = type?.assemblyname;
        let sameMachineNo = 0;

        let NoOfMachineExist = nodes.filter(
            (x) => x.dockerimagename === dockerimagename,
        );
        if (NoOfMachineExist?.length) {
            NoOfMachineExist.sort((a, b) =>
                a.sameMachineNo > b.sameMachineNo
                    ? 1
                    : b.sameMachineNo > a.sameMachineNo
                        ? -1
                        : 0,
            );
            sameMachineNo =
                NoOfMachineExist[NoOfMachineExist.length - 1].sameMachineNo + 1;
            shortName = shortName + sameMachineNo;
        }

        const entrypointcommand = type?.entrypointcommand;
        const cpu = type?.cpu;
        const ram = type?.ram;
        const osrequirmet = type?.osrequirmet;
        const cloud = type?.cloud;

        const configList = allMachineList?.dataList2?.filter(
            (x) => x?.machineid === type?.machineid,
        );
        const infoDetail = allMachineList?.dataList3?.filter(
            (x) => x?.machineid === type?.machineid,
        );
        const PROXY_ENABLED = type?.PROXY_ENABLED || false;
        const PROXY_ROTATE_PER_REQUEST = type?.PROXY_ROTATE_PER_REQUEST || true;

        const newNode = {
            id,
            typeid,
            typeName,
            position,
            image,
            dockerimagename,
            shortName,
            price,
            machine_version: type?.versionnumber,
            template,
            sameMachineNo,
            className: fnGetMachineStatus(
                shortName,
                WorkFlowMachineStatus,
                WorkFlowStatus,
            ),
            data: {
                label: CreateModel(
                    type.machinelogo,
                    id,
                    type.machinename,
                    shortName,
                    IsWorkFlowIsRunning,
                    sameMachineNo,
                    WorkFlowMachineStatus,
                    WorkFlowStatus,
                    flowDetails,
                ),
            },
            configData: configList,
            infoData: infoDetail,
            entrypointcommand,
            cpu,
            ram,
            osrequirmet,
            cloud,
            PROXY_ENABLED,
            PROXY_ROTATE_PER_REQUEST,
        };

        setNodes((prev) => [...prev, newNode]);
    };

    const onDrop = useCallback(
        (event) => {
            if (event.dataTransfer.getData("application/reactflow")) {
                event.preventDefault();
                const type = JSON.parse(
                    event.dataTransfer.getData("application/reactflow"),
                );
                let gets = nodes?.filter(
                    (x) =>
                        x.shortName === "loopend-0-0-0" ||
                        x.shortName === "loopstart-0-0-0",
                );
                if (
                    gets.length > 0 &&
                    (type?.assemblyname === "loopstart-0-0-0" ||
                        type?.assemblyname === "loopend-0-0-0")
                ) {
                    toast.info("Loop already exist");
                    return;
                }

                const position = CalculateNodePositionAndWidthHeight(
                    event,
                    type?.assemblyname,
                );

                if (
                    type?.assemblyname === "loopend-0-0-0" ||
                    type?.assemblyname === "loopstart-0-0-0"
                ) {
                    const id = GenerateGUID();
                    const typeid = type?.machineid;
                    const typeName = type?.machinename;
                    const price = type?.price;
                    const image = type?.machinelogo;
                    const dockerimagename = type?.dockerimagename;
                    let shortName = type?.assemblyname;
                    const template = type?.assemblyname;
                    let sameMachineNo = 0;

                    let NoOfMachineExist = nodes.filter(
                        (x) => x.dockerimagename === dockerimagename,
                    );
                    if (NoOfMachineExist !== null && NoOfMachineExist.length !== 0) {
                        NoOfMachineExist.sort((a, b) =>
                            a.sameMachineNo > b.sameMachineNo
                                ? 1
                                : b.sameMachineNo > a.sameMachineNo
                                    ? -1
                                    : 0,
                        );

                        sameMachineNo =
                            NoOfMachineExist[NoOfMachineExist.length - 1].sameMachineNo + 1;
                        shortName = shortName + sameMachineNo;
                    }
                    const entrypointcommand = type?.entrypointcommand;
                    const cpu = type?.cpu;
                    const ram = type?.ram;
                    const osrequirmet = type?.osrequirmet;
                    const cloud = type?.cloud;

                    const configList = allMachineList?.dataList2?.filter(
                        (x) => x?.machineid == type?.machineid,
                    );
                    const infoDetail = allMachineList?.dataList3?.filter(
                        (x) => x?.machineid == type?.machineid,
                    );
                    const PROXY_ENABLED = type?.PROXY_ENABLED || false;
                    const PROXY_ROTATE_PER_REQUEST =
                        type?.PROXY_ROTATE_PER_REQUEST || true;

                    const newNode = {
                        id,
                        typeid,
                        typeName,
                        position,
                        image,
                        dockerimagename,
                        shortName,
                        price,
                        machine_version: type?.versionnumber,
                        template: template,
                        sameMachineNo: sameMachineNo,
                        className: fnGetMachineStatus(
                            shortName,
                            WorkFlowMachineStatus,
                            WorkFlowStatus,
                        ),
                        data: {
                            label: CreateModel(
                                type.machinelogo,
                                id,
                                type.machinename,
                                shortName,
                                IsWorkFlowIsRunning,
                                sameMachineNo,
                                WorkFlowMachineStatus,
                                WorkFlowStatus,
                                flowDetails,
                            ),
                        },
                        configData: configList,
                        infoData: infoDetail,
                        entrypointcommand,
                        cpu,
                        ram,
                        osrequirmet,
                        cloud,
                        PROXY_ENABLED,
                        PROXY_ROTATE_PER_REQUEST,
                    };
                    setNodes((nds) => [...nds, newNode]);

                    let a = FindRelatedMachine(
                        type?.assemblyname === "loopend-0-0-0"
                            ? "loopstart-0-0-0"
                            : "loopend-0-0-0",
                    );
                    AddLoopComponent(a[0], position.x, position.y);
                } else {
                    const id = GenerateGUID();
                    const typeid = type?.machineid;
                    const typeName = type?.machinename;
                    const price = type?.price;
                    const image = type?.machinelogo;
                    const dockerimagename = type?.dockerimagename;
                    let shortName = type?.assemblyname;
                    const template = type?.assemblyname;
                    let sameMachineNo = 0;

                    let NoOfMachineExist = nodes.filter(
                        (x) => x.dockerimagename === dockerimagename,
                    );
                    if (NoOfMachineExist !== null && NoOfMachineExist.length !== 0) {
                        NoOfMachineExist.sort((a, b) =>
                            a.sameMachineNo > b.sameMachineNo
                                ? 1
                                : b.sameMachineNo > a.sameMachineNo
                                    ? -1
                                    : 0,
                        );

                        sameMachineNo =
                            NoOfMachineExist[NoOfMachineExist.length - 1].sameMachineNo + 1;
                        shortName = shortName + sameMachineNo;
                    }
                    const entrypointcommand = type?.entrypointcommand;
                    const cpu = type?.cpu;
                    const ram = type?.ram;
                    const osrequirmet = type?.osrequirmet;
                    const cloud = type?.cloud;

                    const configList = allMachineList?.dataList2?.filter(
                        (x) => x?.machineid == type?.machineid,
                    );
                    const infoDetail = allMachineList?.dataList3?.filter(
                        (x) => x?.machineid == type?.machineid,
                    );
                    const PROXY_ENABLED = type?.PROXY_ENABLED || false;
                    const PROXY_ROTATE_PER_REQUEST =
                        type?.PROXY_ROTATE_PER_REQUEST || true;

                    const newNode = {
                        id,
                        typeid,
                        typeName,
                        position,
                        image,
                        dockerimagename,
                        shortName,
                        price,
                        machine_version: type?.versionnumber,
                        template: template,
                        sameMachineNo: sameMachineNo,
                        className: fnGetMachineStatus(
                            shortName,
                            WorkFlowMachineStatus,
                            WorkFlowStatus,
                        ),
                        data: {
                            label: CreateModel(
                                type.machinelogo,
                                id,
                                type.machinename,
                                shortName,
                                IsWorkFlowIsRunning,
                                sameMachineNo,
                                WorkFlowMachineStatus,
                                WorkFlowStatus,
                                flowDetails,
                            ),
                        },
                        configData: configList,
                        infoData: infoDetail,
                        entrypointcommand,
                        cpu,
                        ram,
                        osrequirmet,
                        cloud,
                        PROXY_ENABLED,
                        PROXY_ROTATE_PER_REQUEST,
                    };
                    setNodes((nds) => [...nds, newNode]);
                }
            }
        },
        [nodes, setNodes],
    );

    function GenerateGUID() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
            /[xy]/g,
            function (c) {
                const r = (Math.random() * 16) | 0,
                    v = c == "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            },
        );
    }

    const onConnect = useCallback(
        (params) => {
            let connectingNodeData = nodes.find((n) => n.id === params.source);

            let targetNodeData = nodes.find((n) => n.id === params.target);
            if (connectingNodeData && targetNodeData) {
                if (
                    connectingNodeData.shortName
                        .toUpperCase()
                        .indexOf("QD#SYSTEM#SUBWORKFLOW-") < 0
                ) {
                    const newEdge = {
                        id: `${GenerateGUID()}`,
                        source_machineid: `${connectingNodeData.typeid}`,
                        source_machinename: `${connectingNodeData.typeName}`,
                        source_image: `${connectingNodeData.dockerimagename}`,
                        source_shortname: `${connectingNodeData.shortName}`,
                        source: params.source,
                        target: params.target,
                        target_machineid: `${targetNodeData.typeid}`,
                        target_machinename: `${targetNodeData.typeName}`,
                        target_image: `${targetNodeData.dockerimagename}`,
                        target_shortname: `${targetNodeData.shortName}`,
                        type: Edgetype,
                    };

                    const edgeExists = edges.some(
                        (edge) =>
                            edge.source === newEdge.source && edge.target === newEdge.target,
                    );

                    if (!edgeExists) {
                        setEdges((eds) => addEdge(newEdge, eds));
                    }
                }
            }
        },
        [edges, setEdges],
    );

    const isValidJson = (text) => {
        if (typeof text !== "string") {
            return false;
        }
        try {
            JSON.parse(text);
            return true;
        } catch (error) {
            return false;
        }
    };

    const MAX_TASK_ARGUMENTS_BYTES = 64 * 1024;

    const getUtf8ByteSize = (value) => {
        try {
            return new TextEncoder().encode(value || "").length;
        } catch (error) {
            return unescape(encodeURIComponent(value || "")).length;
        }
    };

    const getTaskArgumentsOversizeMachines = (tasks) => {
        if (!Array.isArray(tasks) || tasks.length === 0) {
            return [];
        }

        const oversizedMachines = [];

        tasks.forEach((task) => {
            const taskArguments = task?.arguments
                ? JSON.stringify(task.arguments)
                : "";
            const argumentSizeBytes = getUtf8ByteSize(taskArguments);

            if (argumentSizeBytes > MAX_TASK_ARGUMENTS_BYTES) {
                oversizedMachines.push(
                    commonservices.makeMachineDisplayName(
                        task?.workflowmachinename,
                        0,
                        task?.name,
                        "",
                    ) ||
                    task?.workflowmachinename ||
                    task?.name ||
                    "Unknown machine",
                );
            }
        });

        return [...new Set(oversizedMachines)];
    };

    const handleConfigValidation = () => {
        let nodeErrorArr = [];

        let updatedNodes = nodes?.map((item) => {
            let isErrorExists = false;
            let updatedConfig = item?.configData?.map((configItem) => {
                if (configItem?.paratype === "Json" && configItem?.value) {
                    let isJsonValid = isValidJson(configItem?.value);
                    if (!isJsonValid) {
                        isErrorExists = true;
                        configItem.error = true;
                        nodeErrorArr.push(item);
                    } else {
                        configItem.error = false;
                    }
                }
                return configItem;
            });
            item.configData = updatedConfig;
            if (isErrorExists) {
                nodeErrorArr.push(item);
            }
            return item;
        });

        return { nodeErrorArr, updatedNodes };
    };

    const ARGO_RAW_PARAM_KEY = "__argoRawParam__";
    const stringifyWithRawWorkflowParams = (payload) => {
        const serializedPayload = JSON.stringify(payload);
        const rawParamRegex = new RegExp(
            `\\{\\"${ARGO_RAW_PARAM_KEY}\\":\\"(\\{\\{(?:workflow\\.parameters\\.[^\\\"]+|inputs\\.parameters\\.data|=jsonpath\\([^\\\"]+\\))\\}\\})\\"\\}`,
            "g",
        );

        return serializedPayload.replace(rawParamRegex, "$1");
    };

    const parseWithRawWorkflowParams = (serializedPayload) => {
        if (!serializedPayload) {
            return {};
        }

        const normalizedPayload = serializedPayload.replace(
            /:\s*(\{\{(?:workflow\.parameters\.[^}]+|inputs\.parameters\.data|=jsonpath\([^}]+\))\}\})(\s*[,}])/g,
            `:{"${ARGO_RAW_PARAM_KEY}":"$1"}$2`,
        );

        return JSON.parse(normalizedPayload);
    };

    const createWorkflowJson = () => {
        let MachinesFiles = [];

        let _parametersforworkflow = parametersforworkflow
            ? parametersforworkflow.filter((item) => item.name !== "loops")
            : [];

        let groupingJson = {
            name: "#YAMLWORKFLOWNAME#",
            workflowname: flowName,
            code: "#code#",
            inputs: {},
            outputs: {},
            metadata: {},
            schedule: CroneExpressionValue,
            loopparam: JSON.stringify([]),
            loop_list: "",
            loop_type: "",
            loop_key: "",
            loop_sample_data: JSON.stringify([]),
            timezone: schedularData?.["WorkFlowSchedule.timezone"]
                ? schedularData?.["WorkFlowSchedule.timezone"]
                : Userdata.timezone,
            dag: {
                tasks: [],
            },
            workflowid: "1001001.101",
            mode: process.env.REACT_APP_APIBASEPATH?.includes("//api")
                ? "prod"
                : "smoke",
            logdata:
                '{"userid": 1001001.102,"workflowid": "#workflowid#","log_type": "","log_message": "#log_message#","env": "#env#","log_from": "#log_from#"}',
            retryStrategy: retrystrategy ? retrystrategy : 0,
            parallelism: parallelism ? parallelism : 0,
            nodegroup: eksnodegroup ? eksnodegroup : "",
            arguments: {
                parameters: _parametersforworkflow ? _parametersforworkflow : [],
            },
        };

        let NoOfParentNode = 0;

        let NewNodeData = commonservices.TopOlogicalSort(nodes, edges);

        let SubWorkflowDetails = [];

        NewNodeData?.forEach((item) => {
            let obj = {
                name: item?.shortName,
                template: item?.shortName.replace(
                    "-Loop-{{inputs.parameters.count}}",
                    "",
                ), // template: item?.template,
                images: item?.dockerimagename ? item?.dockerimagename : "",
                entrypointcommand: item?.entrypointcommand
                    ? item?.entrypointcommand.toLowerCase()
                    : "main.py",
                cpu: item?.cpu ? item?.cpu : "500m",
                ram: item?.ram ? item?.ram : "256Mi",
                osrequirmet: item?.osrequirmet ? item?.osrequirmet : "Linux",
                cloud: item?.cloud ? item?.cloud : "AWS",
                PROXY_ENABLED: item?.PROXY_ENABLED ? item?.PROXY_ENABLED : false,
                PROXY_ROTATE_PER_REQUEST: item?.PROXY_ROTATE_PER_REQUEST
                    ? item?.PROXY_ROTATE_PER_REQUEST
                    : true,
                arguments: {
                    parameters: {
                        name: "args",
                        value: "",
                    },
                },
                dependencies: [],
                fulldependencies: [],
                machineid: item.typeid,
                workflowmachinename: item.typeName,
                condition_list:
                    item?.condition_list && item?.condition_list.length > 0
                        ? item?.condition_list
                        : "",
                output_para: [],
                condition: "",
            };

            let objForParaValue = {};

            item?.configData?.forEach((configItem) => {
                // let newID = GenerateGUID();
                let valueForConfig = "";
                if (configItem?.valuetype && configItem?.workflowparavalue) {
                    const paraType = (configItem?.paratype || "").toUpperCase();
                    if (configItem?.valuetype.toUpperCase() === "GLOBAL PARAMETER") {
                        const workflowParamRef = `{{workflow.parameters.${configItem?.workflowparavalue}}}`;
                        if (
                            paraType === "NUMBER" ||
                            paraType === "DECIMAL" ||
                            paraType === "JSON"
                        ) {
                            valueForConfig = { [ARGO_RAW_PARAM_KEY]: workflowParamRef };
                        } else {
                            valueForConfig = workflowParamRef;
                        }
                    } else if (configItem?.valuetype.toUpperCase() === "LOOP KEY") {
                        const loopKeyRef = `{{=jsonpath(inputs.parameters.data,'$.${configItem?.workflowparavalue.replace("data.", "")}')}}`;
                        valueForConfig = loopKeyRef;
                        if (paraType === "NUMBER" || paraType === "DECIMAL") {
                            if (paraType === "NUMBER") {
                                valueForConfig = `{{=asInt(jsonpath(inputs.parameters.data,'$.${configItem?.workflowparavalue.replace("data.", "")}'))}}`;
                            } else if (paraType === "DECIMAL") {
                                valueForConfig = `{{=asFloat(jsonpath(inputs.parameters.data,'$.${configItem?.workflowparavalue.replace("data.", "")}'))}}`;
                            }
                        } else {
                            valueForConfig = loopKeyRef;
                        }
                        if (configItem?.workflowparavalue.toUpperCase() === "DATA") {
                            if (
                                paraType === "NUMBER" ||
                                paraType === "DECIMAL" ||
                                paraType === "JSON"
                            ) {
                                valueForConfig = {
                                    [ARGO_RAW_PARAM_KEY]: `{{inputs.parameters.data}}`,
                                };
                            } else {
                                valueForConfig = `{{inputs.parameters.data}}`;
                            }
                        }
                    }
                } else {
                    if (configItem?.value) {
                        valueForConfig = configItem?.value;
                    }

                    if (
                        configItem?.paratype.toUpperCase() === "NUMBER" &&
                        configItem?.value
                    ) {
                        valueForConfig = parseInt(configItem?.value);
                    }

                    if (
                        configItem?.paratype.toUpperCase() === "DECIMAL" &&
                        configItem?.value
                    ) {
                        valueForConfig = parseFloat(configItem?.value);
                    }

                    if (
                        configItem?.paratype.toUpperCase() === "JSON" &&
                        configItem?.value
                    ) {
                        valueForConfig = JSON.parse(configItem?.value);
                    }

                    if (
                        configItem?.paratype.toUpperCase() === "FILE" &&
                        configItem?.value
                    ) {
                        valueForConfig = configItem?.file;
                        if (configItem?.file instanceof File) {
                            valueForConfig =
                                item.id +
                                commonservices.getFileExtension(configItem?.file.name);
                            MachinesFiles.push({
                                title: valueForConfig,
                                file: configItem?.file,
                            });
                        }
                    }
                }

                objForParaValue = {
                    ...objForParaValue,
                    [configItem?.parakey]: valueForConfig,
                };
            });

            if (obj.images) {
                if (obj.images.toUpperCase().indexOf("/LAMBDA:") >= 0) {
                    if ("code_source" in objForParaValue) {
                        if (objForParaValue.code_source) {
                            if (
                                objForParaValue.code_source.toUpperCase() === "FILE" ||
                                objForParaValue.code_source.toUpperCase() === "ZIP"
                            ) {
                                objForParaValue.code_source = "s3";
                            }
                        }
                    }
                }
            }

            let findDependencies = edges?.filter((x) => x?.target === item?.id);

            if (findDependencies?.length > 0) {
                let names = [];
                let fullnames = [];

                findDependencies?.forEach((dependenciesItem) => {
                    let n = NewNodeData?.find(
                        (item) => item?.id === dependenciesItem?.source,
                    )?.shortName;
                    if (n) {
                        fullnames.push(n.replace("-Loop-{{inputs.parameters.count}}", ""));
                    }
                    if (n) {
                        if (n.toLowerCase().indexOf("loopstart-0-0-0") >= 0) {
                            n = "startloop";
                        }

                        if (n.toLowerCase().indexOf("loopend-0-0-0") >= 0) {
                            n = "loop";
                        }
                    }
                    if (n) {
                        names.push(n);
                    }
                });

                obj.dependencies = names.filter(
                    (value, index, self) => self.indexOf(value) === index,
                );

                obj.fulldependencies = fullnames.filter(
                    (value, index, self) => self.indexOf(value) === index,
                );
            } else {
                NoOfParentNode = NoOfParentNode + 1;
            }

            let findMachineVersion = allMachineList?.dataList1?.filter(
                (x) => x?.machineid == item?.typeid,
            );

            if (findMachineVersion?.length > 0) {
                item.machine_version = findMachineVersion?.[0]?.versionnumber;
            }

            let _condition_list = [];

            if (item?.condition_list && item?.condition_list.length > 0) {
                _condition_list = item?.condition_list.filter(
                    (item) => item.parentmachine !== "loopstart-0-0-0",
                );
            }

            let objForValue = {
                machine_name: item?.shortName,
                machinetemplate_name: item?.template,
                workflow_name: flowName ? flowName?.trim() : flowName,
                machine_version: item?.machine_version,
                workflowid: 1001001.101,
                subscriberid: Userdata?.subscriberid,
                machineid: item?.typeid,
                mode: process.env.REACT_APP_APIBASEPATH?.includes("//api")
                    ? "prod"
                    : "smoke",
                isautorun: true,
                prog_lang: "python",
                input_data: objForParaValue,
                output: item?.shortName + ".json",
                depends_machine: obj?.dependencies,
                dataprofile_query: item?.dataprofile_query
                    ? item?.dataprofile_query
                    : "",
                condition_list:
                    _condition_list && _condition_list.length > 0 ? _condition_list : "",
                output_para: {},
            };

            obj.arguments.parameters.value =
                stringifyWithRawWorkflowParams(objForValue);

            groupingJson.dag.tasks.push(obj);
        });

        let checkisloop = groupingJson?.dag?.tasks?.filter(
            (n) => n?.template === "loopstart-0-0-0",
        );

        if (checkisloop && checkisloop.length > 0) {
            let loopdata = parseWithRawWorkflowParams(
                checkisloop[0].arguments.parameters.value,
            );

            let loop_list = loopdata?.input_data?.loop_list;
            let loop_type = loopdata?.input_data?.loop_type;
            let loop_key = loopdata?.input_data?.loop_key;
            let output_from = loopdata?.input_data?.output_from;
            if (loop_type) {
                groupingJson.loop_type = loop_type.toUpperCase();

                if (loop_type.toUpperCase() === "FIX") {
                    if (loop_list) {
                        const isArrayData = Array.isArray(loop_list);
                        const isObjectArray =
                            isArrayData &&
                            loop_list.every(
                                (item) =>
                                    typeof item === "object" &&
                                    !Array.isArray(item) &&
                                    item !== null,
                            );
                        const isPrimitiveArray =
                            isArrayData &&
                            loop_list.every((item) =>
                                ["string", "number", "boolean"].includes(typeof item),
                            );

                        if (!isArrayData || (!isObjectArray && !isPrimitiveArray)) {
                            toast.error(
                                "Loop Start must contain either object array or value array format",
                            );
                            return;
                        } else {
                            groupingJson.loop_sample_data = JSON.stringify(loop_sample_data);
                            groupingJson.loop_list = JSON.stringify(loop_list);
                            groupingJson.arguments.parameters.push({
                                name: "loops",
                                value: JSON.stringify(loop_list),
                                isvalid: "",
                                isvalidName: "",
                            });
                        }
                    } else {
                        toast.error("Loop Start must has data");
                        return;
                    }
                } else if (loop_type.toUpperCase() === "BASED ON OUTPUT") {
                    if (loop_key && output_from) {
                        groupingJson.loop_sample_data = JSON.stringify(loop_sample_data);
                        groupingJson.loop_list = output_from;
                        groupingJson.loop_key = loop_key;
                        groupingJson.arguments.parameters.push({
                            name: "loops",
                            value: JSON.stringify([]),
                            isvalid: "",
                            isvalidName: "",
                        });
                    } else {
                        toast.error("Loop Start must has data");
                        return;
                    }
                } else {
                    toast.error("Loop Start must has data");
                    return;
                }
            } else {
                toast.error("Loop Start must has data");
                return;
            }
        }

        groupingJson?.dag?.tasks?.forEach((TasksItem) => {
            let dependencies = [];
            if (TasksItem.dependencies && TasksItem.dependencies.length > 0) {
                TasksItem.dependencies.forEach((d) => {
                    if (d) {
                        if (d.toLowerCase() === "loop") {
                            TasksItem.dependencies.forEach((d_d) => {
                                if (d_d && d_d.toLowerCase() !== "loop") {
                                    dependencies.push(d_d);
                                }
                            });
                            let findloopenddependencies = groupingJson?.dag?.tasks?.filter(
                                (n) => n?.template === "loopend-0-0-0",
                            );
                            if (
                                findloopenddependencies &&
                                findloopenddependencies.length > 0
                            ) {
                                if (
                                    findloopenddependencies[0].fulldependencies &&
                                    findloopenddependencies[0].fulldependencies.length > 0
                                ) {
                                    findloopenddependencies[0].fulldependencies.forEach(
                                        (loopend_d) => {
                                            if (loopend_d) {
                                                dependencies.push(loopend_d);
                                            }
                                        },
                                    );
                                }
                            }
                            if (TasksItem.arguments.parameters.value) {
                                let val = parseWithRawWorkflowParams(
                                    TasksItem.arguments.parameters.value,
                                );
                                val.depends_machine = dependencies;
                                TasksItem.arguments.parameters.value =
                                    stringifyWithRawWorkflowParams(val);
                            }
                        }
                    }
                });
            }
        });

        groupingJson?.dag?.tasks?.forEach((TasksItem) => {
            let dependencies = [];
            if (TasksItem.dependencies && TasksItem.dependencies.length > 0) {
                TasksItem.dependencies.forEach((d) => {
                    if (d) {
                        if (d.toLowerCase() === "startloop") {
                            TasksItem.dependencies.forEach((d_d) => {
                                if (d_d && d_d.toLowerCase() !== "startloop") {
                                    dependencies.push(d_d);
                                }
                            });
                            let findloopenddependencies = groupingJson?.dag?.tasks?.filter(
                                (n) => n?.template === "loopstart-0-0-0",
                            );
                            if (
                                findloopenddependencies &&
                                findloopenddependencies.length > 0
                            ) {
                                if (
                                    findloopenddependencies[0].fulldependencies &&
                                    findloopenddependencies[0].fulldependencies.length > 0
                                ) {
                                    findloopenddependencies[0].fulldependencies.forEach(
                                        (loopend_d) => {
                                            if (loopend_d) {
                                                dependencies.push(loopend_d);
                                            }
                                        },
                                    );
                                }
                            }
                            if (TasksItem.arguments.parameters.value) {
                                let val = parseWithRawWorkflowParams(
                                    TasksItem.arguments.parameters.value,
                                );
                                val.depends_machine = dependencies;
                                TasksItem.arguments.parameters.value =
                                    stringifyWithRawWorkflowParams(val);
                            }
                        }
                    }
                });
            }

            dependencies = [];
            if (TasksItem.dependencies && TasksItem.dependencies.length > 0) {
                TasksItem.dependencies.forEach((d) => {
                    if (d && d.toLowerCase() !== "startloop") {
                        dependencies.push(d);
                    }
                });
            }
            TasksItem.dependencies = dependencies;
        });

        let checkisSUBWORKFLOW = groupingJson?.dag?.tasks?.filter(
            (n) => n?.images === "SUBWORKFLOW",
        );

        if (checkisSUBWORKFLOW && checkisSUBWORKFLOW.length > 0) {
            groupingJson?.dag?.tasks?.forEach((TasksItem) => {
                if (TasksItem.images === "SUBWORKFLOW") {
                    groupingJson?.dag?.tasks?.forEach((SubTasksItem) => {
                        if (
                            SubTasksItem.dependencies &&
                            SubTasksItem.dependencies.length > 0 &&
                            TasksItem.dependencies &&
                            TasksItem.dependencies.length > 0
                        ) {
                            const exists = SubTasksItem.dependencies.includes(TasksItem.name);
                            if (exists) {
                                TasksItem.dependencies.forEach((d) =>
                                    SubTasksItem.dependencies.push(d),
                                );

                                const index = SubTasksItem.dependencies.indexOf(TasksItem.name);
                                if (index !== -1) {
                                    SubTasksItem.dependencies.splice(index, 1);
                                }

                                SubTasksItem.dependencies = [
                                    ...new Set(SubTasksItem.dependencies),
                                ];

                                if (SubTasksItem.arguments.parameters.value) {
                                    let val = parseWithRawWorkflowParams(
                                        SubTasksItem.arguments.parameters.value,
                                    );
                                    val.depends_machine = SubTasksItem.dependencies;
                                    SubTasksItem.arguments.parameters.value =
                                        stringifyWithRawWorkflowParams(val);
                                }
                            }
                        }
                    });

                    if (
                        TasksItem.machineid &&
                        TasksItem.dependencies &&
                        TasksItem.dependencies.length > 0 &&
                        TasksItem.machineid
                    ) {
                        SubWorkflowDetails.push({
                            subworkflowid: TasksItem.machineid,
                            dependencies: TasksItem.dependencies.join(","),
                            name: TasksItem.workflowmachinename,
                        });
                    }
                }
            });

            groupingJson.dag.tasks = groupingJson?.dag?.tasks.filter(
                (item) => item.images !== "SUBWORKFLOW",
            );
        }

        let IsAnyInvalidSubWorkflow = [];

        if (SubWorkflowDetails && SubWorkflowDetails.length > 0) {
            for (let i = 0; i < SubWorkflowDetails.length; i++) {
                let F = allMachineDetails.filter(
                    (m) => m.machineid === SubWorkflowDetails[i].subworkflowid,
                );
                if (F && F.length > 0) {
                } else {
                    IsAnyInvalidSubWorkflow.push(SubWorkflowDetails[i]);
                }
            }
        }

        groupingJson?.dag?.tasks?.forEach((TasksItem) => {
            if (TasksItem?.condition_list && TasksItem?.condition_list.length > 0) {
                let condition = { logic: "" };
                let logic = "";
                for (let c = 0; c < TasksItem?.condition_list.length; c++) {
                    let isLoopStart =
                        TasksItem?.condition_list[c].parentmachine === "loopstart-0-0-0";
                    let key = "";
                    if (isLoopStart) {
                        if (
                            TasksItem?.condition_list[c].expression
                                .toUpperCase()
                                .indexOf("DATA.") >= 0
                        ) {
                            if (Number(TasksItem?.condition_list[c].value)) {
                                if (TasksItem?.condition_list[c].value.indexOf(".") >= 0) {
                                    key =
                                        "{{=asFloat(jsonpath(inputs.parameters.data, '$." +
                                        TasksItem?.condition_list[c].expression.replace(
                                            "data.",
                                            "",
                                        ) +
                                        "'))}}";
                                } else {
                                    key =
                                        "{{=asInt(jsonpath(inputs.parameters.data, '$." +
                                        TasksItem?.condition_list[c].expression.replace(
                                            "data.",
                                            "",
                                        ) +
                                        "'))}}";
                                }
                            } else {
                                key =
                                    "{{=jsonpath(inputs.parameters.data, '$." +
                                    TasksItem?.condition_list[c].expression.replace("data.", "") +
                                    "')}}";
                            }
                        } else {
                            key = "{{inputs.parameters.data}}";
                        }
                    } else {
                        key = TasksItem?.condition_list[c].expression;
                    }

                    logic =
                        logic +
                        " " +
                        TasksItem?.condition_list[c].condition +
                        " " +
                        TasksItem?.condition_list[c].name;
                    condition[TasksItem?.condition_list[c].name] = {
                        name: TasksItem?.condition_list[c].name,
                        parent: TasksItem?.condition_list[c].parentmachine,
                        conditionexpression:
                            TasksItem?.condition_list[c].name +
                            " " +
                            TasksItem?.condition_list[c].operation +
                            " " +
                            TasksItem?.condition_list[c].value,
                        key: key,
                    };

                    let conditionparentfilter = groupingJson?.dag?.tasks?.filter(
                        (conditionparent) =>
                            conditionparent.name ===
                            TasksItem?.condition_list[c].parentmachine,
                    );
                    if (conditionparentfilter && conditionparentfilter.length > 0) {
                        conditionparentfilter[0].output_para.push(
                            TasksItem?.condition_list[c].name,
                        );

                        if (conditionparentfilter[0].arguments.parameters.value) {
                            let val = parseWithRawWorkflowParams(
                                conditionparentfilter[0].arguments.parameters.value,
                            );
                            val.output_para[TasksItem?.condition_list[c].name] =
                                TasksItem?.condition_list[c].expression;
                            conditionparentfilter[0].arguments.parameters.value =
                                stringifyWithRawWorkflowParams(val);
                        }
                    }
                }
                condition.logic = logic.trim();
                TasksItem.condition = condition;
            }
        });

        return {
            groupingJson,
            NoOfParentNode,
            SubWorkflowDetails,
            IsAnyInvalidSubWorkflow,
            MachinesFiles,
        };
    };

    const createWorkFlowDetail = () => {
        let workFlowArr = [];
        nodes?.forEach((item) => {
            let parentMachineData = edges?.filter((x) => x?.target === item?.id);
            let childeMachineData = edges?.filter((x) => x?.source === item?.id);
            let parentDataArr = [];
            let childDataArr = [];

            parentMachineData?.forEach((dataItem) => {
                parentDataArr.push(dataItem?.source_machineid);
            });
            childeMachineData?.forEach((dataItem) => {
                childDataArr.push(dataItem?.target_machineid);
            });

            workFlowArr?.push({
                machineid: item?.typeid,
                parentmachineids: parentDataArr?.toString(),
                childmachineids: childDataArr?.toString(),
                ram: item?.ram,
                cpu: item?.cpu,
                template: item?.shortName,
            });
        });
        return workFlowArr;
    };

    const handleWorkFlowSave = async (workflowSaveType) => {
        if (edges?.length > 0 && nodes?.length > 0 && flowName !== "") {
            // Satish Thummar

            if (API_URL.BASEURL.includes("beta")) {
                const workFlowName = flowName;
                if (
                    !workFlowName ||
                    workFlowName.substring(0, 5).toLowerCase() !== "beta-" // must start with beta
                ) {
                    toast.error("Workflow Name must start with 'beta-'.");
                    return;
                }
            }

            if (flowName.toLowerCase().indexOf("sandbox") >= 0) {
                toast.error("The keyword 'SANDBOX' is not allowed in workflow names.");
                return;
            }

            setFlowLoader(true);
            let configValidation = handleConfigValidation();
            if (configValidation?.nodeErrorArr?.length > 0) {
                setFlowLoader(false);
                setNodes(configValidation?.updatedNodes);
                handleNodeClick(
                    "",
                    configValidation?.nodeErrorArr?.[0],
                    IsWorkFlowIsRunning,
                    WorkFlowMachineStatus,
                    WorkFlowMachineUse,
                );
                return;
            }
            let workFlowJson = createWorkflowJson();

            //setFlowLoader(false);

            if (workFlowJson) {
                const oversizedArgumentMachines = getTaskArgumentsOversizeMachines(
                    workFlowJson?.groupingJson?.dag?.tasks,
                );

                if (oversizedArgumentMachines.length > 0) {
                    setFlowLoader(false);
                    toast.error(
                        "Do not enter parameter value size greater than 64KB in machine(s):\n" +
                        oversizedArgumentMachines.join("\n"),
                    );
                    return;
                }

                if (
                    workFlowJson.IsAnyInvalidSubWorkflow &&
                    workFlowJson.IsAnyInvalidSubWorkflow.length > 0
                ) {
                    let imname = "";
                    for (
                        let ii = 0;
                        ii < workFlowJson.IsAnyInvalidSubWorkflow.length;
                        ii++
                    ) {
                        imname =
                            imname + workFlowJson.IsAnyInvalidSubWorkflow[ii].name + "\n";
                    }
                    setFlowLoader(false);
                    toast.error("Below workflow are not valid. \n" + imname);
                    return;
                }

                if (workFlowJson?.NoOfParentNode !== 1) {
                    setFlowLoader(false);
                    toast.error("Add One Parent Only");
                    return;
                }

                let workFlowDetail = createWorkFlowDetail();

                const currentDate = new Date();
                const futureFiveYearsPlusDate = new Date(
                    currentDate.setFullYear(currentDate.getFullYear() + 5),
                );

                let _workspaceReq = [];
                workspaceInput?.map((item) =>
                    _workspaceReq.push({ workspacename: item.label }),
                );
                let payload = {
                    "WorkFlow.workflowid": id,
                    "WorkFlow.description": descriptionName,
                    "WorkFlow.tag": tag,
                    "WorkFlow.workflowname": flowName ? flowName?.trim() : flowName,
                    "WorkFlow.workflownodejson": JSON.stringify(nodes),
                    "WorkFlow.workflowedgejson": JSON.stringify(edges),
                    "WorkFlow.workflowjson": JSON.stringify(workFlowJson?.groupingJson),
                    "WorkFlow.parametersforworkflow": JSON.stringify(
                        parametersforworkflow ? parametersforworkflow : [],
                    ),
                    "WorkFlowSchedule.timezone": schedularData?.[
                        "WorkFlowSchedule.timezone"
                    ]
                        ? schedularData?.["WorkFlowSchedule.timezone"]
                        : Userdata.timezone,
                    "WorkFlowSchedule.startondatetime": schedularData?.[
                        "WorkFlowSchedule.startondatetime"
                    ]
                        ? schedularData?.["WorkFlowSchedule.startondatetime"]
                        : commonservices.getDateInDBFormat(new Date()),
                    "WorkFlowSchedule.endondatetime": schedularData?.[
                        "WorkFlowSchedule.endondatetime"
                    ]
                        ? schedularData?.["WorkFlowSchedule.endondatetime"]
                        : commonservices.getDateInDBFormat(futureFiveYearsPlusDate),
                    "WorkFlowSchedule.scheduledays": schedularData?.[
                        "WorkFlowSchedule.scheduledays"
                    ]
                        ? schedularData?.["WorkFlowSchedule.scheduledays"]
                        : "",
                    "WorkFlowSchedule.schedulemonth": schedularData?.[
                        "WorkFlowSchedule.schedulemonth"
                    ]
                        ? schedularData?.["WorkFlowSchedule.schedulemonth"]
                        : "",
                    "WorkFlowSchedule.hour": schedularData?.["WorkFlowSchedule.hour"]
                        ? schedularData?.["WorkFlowSchedule.hour"]
                        : "",
                    "WorkFlowSchedule.minute": schedularData?.["WorkFlowSchedule.minute"]
                        ? schedularData?.["WorkFlowSchedule.minute"]
                        : "",
                    "WorkFlowSchedule.weekdays": schedularData?.[
                        "WorkFlowSchedule.weekdays"
                    ]
                        ? schedularData?.["WorkFlowSchedule.weekdays"]
                        : "",
                    "WorkFlowSchedule.cronexpression": schedularData?.[
                        "WorkFlowSchedule.cronexpression"
                    ]
                        ? schedularData?.["WorkFlowSchedule.cronexpression"]
                        : "0 0 1 1 *",
                    WorkFlowDetail: workFlowDetail,
                    WorkFlowTeam: [],
                    SubWorkflowDetails: workFlowJson.SubWorkflowDetails,
                    "WorkFlow.workflowsavestatus": workflowSaveType,
                    "WorkFlow.parallelism": parallelism ? parallelism : 0,
                    "WorkFlow.retrystrategy": retrystrategy ? retrystrategy : 0,
                    "WorkFlow.nodegroup": eksnodegroup ? eksnodegroup : "",
                    ...(subscribersinfrastructureautomationid && subscribersinfrastructureautomationid !== "null" && subscribersinfrastructureautomationid !== 0 && subscribersinfrastructureautomationid !== "0"
                        ? { "WorkFlow.subscribersinfrastructureautomationid": subscribersinfrastructureautomationid }
                        : {}),
                    Workspace: _workspaceReq ? _workspaceReq : [],
                    WorkflowMachineFiles: workFlowJson.MachinesFiles,
                };

                dispatch(WorkFlowSave(payload)).then((response) => {
                    let data = commonservices.bodyEncryption(
                        `${response?.payload?.data?.data?.workFlow?.workflowid}?v=0&r=${RedirectParam}`,
                    );
                    if (response?.payload?.isValidate) {
                        setFlowLoader(false);
                        setReload(true);
                        setTrackState(false);
                        navigate(`/flow-new/${data}`, {
                            state: {
                                isViewMode: false,
                                flowRoleRights: state?.flowRoleRights,
                            },
                        });
                        if (AIMachineListOnNodes || AIMachineList) {
                            dispatch(
                                SaveWorkflowPrompt({
                                    workflowid: id,
                                    prompt:
                                        AIMachineListOnNodes?.expanded_query ||
                                        AIMachineList?.expanded_query ||
                                        AIPromptData ||
                                        "",
                                    promptsessionid:
                                        AIMachineListOnNodes?.thread_id ||
                                        AIMachineList?.thread_id ||
                                        "",
                                }),
                            );
                        }
                        BindDataByID(
                            response?.payload?.data?.data?.workFlow?.workflowid,
                            "",
                        );
                        if (workflowSaveType === "CopyWorkFlow") {
                            handleFlowOperations("Save As");
                        } else if (workflowSaveType === "Draft") {
                            handleFlowOperations("Save");
                        } else if (workflowSaveType === "Publish") {
                            handleFlowOperations("Publish");
                        }
                    }
                    if (!response?.payload?.isValidate) {
                        setReload(false);
                        setFlowLoader(false);
                        setTrackState(false);
                        handleFlowOperations("Save");
                    }
                });
            } else {
                setFlowLoader(false);
            }
        } else {
            setFlowLoader(false);
            toast.error("Please provide proper data for save");
        }
    };

    const handleSchedularSubmit = (data) => {
        setSchedularData(data);
        setCroneExpressionValue(data?.["WorkFlowSchedule.cronexpression"]);
    };

    const handleshowSchedularPopup = (e) => {
        if (document.getElementById("body").classList.contains("popup-is-open")) {
            document.getElementById("body").classList.remove("popup-is-open");
        } else {
            document.getElementById("body").classList.add("popup-is-open");
        }
        setShowSchedularPopup(!showSchedularPopup);
    };

    const handleshowCostPopup = (e) => {
        if (document.getElementById("body").classList.contains("popup-is-open")) {
            document.getElementById("body").classList.remove("popup-is-open");
        } else {
            document.getElementById("body").classList.add("popup-is-open");
        }
        setShow(!show);
    };

    const handleShowConfigPopup = (e) => {
        if (document.getElementById("body").classList.contains("popup-is-open")) {
            document.getElementById("body").classList.remove("popup-is-open");
        } else {
            document.getElementById("body").classList.add("popup-is-open");
        }
        setShowConfigPopup(!showConfigPopup);
    };

    const WorkflowConfigSave = (data) => {
        debugger;
        setParallelism(data.parallelism ? data.parallelism : 0);
        setRetrystrategy(data.retrystrategy ? data.retrystrategy : 0);
        setParametersForWorkflow(
            data.parametersforworkflow ? data.parametersforworkflow : [],
        );
        setWorkspaceInput(data.workspaceInput ? data.workspaceInput : []);
        setEksnodegroup(data.eksnodegroup ? data.eksnodegroup : "");
        setSubscribersinfrastructureautomationid(data.subscribersinfrastructureautomationid ? data.subscribersinfrastructureautomationid : "");
        // setWorkspaceForWorkflow(data.workspaceForWorkflow ? data.workspaceForWorkflow : [])
        handleShowConfigPopup();
    };

    const workFlowDiscriptionPopup = (e) => {
        if (document.getElementById("body").classList.contains("popup-is-open")) {
            document.getElementById("body").classList.remove("popup-is-open");
            // handleOverlay(e);
        } else {
            document.getElementById("body").classList.add("popup-is-open");
        }
        setworkFlowDiscriptionPopupstate(!workFlowDiscriptionPopupstate);
    };

    const handleWorkFlowSaveStatusType = async (type) => {
        setFlowLoader(true);

        let payload = {
            workflowid: flowDetails?.workflowid,
            status: type,
        };
        setFlowLoader(true);

        dispatch(UpdateWorkFlowStatus(payload)).then((response) => {
            if (response?.payload?.isValidate) {
                if (type === "delete") {
                    if (RedirectParam === "dc" || RedirectParam === "dl") {
                        navigate("/dashboard", {
                            state: {
                                param: RedirectParam,
                            },
                        });
                    } else if (RedirectParam === "wc" || RedirectParam === "wl") {
                        navigate("/workflows", {
                            state: {
                                param: RedirectParam,
                            },
                        });
                    } else if (RedirectParam === "sl") {
                        navigate("/scheduler", {
                            state: {
                                param: RedirectParam,
                            },
                        });
                    } else if (RedirectParam === "wa") {
                        navigate("/management-listing", {
                            state: "workflow",
                        });
                    } else {
                        navigate("/dashboard");
                    }
                }
                setFlowLoader(false);
                BindDataByID(id, "");

                if (type === "resume") {
                    handleFlowOperations("Publish");
                } else if (type === "suspend") {
                    handleFlowOperations("Suspend");
                }
            }

            if (!response?.payload?.isValidate) {
                handleFlowOperations("Save");
                setFlowLoader(false);
            }
        });
    };

    const fetchData = async (id) => {
        let body = {
            subscriberid: 0,
            workflowid: parseInt(id),
        };
        try {
            dispatch(WorkTeamGetTeamList(body))?.then((res) => {
                if (res?.payload?.isValidate) {
                    let filteredUContact = res?.payload?.data?.data.filter(
                        (itm) => itm?.workflowroleid && itm,
                    );
                    setContactList(filteredUContact);
                }
            });
        } catch (error) { }
    };

    const fetchWorkspaceList = (workflowId) => {
        dispatch(GetWorkspaceListByID(parseInt(workflowId)))?.then((response) => {
            if (response?.payload?.isValidate) {
                if (response?.payload?.data?.data?.length > 0) {
                    let _WorkspaceOpt = [];
                    let _WorkspaceInput = [];
                    response?.payload?.data?.data.forEach((element) => {
                        if (element?.isselected) {
                            _WorkspaceInput.push({
                                value: element?.workspacename,
                                label: element?.workspacename,
                                isselected: element?.isselected,
                            });
                        }
                        _WorkspaceOpt.push({
                            value: element?.workspacename,
                            label: element?.workspacename,
                            isselected: element?.isselected,
                        });
                    });
                    setWorkspaceInput(_WorkspaceInput);
                    setWorkspaceForWorkflow(_WorkspaceOpt);
                }
            }
            if (!response?.payload?.isValidate) {
            }
        });
    };

    const BindDataByID = (workflowid, workflowulogid) => {
        let body = {
            id: parseInt(workflowid),
            workflowulogid: workflowulogid,
        };

        dispatch(GetWorkFlowByID(body));
    };

    async function fnGetUsageTrendChartData(workflowid) {
        setUsageTrendChartLoader(true);
        const endDateValue = new Date();
        const startDateValue = moment(endDateValue).subtract(6, "days").toDate();
        let body = {
            startdate: new Date(
                Date.UTC(
                    startDateValue.getFullYear(),
                    startDateValue.getMonth(),
                    startDateValue.getDate(),
                    0,
                    0,
                    0,
                    0,
                ),
            ).toISOString(),
            enddate: new Date(
                Date.UTC(
                    endDateValue.getFullYear(),
                    endDateValue.getMonth(),
                    endDateValue.getDate(),
                    23,
                    59,
                    59,
                    999,
                ),
            ).toISOString(),
            workflowid: parseInt(workflowid),
        };
        try {
            const response = await dispatch(getMonthlycostbydatabyWorkflowId(body));
            if (response?.payload?.isValidate) {
                let templables = [];
                let dataByLabel = {};
                const data1 = response?.payload?.data?.data || [];
                data1.forEach((element) => {
                    templables.push(element.monthandyear);
                    if (!dataByLabel[element.displayname]) {
                        dataByLabel[element.displayname] = [];
                    }
                    dataByLabel[element.displayname].push({
                        monthandyear: element.monthandyear,
                        bill: element.bill,
                    });
                });
                templables = [...new Set(templables)];
                let tempdatasets = [];
                for (const [label, items] of Object.entries(dataByLabel)) {
                    tempdatasets.push({
                        label: label,
                        data: templables.map((month) => {
                            const item = items.find((i) => i.monthandyear === month);
                            return item ? item.bill : 0;
                        }),
                        backgroundColor: commonservices.CreateColor(label)?.BGColor,
                    });
                }
                setUsageTrendChartData({
                    labels: templables,
                    datasets: tempdatasets,
                });
            } else {
                setUsageTrendChartData({ labels: [], datasets: [] });
            }
        } catch (error) {
            setUsageTrendChartData({ labels: [], datasets: [] });
        } finally {
            setUsageTrendChartLoader(false);
        }
    }

    async function fnGetRecentRunsList(workflowid) {
        setRecentRunsLoader(true);
        let body = {
            workflowid: parseInt(workflowid),
            startdate: "",
            enddate: "",
            status: "",
            searchtext: "",
        };
        try {
            const response = await dispatch(WorkflowScheduleLogGetList(body));
            if (response?.payload?.isValidate) {
                let sorted_array = [...(response?.payload?.data?.data?.dataList1 || [])]
                    .sort((a, b) => new Date(b.starton) - new Date(a.starton))
                    .slice(0, 5);
                setRecentRunsList(sorted_array);
            } else {
                setRecentRunsList([]);
            }
        } catch (error) {
            setRecentRunsList([]);
        } finally {
            setRecentRunsLoader(false);
        }
    }

    const calculateOffsets = () => {
        const leftOffset = activeSidePanel ? 340 : 38;
        const rightOffset = activeRightSidePanel !== "sm-panel" ? 399 : 38;
        // const bottomOffset = panels.bottomPanel ? 50 : 150;
        return {
            leftOffset,
            rightOffset,
        };
    };

    const handleshowContactPopup = (e) => {
        if (document.getElementById("body").classList.contains("popup-is-open")) {
            document.getElementById("body").classList.remove("popup-is-open");
            fetchData(id);
            // handleOverlay(e);
        } else {
            document.getElementById("body").classList.add("popup-is-open");
        }
        setShowContact(!showContact);
    };

    const handleshowNotification = () => {
        if (document.getElementById("body").classList.contains("popup-is-open")) {
            document.getElementById("body").classList.remove("popup-is-open");
        } else {
            document.getElementById("body").classList.add("popup-is-open");
        }
        setShowNotification(!showNotification);
    };

    const handleSidepanelClick = () => {
        if (activeSidePanelPinned) {
            setActiveSidePanel(activeSidePanelPinned);
        } else {
            setActiveSidePanel(!activeSidePanel);
        }
    };

    function handleFlowOperations(btn_action) {
        switch (btn_action) {
            case "Save":
                setSelOption({
                    btnTitle: "Save",
                    backColor: "#9A9A9A",
                    foreColor: "#dcecf9",
                });
                break;
            case "Save As":
                setSelOption({
                    btnTitle: "Save",
                    backColor: "#9A9A9A",
                    foreColor: "#dcecf9",
                });
                break;

            case "Publish":
                setSelOption({
                    btnTitle: "Publish",
                    backColor: "#0461BB",
                    foreColor: "#dcecf9",
                });
                break;

            case "Save & Publish":
                setSelOption({
                    btnTitle: "Publish",
                    backColor: "#0461BB",
                    foreColor: "#dcecf9",
                });
                break;

            case "Suspend":
                setSelOption({
                    btnTitle: "Suspend",
                    backColor: "#FFA500",
                    foreColor: "#dcecf9",
                });
                break;

            case "Resume":
                setSelOption({
                    btnTitle: "Resume",
                    backColor: "#007BFF",
                    foreColor: "#dcecf9",
                });
                break;

            default:
                setSelOption({
                    btnTitle: "Save",
                    backColor: "#9A9A9A",
                    foreColor: "#dcecf9",
                });
                break;
        }
    }

    // Same color scheme as handleFlowOperations, keyed off the saved workflow status
    function getWorkflowStatusColor(status) {
        switch (status) {
            case "Publish":
            case "Save & Publish":
                return { backColor: "#0461BB", foreColor: "#dcecf9" };
            case "Suspend":
                return { backColor: "#FFA500", foreColor: "#dcecf9" };
            case "Resume":
                return { backColor: "#007BFF", foreColor: "#dcecf9" };
            case "Save":
            case "Save As":
            case "Draft":
            default:
                return { backColor: "#9A9A9A", foreColor: "#dcecf9" };
        }
    }

    const getLayoutedElements = (
        nodes,
        edges,
        direction = "TB",
        viewportWidth = 800,
        viewportHeight = 600,
    ) => {
        if (document.getElementById("canvas-workflow-wrapper-ReactFlow")) {
            viewportWidth = document.getElementById(
                "canvas-workflow-wrapper-ReactFlow",
            ).clientWidth;
            viewportHeight = document.getElementById(
                "canvas-workflow-wrapper-ReactFlow",
            ).clientHeight;
        }

        const dagreGraph = new dagre.graphlib.Graph();
        dagreGraph.setDefaultEdgeLabel(() => ({}));

        dagreGraph.setGraph({ rankdir: direction });

        nodes.forEach((node) => {
            //let cpwh = CalculateNodePositionAndWidthHeight(null, node.assemblyname);
            dagreGraph.setNode(node.id, { width: nodeWidth, height: nodeHeight });
        });

        edges.forEach((edge) => {
            dagreGraph.setEdge(edge.source, edge.target);
        });

        dagre.layout(dagreGraph);

        // Compute node positions
        let minX = Infinity,
            minY = Infinity,
            maxX = -Infinity,
            maxY = -Infinity;
        nodes.forEach((node) => {
            const nodeWithPosition = dagreGraph.node(node.id);
            //let cpwh = CalculateNodePositionAndWidthHeight(null, node.assemblyname);
            node.position = {
                x: nodeWithPosition.x - nodeWidth / 2,
                y: nodeWithPosition.y - nodeHeight / 2,
            };

            // Update bounding box
            minX = Math.min(minX, node.position.x);
            minY = Math.min(minY, node.position.y);
            maxX = Math.max(maxX, node.position.x + nodeWidth);
            maxY = Math.max(maxY, node.position.y + nodeHeight);
        });

        // Calculate graph dimensions
        const graphWidth = maxX - minX;
        const graphHeight = maxY - minY;

        // Calculate offsets to center the graph
        const offsetX = (viewportWidth - graphWidth) / 2 - minX;
        const offsetY = (viewportHeight - graphHeight) / 2 - minY;

        // Apply offsets to center the graph
        nodes.forEach((node) => {
            node.position.x += offsetX;
            /*node.position.y += offsetY;*/
        });

        return { nodes, edges };
    };

    const ConnectWithSignalR = (workflowid) => {
        if (workflowid && workflowid !== "0" && workflowid !== 0) {
            if (connection) {
                connection
                    .stop()
                    .then(() => { })
                    .catch((err) => { });
            }
            const connect = new HubConnectionBuilder()
                .withUrl(process.env.REACT_APP_SIGNAL_R, { withCredentials: false })
                .withAutomaticReconnect()
                .build();
            connect
                .start()
                .then(() => {
                    setConnection(connect);

                    connect.send("workflowconnect", parseInt(workflowid));
                    connect.on("getworkflowupdate", (data) => {
                        if (parseInt(data.id) === parseInt(workflowid)) {
                            if (data.datatype === "tra_workflowschedulelog") {
                                let workflowpage = document.getElementById("wf_" + workflowid);

                                if (workflowpage) {
                                    let wfdata_attr = workflowpage.getAttribute("wfdata");
                                    if (wfdata_attr) {
                                        let wfdata_array = JSON.parse(wfdata_attr);
                                        let dataList1 = wfdata_array.data.dataList1;
                                        if (
                                            dataList1[0].runningworkflows &&
                                            dataList1[0].runningworkflows.indexOf("[") >= 0
                                        ) {
                                            let runningworkflows = JSON.parse(
                                                dataList1[0].runningworkflows,
                                            );

                                            if (data.data.status.toUpperCase() === "START") {
                                                runningworkflows.unshift({
                                                    workflowid: parseInt(workflowid),
                                                    starton: new Date().toISOString().slice(0, -1),
                                                    workflowulogid: data.data.workflowulogid,
                                                    argostatus: "Running",
                                                });
                                                dataList1[0].runningworkflows =
                                                    JSON.stringify(runningworkflows);
                                            } else if (data.data.status.toUpperCase() === "END") {
                                                if (
                                                    dataList1[0].currentdataworkflowulogid ===
                                                    data.data.workflowulogid
                                                ) {
                                                    BindDataByID(workflowid, data.data.workflowulogid);
                                                } else {
                                                    runningworkflows = runningworkflows.filter(
                                                        (x) =>
                                                            x.workflowulogid !== data.data.workflowulogid,
                                                    );

                                                    dataList1[0].runningworkflows = runningworkflows;
                                                }
                                            }

                                            wfdata_array.data.dataList1 = dataList1;

                                            let GetWorkFlowIDData = {
                                                isValidate: true,
                                                data: {
                                                    message: "Records found",
                                                    status_code: 1,
                                                    recordcount: 0,
                                                    data: {
                                                        dataList1: wfdata_array.data.dataList1,
                                                        dataList2: wfdata_array.data.dataList2,
                                                        dataList3: wfdata_array.data.dataList3,
                                                        dataList4: wfdata_array.data.dataList4,
                                                        dataList5: wfdata_array.data.dataList5,
                                                        dataList6: wfdata_array.data.dataList6,
                                                    },
                                                },
                                            };

                                            BindWorkFlowDataOnUI(GetWorkFlowIDData);
                                        } else {
                                            BindDataByID(
                                                workflowid,
                                                dataList1[0].currentdataworkflowulogid
                                                    ? dataList1[0].currentdataworkflowulogid
                                                    : "",
                                            );
                                        }
                                    } else {
                                        BindDataByID(workflowid, "");
                                    }
                                } else {
                                    BindDataByID(workflowid, "");
                                }
                            } else {
                                let workflowpage = document.getElementById("wf_" + workflowid);
                                if (workflowpage) {
                                    let wfdata_attr = workflowpage.getAttribute("wfdata");
                                    if (wfdata_attr) {
                                        let wfdata_array = JSON.parse(wfdata_attr);
                                        let dataList1 = wfdata_array.data.dataList1;
                                        if (
                                            dataList1[0].currentdataworkflowulogid ===
                                            data.data.workflowulogid
                                        ) {
                                            let dataList2 = wfdata_array.data.dataList2;

                                            let dataList3 = wfdata_array.data.dataList3;

                                            if (data.datatype === "tra_workflowschedulemachinelog") {
                                                let checkIsExist = dataList3.filter(
                                                    (i) =>
                                                        i.workflowmachinename ===
                                                        data.data.workflowmachinename,
                                                );

                                                if (checkIsExist && checkIsExist.length === 0) {
                                                    let filtermachine = allMachineDetails.filter(
                                                        (m) => m.assemblyname === data.data.assemblyname,
                                                    );
                                                    //
                                                    if (filtermachine && filtermachine.length > 0) {
                                                        data.data.machinename =
                                                            filtermachine[0].machinename;
                                                        data.data.machineid = filtermachine[0].machineid;
                                                    }
                                                    dataList3.push(data.data);
                                                } else {
                                                    checkIsExist[0].endon = data.data.endon;
                                                    checkIsExist[0].logdata = data.data.logdata;
                                                    checkIsExist[0].status = data.data.status;
                                                    if (data.data.stepno) {
                                                        checkIsExist[0].stepno = data.data.stepno;
                                                    }

                                                    //checkIsExist[0].thisweek = data.data.thisweek;
                                                    //checkIsExist[0].thismonth = data.data.thismonth;
                                                    //checkIsExist[0].thisyear = data.data.thisyear;
                                                    //checkIsExist[0].lastweek = data.data.lastweek;
                                                    //checkIsExist[0].lastmonth = data.data.lastmonth;
                                                    //checkIsExist[0].lastyear = data.data.lastyear;
                                                }
                                            }

                                            let dataList4 = wfdata_array.data.dataList4;

                                            if (data.datatype === "tra_machineusage") {
                                                let filtermachine = allMachineDetails.filter(
                                                    (m) => m.assemblyname === data.data.assemblyname,
                                                );
                                                if (filtermachine && filtermachine.length > 0) {
                                                    data.data.machineid = filtermachine[0].machineid;
                                                }
                                                dataList4.push(data.data);
                                            }

                                            let dataList5 = wfdata_array.data.dataList5;

                                            let dataList6 = wfdata_array.data.dataList6;

                                            let GetWorkFlowIDData = {
                                                isValidate: true,
                                                data: {
                                                    message: "Records found",
                                                    status_code: 1,
                                                    recordcount: 0,
                                                    data: {
                                                        dataList1: dataList1,
                                                        dataList2: dataList2,
                                                        dataList3: dataList3,
                                                        dataList4: dataList4,
                                                        dataList5: dataList5,
                                                        dataList6: dataList6,
                                                    },
                                                },
                                            };

                                            BindWorkFlowDataOnUI(GetWorkFlowIDData);
                                        }
                                    }
                                }
                            }
                        }
                    });
                })
                .catch((error) => { });
        }
    };

    function fnGetWorkFlowStatus(WFData) {
        //
        let isRunning = false;
        if (WFData && WFData.length !== 0) {
            if (WFData?.[0]?.status?.toUpperCase() === "START") {
                setIsWorkFlowIsRunning(true);
                isRunning = true;
            } else {
                setIsWorkFlowIsRunning(false);
                isRunning = false;
            }
        } else {
            setIsWorkFlowIsRunning(false);
            isRunning = false;
        }
        return isRunning;
    }

    function BindWorkFlowDataOnUI(GetWorkFlowIDData) {
        if (GetWorkFlowIDData) {
            if (GetWorkFlowIDData?.isValidate) {
                let workflowpage = document.getElementById("wf_" + id);
                if (workflowpage) {
                    workflowpage.setAttribute("wfdata", "");
                }
                if (GetWorkFlowIDData.data.data.dataList1?.length > 0) {
                    let WorkFlowIsRunning = fnGetWorkFlowStatus(
                        GetWorkFlowIDData.data.data.dataList2,
                    );

                    setIsWorkFlowIsRunning(WorkFlowIsRunning);

                    setFlowDetails(GetWorkFlowIDData.data.data.dataList1[0]);
                    let schedularDataObj = {
                        "WorkFlowSchedule.timezone":
                            GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.timezone,
                        "WorkFlowSchedule.startondatetime": GetWorkFlowIDData?.data?.data
                            ?.dataList1?.[0]?.startondatetime
                            ? moment(
                                GetWorkFlowIDData?.data?.data?.dataList1?.[0]
                                    ?.startondatetime,
                            ).format("YYYY-MM-DD")
                            : "",
                        "WorkFlowSchedule.endondatetime": GetWorkFlowIDData?.data?.data
                            ?.dataList1?.[0]?.endondatetime
                            ? moment(
                                GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.endondatetime,
                            ).format("YYYY-MM-DD")
                            : "",
                        "WorkFlowSchedule.scheduledays":
                            GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.scheduledays,
                        "WorkFlowSchedule.schedulemonth":
                            GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.schedulemonth,
                        "WorkFlowSchedule.hour":
                            GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.schedulehour,
                        "WorkFlowSchedule.minute":
                            GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.scheduleminute,
                        "WorkFlowSchedule.weekdays":
                            GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.scheduleweekday,
                        "WorkFlowSchedule.cronexpression":
                            GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.cronexpression,
                        "filter.minute":
                            GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.scheduleminute ===
                                "all"
                                ? true
                                : false,
                        "filter.hour":
                            GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.schedulehour ===
                                "all"
                                ? true
                                : false,
                        "filter.date":
                            GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.scheduledays ===
                                "all"
                                ? true
                                : false,
                    };

                    setSchedularData(schedularDataObj);

                    // ----- Set Action Buttons colors :
                    if (
                        GetWorkFlowIDData.data.data.dataList1[0].argoworkflowstatus ===
                        "Suspend"
                    ) {
                        handleFlowOperations("Suspend");
                    } else if (
                        GetWorkFlowIDData.data.data.dataList1[0].argoworkflowstatus ===
                        "Active"
                    ) {
                        handleFlowOperations("Publish");
                    }
                    // -----
                    let d =
                        GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.workflownodejson &&
                        JSON.parse(
                            GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.workflownodejson,
                        );
                    let e =
                        GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.workflowedgejson &&
                        JSON?.parse(
                            GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.workflowedgejson,
                        );

                    if (e && e.length > 0) {
                        e.map(
                            (ed) =>
                            (ed.type =
                                ed.target_shortname !== "loopstart-0-0-0" &&
                                    ed.target_shortname !== "loopend-0-0-0"
                                    ? Edgetype
                                    : Defaultedgetype),
                        );
                    }
                    setWorkflowPopup(WorkFlowIsRunning);

                    if (WorkFlowIsRunning || ViewParam === "1") {
                        if (GetWorkFlowIDData.data.data.dataList3) {
                            for (
                                let m = 0;
                                m < GetWorkFlowIDData.data.data.dataList3.length;
                                m++
                            ) {
                                const dcopy = JSON.parse(JSON.stringify(d));
                                var mdata = GetWorkFlowIDData.data.data.dataList3[m];
                                if (
                                    mdata.workflowmachinename.toUpperCase() !== "EXIT" &&
                                    mdata.workflowmachinename.toUpperCase() !== "STARTER"
                                ) {
                                    var checkIsExist = dcopy.filter(
                                        (dd) => dd.shortName === mdata.workflowmachinename,
                                    );
                                    if (checkIsExist && checkIsExist.length === 0) {
                                        const samemachine = dcopy.filter(
                                            (dd) =>
                                                dd.shortName ===
                                                mdata.workflowmachinename.split("-Loop-")[0],
                                        );
                                        if (samemachine && samemachine.length > 0) {
                                            samemachine[0].id =
                                                samemachine[0].id +
                                                "_-Loop-" +
                                                mdata.workflowmachinename.split("-Loop-")[1];
                                            samemachine[0].shortName = mdata.workflowmachinename;
                                            samemachine[0].sameMachineNo = 0;
                                            //samemachine[0].typeName = mdata.machinename + '-' + mdata.workflowmachinename.replace(mdata.assemblyname, "").replace("Loop-", "");
                                            samemachine[0].typeName =
                                                commonservices.makeMachineDisplayName(
                                                    mdata.machinename,
                                                    0,
                                                    mdata.assemblyname,
                                                    mdata.workflowmachinename,
                                                );

                                            d.push(samemachine[0]);
                                        }
                                    }
                                }
                            }

                            for (let ld = 0; ld < d.length; ld++) {
                                if (d[ld].shortName.toUpperCase().indexOf("-LOOP-") >= 0) {
                                    let wf =
                                        GetWorkFlowIDData?.data?.data?.dataList1?.[0]
                                            ?.workflowjson &&
                                        JSON?.parse(
                                            GetWorkFlowIDData?.data?.data?.dataList1?.[0]
                                                ?.workflowjson,
                                        );

                                    if (wf && wf.dag && wf.dag.tasks) {
                                        let findmachine = wf.dag.tasks.filter(
                                            (t) =>
                                                t.name.split("-Loop-")[0] ===
                                                d[ld].shortName.split("-Loop-")[0],
                                        );
                                        if (findmachine && findmachine.length) {
                                            if (
                                                findmachine[0].fulldependencies &&
                                                findmachine[0].fulldependencies.length !== 0
                                            ) {
                                                for (
                                                    let depend = 0;
                                                    depend < findmachine[0].fulldependencies.length;
                                                    depend++
                                                ) {
                                                    let source_machinename =
                                                        findmachine[0].fulldependencies[depend] +
                                                        "-Loop-" +
                                                        d[ld].shortName.split("-Loop-")[1];
                                                    let findSourceMachine = d.filter(
                                                        (dd) => dd.shortName === source_machinename,
                                                    );
                                                    if (
                                                        findSourceMachine &&
                                                        findSourceMachine.length > 0
                                                    ) {
                                                        let new_e = {
                                                            id: GenerateGUID(),
                                                            source_machineid: findSourceMachine[0].machineid,
                                                            source_machinename: findSourceMachine[0].typeName,
                                                            source_image: findSourceMachine[0].image,
                                                            source_shortname: findSourceMachine[0].shortName,
                                                            source: findSourceMachine[0].id,
                                                            target: d[ld].id,
                                                            target_machineid: d[ld].machineid,
                                                            target_machinename: d[ld].typeName,
                                                            target_image: d[ld].image,
                                                            target_shortname: d[ld].shortName,
                                                            type: Edgetype,
                                                        };
                                                        e.push(new_e);
                                                    } else {
                                                        let FirstParent_source_machinename =
                                                            findmachine[0].fulldependencies[depend];

                                                        let FirstParent_findSourceMachine = d.filter(
                                                            (dd) =>
                                                                dd.shortName === FirstParent_source_machinename,
                                                        );
                                                        if (
                                                            FirstParent_findSourceMachine &&
                                                            FirstParent_findSourceMachine.length > 0
                                                        ) {
                                                            let new_e = {
                                                                id: GenerateGUID(),
                                                                source_machineid:
                                                                    FirstParent_findSourceMachine[0].machineid,
                                                                source_machinename:
                                                                    FirstParent_findSourceMachine[0].typeName,
                                                                source_image:
                                                                    FirstParent_findSourceMachine[0].image,
                                                                source_shortname:
                                                                    FirstParent_findSourceMachine[0].shortName,
                                                                source: FirstParent_findSourceMachine[0].id,
                                                                target: d[ld].id,
                                                                target_machineid: d[ld].machineid,
                                                                target_machinename: d[ld].typeName,
                                                                target_image: d[ld].image,
                                                                target_shortname: d[ld].shortName,
                                                                type: Edgetype,
                                                            };
                                                            e.push(new_e);
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        let loopend = d.filter(
                            (m) => m.template.toUpperCase() === "LOOPEND-0-0-0",
                        );

                        if (loopend && loopend.length > 0) {
                            let wf =
                                GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.workflowjson &&
                                JSON?.parse(
                                    GetWorkFlowIDData?.data?.data?.dataList1?.[0]?.workflowjson,
                                );
                            if (wf && wf.dag && wf.dag.tasks) {
                                let findmachine = wf.dag.tasks.filter(
                                    (t) => t.template.toUpperCase() === "LOOPEND-0-0-0",
                                );
                                if (findmachine && findmachine.length) {
                                    if (
                                        findmachine[0].fulldependencies &&
                                        findmachine[0].fulldependencies.length > 0
                                    ) {
                                        for (
                                            let el = 0;
                                            el < findmachine[0].fulldependencies.length;
                                            el++
                                        ) {
                                            let depmachine = d.filter(
                                                (t) =>
                                                    t.shortName.split("-Loop-")[0] ===
                                                    findmachine[0].fulldependencies[el].split(
                                                        "-Loop-",
                                                    )[0],
                                            );
                                            if (depmachine && depmachine.length > 0) {
                                                for (let nel = 0; nel < depmachine.length; nel++) {
                                                    let new_e = {
                                                        id: GenerateGUID(),
                                                        source_machineid: 0,
                                                        source_machinename: "",
                                                        source_image: "",
                                                        source_shortname: "",
                                                        source: depmachine[nel].id,
                                                        target: loopend[0].id,
                                                        target_machineid: 0,
                                                        target_machinename: "",
                                                        target_image: "",
                                                        target_shortname: "",
                                                        type: Edgetype,
                                                    };
                                                    e.push(new_e);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        let { nodes: layoutedNodes, edges: layoutedEdges } =
                            getLayoutedElements(d, e);

                        layoutedNodes = layoutedNodes?.map((item) => ({
                            ...item,
                            data: {
                                ...item?.data,
                                label: CreateModel(
                                    item?.image,
                                    item?.id,
                                    item?.typeName,
                                    item.shortName,
                                    WorkFlowIsRunning,
                                    item?.sameMachineNo,
                                    GetWorkFlowIDData?.data?.data?.dataList3,
                                    GetWorkFlowIDData?.data?.data?.dataList2,
                                    GetWorkFlowIDData.data.data.dataList1[0],
                                ),
                            },
                        }));

                        //-Loop-
                        layoutedNodes = layoutedNodes?.map((item) => ({
                            ...item,
                            className:
                                fnGetMachineStatus(
                                    item.shortName,
                                    GetWorkFlowIDData.data.data.dataList3,
                                    GetWorkFlowIDData.data.data.dataList2,
                                ) +
                                " " +
                                (item.id.indexOf("-Loop-") >= 0 ? "logical" : ""),
                        }));

                        if (WorkFlowIsRunning) {
                            if (workflowpage) {
                                workflowpage.setAttribute(
                                    "wfdata",
                                    JSON.stringify(GetWorkFlowIDData.data),
                                );
                            }
                            var runningMachineData = layoutedNodes.filter(
                                (i) => i.className.indexOf("start") >= 0,
                            );
                            if (
                                runningMachineData &&
                                runningMachineData !== null &&
                                runningMachineData.length > 0
                            ) {
                                handleNodeClick(
                                    "",
                                    runningMachineData[0],
                                    WorkFlowIsRunning,
                                    GetWorkFlowIDData.data.data.dataList3,
                                    GetWorkFlowIDData.data.data.dataList4,
                                );
                            }
                        }

                        setNodes(layoutedNodes);
                        setEdges(layoutedEdges);
                    } else {
                        d = d?.map((item) => ({
                            ...item,
                            data: {
                                ...item?.data,
                                label: CreateModel(
                                    item?.image,
                                    item?.id,
                                    item?.typeName,
                                    item.shortName,
                                    WorkFlowIsRunning,
                                    item?.sameMachineNo,
                                    GetWorkFlowIDData?.data?.data?.dataList3,
                                    GetWorkFlowIDData?.data?.data?.dataList2,
                                    GetWorkFlowIDData.data.data.dataList1[0],
                                ),
                            },
                        }));
                        d = d?.map((item) => ({
                            ...item,
                            className: fnGetMachineStatus(
                                item.shortName,
                                GetWorkFlowIDData.data.data.dataList3,
                                GetWorkFlowIDData.data.data.dataList2,
                            ),
                        }));
                        setNodes(d);
                        setEdges(e);
                    }

                    if (GetWorkFlowIDData.data.data.dataList1[0]?.workflowjson) {
                        let _workflowjson = JSON.parse(
                            GetWorkFlowIDData.data.data.dataList1[0]?.workflowjson,
                        );
                        if (_workflowjson?.loop_sample_data) {
                            let _loop_sample_data = JSON.parse(
                                _workflowjson?.loop_sample_data,
                            );
                            setLoop_sample_data(_loop_sample_data);
                        } else {
                            setLoop_sample_data([]);
                        }
                    } else {
                        setLoop_sample_data([]);
                    }

                    setFlowName(GetWorkFlowIDData.data.data.dataList1[0]?.workflowname);
                    setDescriptionName(
                        GetWorkFlowIDData.data.data.dataList1[0]?.description,
                    );
                    settag(GetWorkFlowIDData.data.data.dataList1[0]?.tag);
                    setCroneExpressionValue(
                        GetWorkFlowIDData.data.data.dataList1[0]?.cronexpression,
                    );
                    let _parametersforworkflow = [];
                    if (GetWorkFlowIDData.data.data.dataList1[0]?.parametersforworkflow) {
                        _parametersforworkflow = JSON.parse(
                            GetWorkFlowIDData.data.data.dataList1[0]?.parametersforworkflow,
                        );
                    }
                    setParametersForWorkflow(_parametersforworkflow);
                    setParallelism(GetWorkFlowIDData.data.data.dataList1[0]?.parallelism);
                    setRetrystrategy(
                        GetWorkFlowIDData.data.data.dataList1[0]?.retrystrategy,
                    );
                    setEksnodegroup(
                        GetWorkFlowIDData.data.data.dataList1[0]?.eksnodegroup,
                    );
                    setSubscribersinfrastructureautomationid(
                        GetWorkFlowIDData.data.data.dataList1[0]?.subscribersinfrastructureautomationid || "",
                    );

                    setWorkFlowMachineStatus(GetWorkFlowIDData.data.data.dataList3);
                    setWorkFlowMachineUse(GetWorkFlowIDData.data.data.dataList4);
                    setWorkFlowStatus(GetWorkFlowIDData.data.data.dataList2);
                }
                if (GetWorkFlowIDData.data.data.dataList5?.length > 0) {
                    setRoleAccess(GetWorkFlowIDData.data.data.dataList5);
                }
            }
        }
    }

    const { leftOffset, rightOffset } = calculateOffsets();

    useLayoutEffect(() => {
        getMachineListBySubscriberId();
    }, []);

    const handleOutsideClick = (event) => {
        if (
            overlayDesc_Ref.current &&
            !overlayDesc_Ref.current.contains(event.target) &&
            !target1.current.contains(event.target)
        ) {
            workFlowDiscriptionPopup(event); // Close the overlay
        }

        if (
            overlayCostusage_Ref.current &&
            !overlayCostusage_Ref.current.contains(event.target) &&
            !target.current.contains(event.target)
        ) {
            handleshowCostPopup(event); // Close the overlay
        }

        // if (
        //   overlayCont_Ref.current &&
        //   !overlayCont_Ref.current.contains(event.target) &&
        //   !target2.current.contains(event.target)
        // ) {
        //   handleshowContactPopup(event); // Close the overlay
        // }

        if (
            overlayNoti_Ref.current &&
            !overlayNoti_Ref.current.contains(event.target) &&
            !notification1.current.contains(event.target)
        ) {
            handleshowNotification(event); // Close the overlay
        }
    };

    useEffect(() => {
        if (workFlowDiscriptionPopupstate) {
            document.addEventListener("mousedown", handleOutsideClick);
        } else if (show) {
            document.addEventListener("mousedown", handleOutsideClick);
        } else if (showNotification) {
            document.addEventListener("mousedown", handleOutsideClick);
        } else {
            document.removeEventListener("mousedown", handleOutsideClick);
        }

        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [workFlowDiscriptionPopupstate, show, showContact, showNotification]);

    useEffect(() => {
        if (EncID) {
            let decData = commonservices.bodyDecryption(EncID?.id);

            // setId(parseInt(decData?.split("?")[0]));
            setIdData(decData?.split("?")[1]);
        }
    }, [EncID]);

    useEffect(() => {
        if (id) {
            fetchData(id);
            getProjectTermList();
            dispatch(GetWorkflowPrompt(id));
        }
    }, [Userdata, reload, EncID, id]);

    useEffect(() => {
        if (isWorkflowViewDashboard && id && id !== "0") {
            fnGetUsageTrendChartData(id);
            fnGetRecentRunsList(id);
        }
    }, [isWorkflowViewDashboard, id]);

    useEffect(() => {
        if (divRef.current) {
            divRef.current.scrollTop = divRef.current.scrollHeight;
        }
    }, [WorkFlowMachineStatus]);

    useEffect(() => {
        BindWorkFlowDataOnUI(GetWorkFlowIDData);
        return () => {
            dispatch(setGetWorkFlowByID());
        };
    }, [GetWorkFlowIDData]);

    useEffect(() => {
        if (IsWorkFlowIsRunning) {
            setActiveSidePanel(false);
            setActiveRightSidePanel("summary");
            setActiveRightSidePinnedPanel("summary");
        }
    }, [IsWorkFlowIsRunning]);

    useEffect(() => {
        if (id) {
            BindDataByID(id, "");
            if (id !== "0") {
                fetchWorkspaceList(id);
            }
        }
        if (ViewParam === "0" && callApi) {
            setActiveSidePanelPinned(true);
            setActiveSidePanel(true);
        }
    }, [allMachineDetails, reload, id, callApi]);

    useEffect(() => {
        if (id && allMachineDetails) {
            if (connection) {
                connection
                    .stop()
                    .then(() => { })
                    .catch((err) => { });
            }
            ConnectWithSignalR(id);
        }
    }, [id, allMachineDetails]);

    useEffect(() => {
        if (state) {
            setFlowName(state?.projectname);
            setDescriptionName(state?.description);
            setAiEnhanceState(state?.aiEnchance);
            settag(state?.tag || "");
            setWorkspaceInput(state?.workspaceInput || []);
            setWorkspaceForWorkflow(state?.workspaceListOpt || []);
            if (state?.aiEnchance) {
                setAIEnhanceLoader(true);
                dispatch(SuggestMachines({ query: state?.description }))?.then(
                    (res) => {
                        setAI_ActiveBox(res?.payload?.suggested_machines?.[0]?.machine_id);
                        setAIEnhanceLoader(false);
                    },
                );
            }
            // dispatch(VectorStore({id:"123"}))
        }
    }, [state, reload]);

    useEffect(() => {
        if (aiEnhanceState) {
            setActiveBottomSidePanelPinned(true);
            setActiveBottomSidePanel(true);
        }
    }, [aiEnhanceState]);

    const SiderWorkflowComponent = ({ running, view }) => {
        return (
            <>
                <div
                    className={`node-content newflow-node-content main-running-status-flownew`}
                >
                    <div className="flow-new-runningstatus">
                        <div className="running-statustitle">
                            {running ? <h4>Running</h4> : <h4>Last Run</h4>}
                        </div>{" "}
                    </div>
                    <div className="flowcard-detail-block-running">
                        <div className=" runningmachine-flowcard">
                            {WorkFlowStatus[0]?.starton && WorkFlowStatus[0]?.endon ? (
                                <>
                                    <div style={{ fontSize: "14px", fontWeight: "400" }}>
                                        {commonservices.convertDateToLocal(
                                            WorkFlowStatus[0]?.starton,
                                        )}{" "}
                                        {commonservices.convertTimeToLocal(
                                            WorkFlowStatus[0]?.starton,
                                        )}
                                    </div>
                                    <span>
                                        <CalculateWorkflowDurationSecInOtherFormat
                                            Seconds={GetSecondCounts(
                                                WorkFlowStatus[0]?.starton,
                                                WorkFlowStatus[0]?.endon,
                                            )}
                                        />
                                    </span>
                                </>
                            ) : (
                                <>
                                    {WorkFlowStatus[0]?.starton && (
                                        <CounterPage
                                            start={WorkFlowStatus[0]?.starton}
                                            current={WorkFlowStatus[0]?.currentdatetime}
                                            type="main"
                                        />
                                    )}
                                </>
                            )}
                        </div>
                        <div className="price-running-flowcard">
                            <>
                                {" "}
                                {running ? (
                                    <p className="d-flex gap-1 align-items-center">
                                        <AmountLoader initialAmount={"$0."} rotation={5} />
                                    </p>
                                ) : (
                                    <p className="d-flex gap-1 align-items-center price-running-price-title">
                                        {WorkFlowStatus[0]?.consumptioncost
                                            ? "$" + WorkFlowStatus[0]?.consumptioncost?.toFixed(5)
                                            : "$ 00.00"}
                                    </p>
                                )}
                            </>
                        </div>
                    </div>

                    <div className="datashow-machine-main workflowsummary-divider">
                        <div className="datamonthly">
                            <p>This week</p>

                            <CalculateMachineDurationSec
                                Seconds={parseInt(WorkFlowStatus[0]?.thisweek)}
                            />
                            <GetPersentageCount
                                lastweek={parseInt(WorkFlowStatus[0]?.lastweek || 0)}
                                thisweek={parseInt(WorkFlowStatus[0]?.thisweek || 0)}
                            />
                        </div>
                        <div className="datamonthly">
                            <p>This Month</p>

                            <CalculateMachineDurationSec
                                Seconds={parseInt(WorkFlowStatus[0]?.thismonth)}
                            />

                            <GetPersentageCount
                                lastweek={parseInt(WorkFlowStatus[0]?.lastmonth || 0)}
                                thisweek={parseInt(WorkFlowStatus[0]?.thismonth || 0)}
                            />
                        </div>
                        <div className="datamonthly">
                            <p>This year</p>

                            <CalculateMachineDurationSec
                                Seconds={parseInt(WorkFlowStatus[0]?.thisyear)}
                            />

                            <GetPersentageCount
                                lastweek={parseInt(WorkFlowStatus[0]?.lastyear || 0)}
                                thisweek={parseInt(WorkFlowStatus[0]?.thismonth || 0)}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    };

    const _DataProfileBlankObj = {
        SelfMachine: {
            outputfilename: "",
            inputsamplefile: "",
            machineid: 0,
            machinename: "",
            outputsamplefile: "",
            versionnumber: "",
            keypaths: [],
            json: null,
            input_data: "",
            machinelogo: "",
        },
        ParentMachine: [],
    };

    const [DataProfileDetails, setDataProfileDetails] =
        useState(_DataProfileBlankObj);

    const [IsOpenDataProfileConfiguration, setIsOpenDataProfileConfiguration] =
        useState(false);

    const FnOpenDataProfileMappingPopup = async (id) => {
        let configValidation = handleConfigValidation();
        if (configValidation?.nodeErrorArr?.length > 0) {
            setFlowLoader(false);
            setNodes(configValidation?.updatedNodes);
            handleNodeClick(
                "",
                configValidation?.nodeErrorArr?.[0],
                IsWorkFlowIsRunning,
                WorkFlowMachineStatus,
                WorkFlowMachineUse,
            );
            return;
        }

        setDataProfileDetails(_DataProfileBlankObj);
        let NoOfParent = edges.filter((item) => item.target === id);
        if (NoOfParent && NoOfParent.length > 0) {
            let ParentMachine = [];
            let SelfMachine = _DataProfileBlankObj.SelfMachine;
            let dataprofile_query = "";
            let condition_list = "";
            for (let i = 0; i < NoOfParent.length; i++) {
                if (i === 0) {
                    if (
                        NoOfParent[i].target_machineid &&
                        NoOfParent[i].target_shortname
                    ) {
                        let objmachine = allMachineList.dataList1.filter(
                            (m) => m.machineid === parseInt(NoOfParent[i].target_machineid),
                        );
                        if (objmachine && objmachine.length !== 0) {
                            let MachineName = commonservices.makeMachineDisplayName(
                                objmachine[0].machinename,
                                0,
                                objmachine[0].assemblyname,
                                NoOfParent[i].target_shortname,
                            );
                            SelfMachine.outputfilename =
                                NoOfParent[i].target_shortname + ".json";
                            SelfMachine.machineid = parseInt(NoOfParent[i].target_machineid);
                            SelfMachine.machinename = MachineName;
                            SelfMachine.outputsamplefile = objmachine[0].outputsamplefile;
                            SelfMachine.versionnumber = objmachine[0].versionnumber;
                            SelfMachine.inputsamplefile = objmachine[0].inputsamplefile;
                            SelfMachine.input_data = null;
                            SelfMachine.machinelogo = objmachine[0].machinelogo;
                            let SelfNode = nodes.filter((f) => f.id === id);
                            if (SelfNode && SelfNode.length > 0) {
                                let objForParaValue = {};

                                dataprofile_query = SelfNode[0].dataprofile_query;
                                condition_list = SelfNode[0].condition_list;
                                SelfNode[0].configData?.forEach((configItem) => {
                                    let valueForConfig = "";
                                    if (configItem?.value) {
                                        valueForConfig = configItem?.value;
                                    }
                                    if (configItem?.paratype === "Number" && configItem?.value) {
                                        valueForConfig = parseInt(configItem?.value);
                                    }
                                    if (configItem?.paratype === "Decimal" && configItem?.value) {
                                        valueForConfig = parseFloat(configItem?.value);
                                    }
                                    if (configItem?.paratype === "Json" && configItem?.value) {
                                        valueForConfig = JSON.parse(configItem?.value);
                                    }
                                    objForParaValue = {
                                        ...objForParaValue,
                                        [configItem?.parakey]: valueForConfig,
                                    };
                                });
                                SelfMachine.input_data = objForParaValue;
                            }
                        }
                    }
                }
                if (NoOfParent[i].source_machineid && NoOfParent[i].source_shortname) {
                    let checkDub = ParentMachine.filter(
                        (d) =>
                            d.outputfilename === NoOfParent[i].source_shortname + ".json",
                    );
                    if (checkDub.length === 0) {
                        let objmachine = allMachineList.dataList1.filter(
                            (m) => m.machineid === parseInt(NoOfParent[i].source_machineid),
                        );
                        if (objmachine && objmachine.length !== 0) {
                            let MachineName = commonservices.makeMachineDisplayName(
                                objmachine[0].machinename,
                                0,
                                objmachine[0].assemblyname,
                                NoOfParent[i].source_shortname,
                            );
                            ParentMachine.push({
                                outputfilename: NoOfParent[i].source_shortname + ".json",
                                machineid: parseInt(NoOfParent[i].source_machineid),
                                machinename: MachineName,
                                outputsamplefile: objmachine[0].outputsamplefile,
                                inputsamplefile: objmachine[0].inputsamplefile,
                                versionnumber: objmachine[0].versionnumber,
                                input_data: "",
                                machinelogo: objmachine[0].machinelogo,
                            });
                        }
                    }
                }
            }
            if (
                SelfMachine.input_data &&
                SelfMachine.input_data !== null &&
                SelfMachine.input_data !== undefined &&
                Object.keys(SelfMachine.input_data).length !== 0
            ) {
                setDataProfileDetails({
                    SelfMachine: SelfMachine,
                    ParentMachine: ParentMachine,
                    nodeid: id,
                    dataprofile_query: dataprofile_query,
                    condition_list: condition_list,
                });
                if (!isWorkflowViewDashboard) {
                    setIsOpenDataProfileConfiguration(true);
                }
            }
        }
    };

    const fnSetDataProfiling = (dataprofile_query, DataProfileDetails) => {
        let SelfNode = nodes.filter((f) => f.id === DataProfileDetails.nodeid);
        if (SelfNode && SelfNode.length > 0) {
            SelfNode[0].dataprofile_query = dataprofile_query;
        }
        setNodes(nodes);
    };

    const fnSetCondition = (condition_list, DataProfileDetails) => {
        let SelfNode = nodes.filter((f) => f.id === DataProfileDetails.nodeid);
        if (SelfNode && SelfNode.length > 0) {
            SelfNode[0].condition_list = condition_list;
        }
        setNodes(nodes);
    };

    const dashboardUniqueNodes = nodes?.filter(
        (item, index, self) =>
            index === self.findIndex((node) => node.typeid === item.typeid),
    );

    const dashboardLastRunTotal = (WorkFlowMachineStatus || []).reduce(
        (sum, item) => sum + (item?.consumptioncost || 0),
        0,
    );

    const dashboardPreviousRunTotal = (WorkFlowMachineStatus || []).reduce(
        (sum, item) => sum + (item?.avgconsumptioncost || 0),
        0,
    );

    return (
        <>
            {FlowLoader && <MainpageLoader />}
            <div
                className="flow-page-new projects-view-page-main having-small-blue-bg flow-chart-wrapper-main-content"
                id={"wf_" + id}
            >
                {ViewParam === "0" && (
                    <Walkthrough
                        callback={handleWalkthroughCallback}
                        steps={id == 0 ? steps : stepsActive}
                        run={!callApi}
                        ref={dropdownToggleRef}
                        keyName="workflowEngineering"
                    />
                )}
                <Container className="flow-chart-container">
                    <div className="flow-chart-container-inner">
                        <div className="top-bot-section drag-drop-page">
                            <div className="d-flex align-items-center gap-3">
                                <h6 className="d-flex align-items-center gap-1">
                                    <img
                                        src={homeImage}
                                        alt="home"
                                        title="home"
                                        style={{ cursor: "pointer", marginBottom: "3px" }}
                                        onClick={() => {
                                            if (!trackState) {
                                                navigate("/dashboard");
                                            } else {
                                                setTrackStatePopup(true);
                                            }
                                        }}
                                    />
                                    <span style={{ fontWeight: "400", color: "#666666" }}>
                                        {" | "}
                                    </span>
                                    <span>Workflow</span>
                                </h6>

                                <div className="d-flex align-items-center gap-2 ">
                                    <div className="position-relative tourWorkflowName">
                                        <input
                                            disabled={id && id !== "0" ? true : false}
                                            // disabled={ViewParam === "1" ? true : false}
                                            className={
                                                id && id !== "0"
                                                    ? "common-select-disabled save-main-input"
                                                    : "common-select save-main-input"
                                            }
                                            type="text"
                                            title={flowName}
                                            value={flowName}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                // const regEx = /^[a-z0-9 ]*$/i;
                                                const regEx = /^[a-z0-9\- ]*$/i;
                                                const isValid = regEx.test(val);
                                                if (val === "") {
                                                    setFlowName("");
                                                } else if (isValid) {
                                                    setFlowName(val);
                                                }
                                            }}
                                            placeholder="Workflow Name"
                                        />
                                        <span
                                            className="message-icon"
                                            style={{
                                                position: "absolute",
                                                top: "6px",
                                                cursor: "pointer",
                                                backgroundColor: "",
                                            }}
                                            onClick={(e) => {
                                                e.preventDefault();

                                                setworkFlowDiscriptionPopupstate(
                                                    !workFlowDiscriptionPopupstate,
                                                );
                                                workFlowDiscriptionPopup();
                                            }}
                                            ref={target1}
                                        >
                                            <img
                                                src={infoIcon}
                                                alt="infoIcon"
                                                style={{ width: "20px", height: "20px" }}
                                            />
                                        </span>
                                    </div>
                                    {workFlowDiscriptionPopupstate ? (
                                        <>
                                            <Overlay
                                                ref={overlayDesc_Ref}
                                                target={target1.current}
                                                show={workFlowDiscriptionPopupstate}
                                                placement="bottom"
                                            >
                                                {(props) => (
                                                    <Tooltip id="overlay-example" {...props}>
                                                        <WorflowDescription
                                                            handleshowPopup={workFlowDiscriptionPopup}
                                                            data={descriptionName}
                                                            id={id}
                                                            RedirectParam={RedirectParam}
                                                            BindDataByID={BindDataByID}
                                                            ViewParam={ViewParam}
                                                            editmode={editstatusfordes}
                                                            setEditMode={setEditstatusfordes}
                                                        />
                                                    </Tooltip>
                                                )}
                                            </Overlay>
                                        </>
                                    ) : (
                                        ""
                                    )}

                                    <>
                                        {FlowLoader ? (
                                            <button
                                                disabled={FlowLoader}
                                                className="blue-btn w-auto mr10"
                                            >
                                                {FlowLoader && "Loading..."}
                                            </button>
                                        ) : (
                                            <Dropdown className="public-private-dropdown ">
                                                <Dropdown.Toggle
                                                    disabled={IsWorkFlowIsRunning || loadingState}
                                                    id="isprivate"
                                                    className="tourWorkflowButtons"
                                                    style={{
                                                        backgroundColor: selOption.backColor, // "#2490d2",
                                                        color: selOption.foreColor, // "#2490d2",
                                                        border: selOption.backColor, // "1px solid #2490d2",
                                                    }}
                                                >
                                                    {selOption.btnTitle}
                                                </Dropdown.Toggle>

                                                {ViewParam === "0" ? (
                                                    <>
                                                        <Dropdown.Menu>
                                                            {ENUMS?.WorkflowBtnLabels?.map((Obj, idx) => (
                                                                <>
                                                                    <Dropdown.Item
                                                                        disabled={
                                                                            id === "0"
                                                                                ? Obj.title === "Publish" ||
                                                                                    Obj.title === "Save As"
                                                                                    ? true
                                                                                    : false
                                                                                : Obj.title === "Save" &&
                                                                                    flowDetails?.workflowsavestatus ===
                                                                                    "Publish"
                                                                                    ? true
                                                                                    : false
                                                                        }
                                                                        key={idx}
                                                                        onClick={(e) => {
                                                                            handleFlowOperations(Obj.title);
                                                                            if (
                                                                                Obj.savePayloadPassKey ===
                                                                                "CopyWorkFlow"
                                                                            ) {
                                                                                setIsActiveWorkFlowBtn(Obj.title);
                                                                                setShowSaveAsCopyModel(true);
                                                                            } else if (
                                                                                Obj.savePayloadPassKey === "Publish" ||
                                                                                Obj.savePayloadPassKey === "Draft"
                                                                            ) {
                                                                                handleWorkFlowSave(
                                                                                    Obj.savePayloadPassKey,
                                                                                );
                                                                                setIsActiveWorkFlowBtn(Obj.title);
                                                                            } else {
                                                                                if (
                                                                                    Obj.savePayloadPassKey === "delete"
                                                                                ) {
                                                                                    setModalShow(true);
                                                                                    setDeletePayload({
                                                                                        workflowid: flowDetails?.workflowid,
                                                                                        status: "delete",
                                                                                    });
                                                                                } else {
                                                                                    handleWorkFlowSaveStatusType(
                                                                                        Obj.savePayloadPassKey,
                                                                                    );
                                                                                }
                                                                            }
                                                                        }}
                                                                    >
                                                                        <h6>{Obj.title}</h6>
                                                                        <p>{Obj.description}</p>
                                                                    </Dropdown.Item>
                                                                </>
                                                            ))}

                                                            <hr className="m-0 mt-2 pb-2" />
                                                            {flowDetails?.argoworkflowstatus ===
                                                                "Suspend" && (
                                                                    <>
                                                                        <Dropdown.Item
                                                                            disabled={
                                                                                flowDetails?.workflowkey === null
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            onClick={() => {
                                                                                handleWorkFlowSaveStatusType("resume");
                                                                            }}
                                                                        >
                                                                            <h6>Resume</h6>
                                                                            <p>
                                                                                Restart a previously suspended workflow
                                                                                from its last saved state without losing
                                                                                progress.
                                                                            </p>
                                                                        </Dropdown.Item>
                                                                    </>
                                                                )}
                                                            {flowDetails?.argoworkflowstatus === "Active" && (
                                                                <>
                                                                    <Dropdown.Item
                                                                        disabled={
                                                                            flowDetails?.workflowkey === null
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        onClick={() => {
                                                                            handleWorkFlowSaveStatusType("suspend");
                                                                        }}
                                                                    >
                                                                        <h6>Suspend</h6>
                                                                        <p>
                                                                            Temporarily pause the workflow’s
                                                                            execution, keeping its progress intact for
                                                                            resumption later.
                                                                        </p>
                                                                    </Dropdown.Item>
                                                                </>
                                                            )}

                                                            <Dropdown.Item
                                                                disabled={
                                                                    !commonservices?.GetRoleAccessDetails(
                                                                        flowDetails?.rolename,
                                                                        roleAccess,
                                                                        "Workflow",
                                                                    )?.isdelete
                                                                        ? true
                                                                        : false
                                                                }
                                                                onClick={() => {
                                                                    setModalShow(true);
                                                                    setDeletePayload({
                                                                        workflowid: flowDetails?.workflowid,
                                                                        status: "delete",
                                                                    });
                                                                }}
                                                            >
                                                                <h6>Delete</h6>
                                                                <p>
                                                                    Permanently remove the workflow and all its
                                                                    associated data, making it unrecoverable.
                                                                </p>
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Dropdown.Menu>
                                                            <>
                                                                <Dropdown.Item
                                                                    disabled={
                                                                        !commonservices?.GetRoleAccessDetails(
                                                                            flowDetails?.rolename,
                                                                            roleAccess,
                                                                            "Workflow",
                                                                        )?.isupdate
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    className="mb-2"
                                                                    onClick={(e) => {
                                                                        let data = commonservices.bodyEncryption(
                                                                            `${id}?v=0&r=${RedirectParam}`,
                                                                        );
                                                                        navigate(
                                                                            `/flow-new/${data}
                                        `,
                                                                            {
                                                                                state: {
                                                                                    isViewMode: false,
                                                                                },
                                                                            },
                                                                        );
                                                                        BindDataByID(id, "");
                                                                        toast.success(
                                                                            "Switch to Edit mode Successfully.",
                                                                        );
                                                                        setActiveSidePanelPinned(true);
                                                                        setActiveSidePanel(true);
                                                                    }}
                                                                >
                                                                    <h6>{"Edit"}</h6>
                                                                    <p>{"Edit the Work-flow."}</p>
                                                                </Dropdown.Item>
                                                                <Dropdown.Item
                                                                    disabled={
                                                                        !commonservices?.GetRoleAccessDetails(
                                                                            flowDetails?.rolename,
                                                                            roleAccess,
                                                                            "Can Copy Workflow",
                                                                        )?.isview
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    className={"active"}
                                                                    onClick={(e) => {
                                                                        handleFlowOperations("Save As");
                                                                        setIsActiveWorkFlowBtn("Save As");
                                                                        setShowSaveAsCopyModel(true);
                                                                    }}
                                                                >
                                                                    <h6>{"Save As"}</h6>
                                                                    <p>
                                                                        {
                                                                            "Create a new copy of the workflow with a different name while keeping the original unchanged."
                                                                        }
                                                                    </p>
                                                                </Dropdown.Item>
                                                            </>
                                                        </Dropdown.Menu>
                                                    </>
                                                )}
                                            </Dropdown>
                                        )}
                                    </>

                                    {parseInt(id) !== 0 && (
                                        <div className="tourWorkflowButtonsStartWorkflow">
                                            {flowDetails?.workflowkey && (
                                                <>
                                                    {flowDetails?.argoworkflowstatus?.toUpperCase() ===
                                                        "DRAFT" ? (
                                                        <></>
                                                    ) : (
                                                        <>
                                                            {loadingState ? (
                                                                <button className="green-btn run-btn-dimension">
                                                                    Loading...
                                                                </button>
                                                            ) : flowDetails &&
                                                                flowDetails.runningworkflows &&
                                                                flowDetails.runningworkflows.indexOf("[") >=
                                                                0 ? (
                                                                <>
                                                                    {JSON.parse(flowDetails.runningworkflows)
                                                                        .length === 0 && (
                                                                            <button
                                                                                className="green-btn run-btn-dimension"
                                                                                onClick={() => {
                                                                                    fnRunworkflow(
                                                                                        "run",
                                                                                        flowDetails?.workflowkey,
                                                                                        flowDetails?.workflowid,
                                                                                        "",
                                                                                        flowDetails.currentdataworkflowulogid,
                                                                                    );
                                                                                    FnForsetActiveRightSidePinnedPanel(
                                                                                        "summary",
                                                                                    );
                                                                                }}
                                                                            >
                                                                                <span>Run Now</span>
                                                                                <img src={playicon} alt="playicon" />
                                                                            </button>
                                                                        )}
                                                                </>
                                                            ) : (
                                                                <button
                                                                    className="green-btn run-btn-dimension"
                                                                    onClick={() => {
                                                                        fnRunworkflow(
                                                                            "run",
                                                                            flowDetails?.workflowkey,
                                                                            flowDetails?.workflowid,
                                                                            "",
                                                                            flowDetails.currentdataworkflowulogid,
                                                                        );
                                                                        FnForsetActiveRightSidePinnedPanel(
                                                                            "summary",
                                                                        );
                                                                    }}
                                                                >
                                                                    <span>Run Now</span>
                                                                    <img src={playicon} alt="playicon" />
                                                                </button>
                                                            )}
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="top-bot-right-section">
                                {!callApi && (
                                    <div
                                        className="workflow-assignto"
                                        style={{ paddingLeft: "12px" }}
                                    >
                                        <div className="tourWorkflowCollaborators ps-2">
                                            {[1, 2, 3]?.map((item) => {
                                                return (
                                                    <img
                                                        src={profileicon}
                                                        alt={item}
                                                        key={item}
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = profileicon;
                                                        }}
                                                        style={{ cursor: "pointer" }}
                                                    />
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}
                                {commonservices?.GetRoleAccessDetails(
                                    flowDetails?.rolename || Userdata?.rolename,
                                    roleAccess,
                                    "Can Manage Member",
                                )?.isview &&
                                    callApi && (
                                        <>
                                            {id && id !== "0" && id !== 0 && (
                                                <>
                                                    {contactList?.length > 0 && (
                                                        <div
                                                            className={
                                                                showContact
                                                                    ? " overlay-isopen workflow-assignto"
                                                                    : "workflow-assignto"
                                                            }
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                // handleOverlay(e);
                                                                setShowContact(!showContact);
                                                                handleshowContactPopup();
                                                            }}
                                                            ref={target2}
                                                        >
                                                            {contactList?.length > 4
                                                                ? contactList
                                                                    ?.slice(0, 4)
                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <img
                                                                                src={
                                                                                    item?.profilepicurl || profileicon
                                                                                }
                                                                                alt={item?.contactname}
                                                                                title={item?.contactname}
                                                                                key={index}
                                                                                onError={(e) => {
                                                                                    e.target.onerror = null;
                                                                                    e.target.src = profileicon;
                                                                                }}
                                                                                style={{ cursor: "pointer" }}
                                                                            />
                                                                        );
                                                                    })
                                                                : contactList?.map((item, index) => {
                                                                    return (
                                                                        <img
                                                                            src={item?.profilepicurl || profileicon}
                                                                            alt={item?.contactname}
                                                                            title={item?.contactname}
                                                                            key={index}
                                                                            onError={(e) => {
                                                                                e.target.onerror = null;
                                                                                e.target.src = profileicon;
                                                                            }}
                                                                            style={{ cursor: "pointer" }}
                                                                        />
                                                                    );
                                                                })}
                                                            {contactList?.length > 4 && (
                                                                <span
                                                                    className="workflow-assignto-remaining-images"
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    +{contactList?.length - 4}
                                                                </span>
                                                            )}
                                                        </div>
                                                    )}
                                                    {showContact ? (
                                                        <>
                                                            <Overlay
                                                                ref={overlayCont_Ref}
                                                                target={target2.current}
                                                                show={showContact}
                                                                placement="bottom"
                                                            >
                                                                {(props) => (
                                                                    <Tooltip id="overlay-example" {...props}>
                                                                        <WorflowContactList
                                                                            fetchContactData={fetchData}
                                                                            handleshowPopup={handleshowContactPopup}
                                                                            isViewMode={ViewParam === "1"}
                                                                            id={id}
                                                                        />
                                                                    </Tooltip>
                                                                )}
                                                            </Overlay>
                                                        </>
                                                    ) : (
                                                        ""
                                                    )}
                                                </>
                                            )}
                                        </>
                                    )}

                                <div className="flow-area-dot-btns">
                                    <img
                                        src={dots}
                                        alt="dots"
                                        onClick={() => setVariant("dotted")}
                                        className={`dots-grid ${variant === "dotted" ? "active" : ""
                                            }`}
                                    />
                                    <img
                                        src={grid}
                                        alt="dots"
                                        onClick={() => setVariant("lines")}
                                        className={`dots-grid ${variant === "lines" ? "active" : ""
                                            }`}
                                    />
                                </div>
                                {!callApi && (
                                    <div
                                        className="filtering-main tourWorkflowNotifications gap-1 d-flex"
                                        id="notification-main"
                                    >
                                        <img src={notification} alt="notification" />
                                        <span>Notifications</span>
                                    </div>
                                )}
                                {id !== 0 && callApi && (
                                    <div
                                        className={
                                            showNotification
                                                ? "filtering-main overlay-isopen"
                                                : "filtering-main"
                                        }
                                        id="notification-main-three"
                                        onClick={(e) => {
                                            e.preventDefault();

                                            setShowNotification(!showNotification);
                                            handleshowNotification();
                                        }}
                                        ref={notification1}
                                    >
                                        <img src={notification} alt="notification" />
                                        <span>Notifications</span>
                                    </div>
                                )}
                                {!callApi && (
                                    <div
                                        className="filtering-main tourWorkflowSchedular gap-1 d-flex"
                                        id="scheduler"
                                    >
                                        <img src={schedular} alt="schedular" />
                                        <span>Scheduler</span>
                                    </div>
                                )}
                                {commonservices?.GetRoleAccessDetails(
                                    flowDetails?.rolename || Userdata?.rolename,
                                    roleAccess,
                                    "Can Manage Scheduler",
                                )?.isview &&
                                    callApi && (
                                        <div
                                            className={
                                                showSchedularPopup
                                                    ? "filtering-main overlay-isopen"
                                                    : "filtering-main"
                                            }
                                            id="scheduler-three"
                                            onClick={(e) => {
                                                e.preventDefault();

                                                setShowSchedularPopup(!showSchedularPopup);
                                                handleshowSchedularPopup();
                                            }}
                                            ref={targetSchedular}
                                        >
                                            <img src={schedular} alt="schedular" />
                                            <span>Scheduler</span>
                                        </div>
                                    )}
                                {!callApi && (
                                    <div
                                        className="filtering-main tourWorkflowCostAndUsgae gap-1 d-flex"
                                        id="cost-usage"
                                    >
                                        <img src={dollar} alt="dollar" />
                                        <span>Cost & Usage</span>
                                    </div>
                                )}
                                {!callApi && (
                                    <div className="filtering-main tourWorkflowLogs gap-1 d-flex">
                                        <img src={workflowSetting} alt="dollar" />
                                        <span>Log</span>
                                    </div>
                                )}

                                {id !== 0 && (
                                    <>
                                        {commonservices?.GetRoleAccessDetails(
                                            flowDetails?.rolename || Userdata?.rolename,
                                            roleAccess,
                                            "Can View Cost and Usage",
                                        )?.isview &&
                                            callApi && (
                                                <div
                                                    className={
                                                        show
                                                            ? "filtering-main overlay-isopen"
                                                            : "filtering-main"
                                                    }
                                                    id="cost-usage-three"
                                                    onClick={(e) => {
                                                        e.preventDefault();

                                                        setShow(!show);
                                                        handleshowCostPopup(e);
                                                    }}
                                                    ref={target}
                                                >
                                                    <img src={dollar} alt="dollar" />
                                                    <span>Cost & Usage</span>
                                                </div>
                                            )}

                                        {callApi && (
                                            <div
                                                className={
                                                    modalShow1
                                                        ? "filtering-main overlay-isopen"
                                                        : "filtering-main"
                                                }
                                                id="log-usage-three"
                                                onClick={() => setModalShow1(!modalShow1)}
                                            >
                                                <img src={workflowSetting} alt="dollar" />
                                                <span>Log</span>
                                            </div>
                                        )}
                                    </>
                                )}

                                <div
                                    className={
                                        supportShowModel
                                            ? "filtering-main overlay-isopen tourWorkflowSupport gap-1 d-flex cursor-pointer"
                                            : "filtering-main tourWorkflowSupport gap-1 d-flex cursor-pointer"
                                    }
                                    id="Support-usage-three"
                                    onClick={() => setSupportShowModel(!supportShowModel)}
                                >
                                    <img src={supportmodule} alt="supportmodule" />
                                    <span>Support</span>
                                </div>

                                <div
                                    ref={targetConfig}
                                    id="add-project"
                                    className={
                                        showConfigPopup
                                            ? "filtering-main position-relative  overlay-isopen tourWorkflowConfig gap-1 d-flex cursor-pointer"
                                            : "filtering-main position-relative tourWorkflowConfig gap-1 d-flex cursor-pointer"
                                    }
                                    onClick={(e) => {
                                        e.preventDefault();

                                        setShowConfigPopup(!showConfigPopup);
                                        handleShowConfigPopup();
                                    }}
                                >
                                    <img src={configmodule} alt="configmodule" />
                                    <span>Config </span>
                                </div>

                                {showConfigPopup && (
                                    <Overlay
                                        target={targetConfig.current}
                                        show={showConfigPopup}
                                        placement="bottom-end"
                                    >
                                        {(props) => (
                                            <Tooltip id="overlay-example" {...props}>
                                                <ConfigModel
                                                    workspaceList={workspaceForWorkflow}
                                                    hooktype="trigger-run-workflow"
                                                    associationid={id}
                                                    associationtype="Workflow"
                                                    handleshowPopup={handleShowConfigPopup}
                                                    isViewMode={ViewParam === "1"}
                                                    workflowdata={{
                                                        parallelism: parallelism,
                                                        retrystrategy: retrystrategy,
                                                        workspaceInput,
                                                        parametersforworkflow:
                                                            parametersforworkflow &&
                                                                parametersforworkflow.length > 0
                                                                ? parametersforworkflow
                                                                : [
                                                                    {
                                                                        name: "",
                                                                        value: "",
                                                                        isvalid: "",
                                                                        isvalidName: "",
                                                                    },
                                                                ],
                                                        eksnodegroup: eksnodegroup,
                                                        subscribersinfrastructureautomationid: subscribersinfrastructureautomationid,
                                                    }}
                                                    configurationsave={WorkflowConfigSave}
                                                    viewOption={"General,Parameters,Webhook"}
                                                />
                                            </Tooltip>
                                        )}
                                    </Overlay>
                                )}

                                <div
                                    className="filtering-main-close"
                                    id="close"
                                    onClick={(e) => {
                                        if (!trackState) {
                                            if (connection) {
                                                connection
                                                    .stop()
                                                    .then(() => { })
                                                    .catch((err) => { });
                                            }
                                            if (RedirectParam === "dc" || RedirectParam === "dl") {
                                                navigate("/dashboard", {
                                                    state: {
                                                        param: RedirectParam,
                                                    },
                                                });
                                            } else if (
                                                RedirectParam === "wc" ||
                                                RedirectParam === "wl"
                                            ) {
                                                navigate("/workflows", {
                                                    state: {
                                                        param: RedirectParam,
                                                    },
                                                });
                                            } else if (RedirectParam === "sl") {
                                                navigate("/scheduler", {
                                                    state: {
                                                        param: RedirectParam,
                                                    },
                                                });
                                            } else if (RedirectParam === "wa") {
                                                navigate("/management-listing", {
                                                    state: "workflow",
                                                });
                                            } else {
                                                navigate("/dashboard");
                                            }
                                        } else {
                                            setTrackStatePopup(true);
                                        }
                                    }}
                                >
                                    <img src={closeImage} alt="close" />
                                </div>

                                {show && (
                                    <Overlay
                                        ref={overlayCostusage_Ref}
                                        target={target.current}
                                        show={show}
                                        placement="bottom-end"
                                    >
                                        {(props) => (
                                            <Tooltip id="overlay-example" {...props}>
                                                <CostAndUsagePopup
                                                    handleshowPopup={handleshowCostPopup}
                                                    workflowid={id}
                                                />
                                            </Tooltip>
                                        )}
                                    </Overlay>
                                )}
                                {showNotification && (
                                    <Overlay
                                        ref={overlayNoti_Ref}
                                        target={notification1.current}
                                        show={showNotification}
                                        placement="bottom-end"
                                    >
                                        {(props) => (
                                            <Tooltip id="overlay-example" {...props}>
                                                <NotificationPopup
                                                    closePopup={handleshowNotification}
                                                    associationId={id}
                                                    associationType="workflow"
                                                />
                                            </Tooltip>
                                        )}
                                    </Overlay>
                                )}
                                {showSchedularPopup && (
                                    <Overlay
                                        target={targetSchedular.current}
                                        show={handleshowSchedularPopup}
                                        placement="bottom"
                                    >
                                        <Tooltip id="overlay-example">
                                            <SchedularPopup
                                                id={id}
                                                FnForSetTrackState={FnForSetTrackState}
                                                isViewMode={ViewParam === "1"}
                                                handleshowPopup={handleshowSchedularPopup}
                                                flowName={flowName ? flowName.trim() : flowName}
                                                CronParseValues={CronParseValues}
                                                handleSubmit={handleSchedularSubmit}
                                                schedularData={schedularData}
                                            />
                                        </Tooltip>
                                    </Overlay>
                                )}
                            </div>
                        </div>
                    </div>
                </Container>
                <>
                    <div
                        className={`container ${isWorkflowViewDashboard ? "workflow-view-dashboard" : ""
                            }`}
                    >
                        {/* Left Panel */}
                        <div
                            className={`panel left-panel ${activeSidePanel ? "open" : "closed"
                                }`}
                        >
                            <div className="panel-header d-flex align-items-center justify-content-between drag-drop-page-side-panel-header gap-2">
                                <h6
                                    className="tourWorkflowMachines"
                                    onClick={() => {
                                        if (ViewParam === "0" && !IsWorkFlowIsRunning) {
                                            handleSidepanelClick();
                                        }
                                    }}
                                >
                                    <span>Machines</span>
                                </h6>{" "}
                                {activeSidePanel && (
                                    <div className="search-pin-box">
                                        {" "}
                                        <div className="header-search-input">
                                            <InputGroup>
                                                <InputGroup.Text id="basic-addon1">
                                                    <img
                                                        src={searchicon}
                                                        alt="searchicon"
                                                        className="cursor-pointer"
                                                    />
                                                </InputGroup.Text>
                                                <Form.Control
                                                    placeholder="Search Machines"
                                                    aria-label="Search"
                                                    aria-describedby="basic-addon1"
                                                    onChange={(e) => setSearchInput(e.target.value)}
                                                />
                                            </InputGroup>
                                        </div>
                                        <div>
                                            <img
                                                style={{ width: "18px" }}
                                                src={activeSidePanelPinned ? pinned : unpinned}
                                                alt="analatics"
                                                onClick={() =>
                                                    activeSidePanelPinned
                                                        ? setActiveSidePanelPinned(false)
                                                        : setActiveSidePanelPinned(true)
                                                }
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="panel-content">
                                <div className="drag-drop-page-side-panel-accordion">
                                    {machineDataLoading ? (
                                        <div>
                                            <Loader type={LoaderType.Line} count={8} />
                                        </div>
                                    ) : machineList ? (
                                        <>
                                            <div className="drag-drop-page-side-panel-accordion-all">
                                                {Object?.entries(machineList)?.map(
                                                    ([key, value], index) => {
                                                        return (
                                                            <>
                                                                <Accordion defaultActiveKey={["0"]} alwaysOpen>
                                                                    <Accordion.Item eventKey={index?.toString()}>
                                                                        <Accordion.Header>
                                                                            {key +
                                                                                ` (${searchInput
                                                                                    ? value?.filter((machineItem) =>
                                                                                        machineItem?.machinename
                                                                                            .toLowerCase()
                                                                                            .includes(
                                                                                                searchInput.toLowerCase(),
                                                                                            ),
                                                                                    ).length
                                                                                    : value?.length
                                                                                })`}
                                                                        </Accordion.Header>
                                                                        <Accordion.Body>
                                                                            <div className="draggable-items-container">
                                                                                {value?.length > 0 ? (
                                                                                    value.some((machineItem) =>
                                                                                        machineItem?.machinename
                                                                                            .toLowerCase()
                                                                                            .includes(
                                                                                                searchInput.toLowerCase(),
                                                                                            ),
                                                                                    ) ? (
                                                                                        value.map((machineItem) => {
                                                                                            return (
                                                                                                <>
                                                                                                    {machineItem?.machinename
                                                                                                        .toLowerCase()
                                                                                                        .includes(
                                                                                                            searchInput.toLowerCase(),
                                                                                                        ) && (
                                                                                                            <div
                                                                                                                title={
                                                                                                                    machineItem?.machinename
                                                                                                                }
                                                                                                                key={
                                                                                                                    machineItem?.machineid
                                                                                                                }
                                                                                                                className="draggable-item"
                                                                                                                onDragStart={(event) => {
                                                                                                                    if (
                                                                                                                        IsWorkFlowIsRunning
                                                                                                                    ) {
                                                                                                                        toast.error(
                                                                                                                            "You are not able to modify workflow when the workflow is running.",
                                                                                                                        );
                                                                                                                    } else {
                                                                                                                        event.dataTransfer.setData(
                                                                                                                            "application/reactflow",
                                                                                                                            JSON.stringify(
                                                                                                                                machineItem,
                                                                                                                            ),
                                                                                                                        );
                                                                                                                    }
                                                                                                                }}
                                                                                                                draggable={
                                                                                                                    !IsWorkFlowIsRunning
                                                                                                                }
                                                                                                            >
                                                                                                                <div>
                                                                                                                    <div className="align-items-start justify-content-between d-flex">
                                                                                                                        <span>
                                                                                                                            <img
                                                                                                                                src={
                                                                                                                                    machineItem?.machinelogo ||
                                                                                                                                    DemoLogo
                                                                                                                                }
                                                                                                                                alt={
                                                                                                                                    machineItem?.machinename
                                                                                                                                }
                                                                                                                                style={{
                                                                                                                                    height: "28px",
                                                                                                                                    width: "28px",
                                                                                                                                    objectFit:
                                                                                                                                        "contain",
                                                                                                                                }}
                                                                                                                                onError={(e) => {
                                                                                                                                    e.target.onerror =
                                                                                                                                        null; // Prevents infinite loop in case fallback also fails
                                                                                                                                    e.target.src =
                                                                                                                                        DemoLogo;
                                                                                                                                }}
                                                                                                                            />
                                                                                                                        </span>
                                                                                                                        {machineItem?.isdisplayversionnumber ===
                                                                                                                            1 && (
                                                                                                                                <span
                                                                                                                                    className={`green-badge versionmachine ${machineItem?.versionnumber} ${key.replace(" ", "")}`}
                                                                                                                                >
                                                                                                                                    {machineItem?.versionnumber
                                                                                                                                        ? machineItem?.versionnumber
                                                                                                                                        : ""}
                                                                                                                                </span>
                                                                                                                            )}
                                                                                                                    </div>
                                                                                                                    <p
                                                                                                                        style={{
                                                                                                                            fontSize: "10px",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {
                                                                                                                            machineItem?.machinename
                                                                                                                        }
                                                                                                                    </p>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        )}
                                                                                                </>
                                                                                            );
                                                                                        })
                                                                                    ) : (
                                                                                        <div className="text-center no-machines-found w-100">
                                                                                            No Data Found
                                                                                        </div>
                                                                                    )
                                                                                ) : (
                                                                                    <div className="text-center no-machines-found w-100">
                                                                                        No Data Found
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </Accordion.Body>
                                                                    </Accordion.Item>
                                                                </Accordion>
                                                            </>
                                                        );
                                                    },
                                                )}
                                            </div>

                                            <div className="workflow-notdata">
                                                <div className="more-machine-main d-flex">
                                                    <div className="more-machine-icon mr-2">
                                                        <img src={buymoremachine} alt="buymoremachine" />
                                                    </div>
                                                    <div className="more-machine-detail">
                                                        <h3>Buy More Machines</h3>
                                                        <p>
                                                            Boost your data processing power adding more
                                                            machines for faster & scalable insights.
                                                        </p>
                                                    </div>
                                                </div>
                                                <button
                                                    onClick={() => navigate("/marketplace")}
                                                    disabled={FlowLoader}
                                                    className="blue-btn  mt-3"
                                                >
                                                    Explore Marketplace
                                                </button>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="not-machine-aval">
                                            <img
                                                src={notmachineavaliable}
                                                alt="notmachineavaliable"
                                            />
                                            <h2>No Machines Available</h2>
                                            <p>
                                                It looks like you don’t have any machines yet. Browse
                                                our marketplace to find the perfect machine for your
                                                needs.
                                            </p>
                                            <button
                                                onClick={() => navigate("/marketplace")}
                                                disabled={FlowLoader}
                                                className="blue-btn w-auto mt-3 "
                                            >
                                                Explore Marketplace
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Right Panel */}
                        <div className="right-panel-sticky-menu">
                            {!callApi && (
                                <>
                                    <h6 className="tourWorkflowMachineSetup">Machine Setup</h6>
                                    <h6 className="tourWorkflowStatus">Status</h6>
                                    <h6 className="tourWorkflowCostSummary">Cost Summary</h6>
                                </>
                            )}
                            {commonservices?.GetRoleAccessDetails(
                                flowDetails?.rolename || Userdata?.rolename,
                                roleAccess,
                                "Can Manage Machine Setup",
                            )?.isview &&
                                callApi && (
                                    <h6
                                        className={
                                            activeRightSidePanel === "machine"
                                                ? "tourWorkflowMachineSetup cursor-pointer right-panel-sticky-menu-Active"
                                                : "tourWorkflowMachineSetup cursor-pointer"
                                        }
                                        onClick={() => {
                                            if (activeRightSidePanel === "machine") {
                                                setActiveRightSidePanel("sm-panel");
                                            } else {
                                                setActiveRightSidePanel("machine");
                                            }
                                        }}
                                    >
                                        Machine Setup
                                    </h6>
                                )}
                            {commonservices?.GetRoleAccessDetails(
                                flowDetails?.rolename || Userdata?.rolename,
                                roleAccess,
                                "Can Manage Status",
                            )?.isview &&
                                callApi &&
                                id > 0 && (
                                    <h6
                                        className={
                                            activeRightSidePanel === "summary"
                                                ? "tourWorkflowMachineSetup cursor-pointer right-panel-sticky-menu-Active"
                                                : "tourWorkflowMachineSetup cursor-pointer"
                                        }
                                        onClick={() => {
                                            if (activeRightSidePanel === "summary") {
                                                setActiveRightSidePanel("sm-panel");
                                            } else {
                                                setActiveRightSidePanel("summary");
                                            }
                                        }}
                                    >
                                        Status
                                    </h6>
                                )}
                            {commonservices?.GetRoleAccessDetails(
                                flowDetails?.rolename || Userdata?.rolename,
                                roleAccess,
                                "Can View Cost Summary",
                            )?.isview &&
                                callApi && (
                                    <h6
                                        className={
                                            activeRightSidePanel === "costSummary"
                                                ? "tourWorkflowMachineSetup cursor-pointer right-panel-sticky-menu-Active"
                                                : "tourWorkflowMachineSetup cursor-pointer"
                                        }
                                        onClick={() => {
                                            if (activeRightSidePanel === "costSummary") {
                                                setActiveRightSidePanel("sm-panel");
                                            } else {
                                                setActiveRightSidePanel("costSummary");
                                            }
                                        }}
                                    >
                                        Cost Summary
                                    </h6>
                                )}
                        </div>
                        <div
                            className={`panel right-panel ${activeRightSidePanel !== "sm-panel" ? "open" : "closed"
                                }`}
                        >
                            {activeRightSidePanel === "summary" && (
                                <WorkFlowStatusModel
                                    NetworkUsageChart={NetworkUsageChart}
                                    MemoryUsageChart={MemoryUsageChart}
                                    CPUUsageChart={CPUUsageChart}
                                    id={id}
                                    NewMachineInfo={NewMachineInfo}
                                    FnForsetIsWorkFlowIsRunning={setIsWorkFlowIsRunning}
                                    IsWorkFlowIsRunning={IsWorkFlowIsRunning}
                                    FnForsetActiveRightSidePanel={setActiveRightSidePanel}
                                    activeRightSidePinnedPanel={activeRightSidePinnedPanel}
                                    FnForsetActiveRightSidePinnedPanel={
                                        FnForsetActiveRightSidePinnedPanel
                                    }
                                    flowDetails={flowDetails}
                                    BindDataByID={BindDataByID}
                                    FunForsetActiveSidePanelPinned={
                                        FunForsetActiveSidePanelPinned
                                    }
                                    FunForsetActiveSidePanel={FunForsetActiveSidePanel}
                                    laststatus={""}
                                    isViewMode={isWorkflowViewDashboard}
                                />
                            )}
                            {activeRightSidePanel === "costSummary" && (
                                <WorkflowCostSummaryModel
                                    isViewMode={isWorkflowViewDashboard}
                                    activeRightSidePinnedPanel={activeRightSidePinnedPanel}
                                    FnForsetActiveRightSidePanel={setActiveRightSidePanel}
                                    FnForsetActiveRightSidePinnedPanel={
                                        FnForsetActiveRightSidePinnedPanel
                                    }
                                    nodes={nodes}
                                    WorkFlowMachineStatus={WorkFlowMachineStatus}
                                />
                            )}
                            {activeRightSidePanel === "machine" && (
                                <WorkFlowMachineSetupModel
                                    isViewMode={isWorkflowViewDashboard}
                                    selectedNode={selectedNode}
                                    FnForSetTrackState={FnForSetTrackState}
                                    activeRightSidePinnedPanel={activeRightSidePinnedPanel}
                                    NewMachineInfo={NewMachineInfo}
                                    activeTab={activeTab}
                                    state={{ ...(state || {}), isViewMode: isWorkflowViewDashboard }}
                                    FnForsetActiveRightSidePanel={setActiveRightSidePanel}
                                    FnForsetActiveRightSidePinnedPanel={
                                        FnForsetActiveRightSidePinnedPanel
                                    }
                                    nodes={nodes}
                                    FnForSetNodes={FnForSetNodes}
                                    FnForsetSelectedNode={FnForsetSelectedNode}
                                    ProjectTermList={ProjectTermList}
                                    allMachineList={allMachineList}
                                    parametersforworkflow={parametersforworkflow}
                                    loop_sample_data={loop_sample_data}
                                    edges={edges}
                                />
                            )}
                        </div>

                        <div
                            className={
                                isWorkflowViewDashboard
                                    ? "workflow-dashboard-top-row"
                                    : "workflow-dashboard-row-pass-through"
                            }
                        >
                            <div
                                className={`workflow-content ${isDiagramFullScreen ? "workflow-diagram-fullscreen" : ""
                                    }`}
                                style={{
                                    left: isWorkflowViewDashboard ? "auto" : `${leftOffset}px`,
                                    right: isWorkflowViewDashboard ? "auto" : `${rightOffset}px`,
                                    padding: isWorkflowViewDashboard ? "0px" : "12px",
                                }}
                            >
                                {isWorkflowViewDashboard && (
                                    <div className="workflow-dashboard-card-header">
                                        <div className="d-flex align-items-center gap-2">
                                            <h2>
                                                <img
                                                    src={wfMain}
                                                    alt="Workflow Diagram"
                                                    className="workflow-card-header-icon"
                                                />
                                                Workflow Diagram
                                            </h2>
                                            <button
                                                type="button"
                                                className="workflow-diagram-fullscreen-toggle-btn"
                                                onClick={() =>
                                                    setIsDiagramFullScreen(!isDiagramFullScreen)
                                                }
                                                title={
                                                    isDiagramFullScreen
                                                        ? "Exit Full Screen"
                                                        : "Full Screen"
                                                }
                                                aria-label={
                                                    isDiagramFullScreen
                                                        ? "Exit Full Screen"
                                                        : "Full Screen"
                                                }
                                            >
                                                {isDiagramFullScreen ? (
                                                    <svg
                                                        width="14"
                                                        height="14"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="2.2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    >
                                                        <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3" />
                                                    </svg>
                                                ) : (
                                                    <svg
                                                        width="14"
                                                        height="14"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="2.2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    >
                                                        <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" />
                                                    </svg>
                                                )}
                                            </button>
                                            {isCurrentlyRunning && (
                                                <div
                                                    className="workflow-running-indicator"
                                                    title="Workflow is currently running"
                                                >
                                                    <span className="workflow-running-pulse-dot"></span>
                                                    <span className="workflow-running-text">Running</span>
                                                    <span className="workflow-running-dots">
                                                        <span className="dot dot-1">.</span>
                                                        <span className="dot dot-2">.</span>
                                                        <span className="dot dot-3">.</span>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                        {isDiagramFullScreen && (
                                            <button
                                                type="button"
                                                className="workflow-diagram-fullscreen-close-btn"
                                                onClick={() => setIsDiagramFullScreen(false)}
                                                title="Close Full Screen (Esc)"
                                                aria-label="Close Full Screen (Esc)"
                                            >
                                                <svg
                                                    width="16"
                                                    height="16"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                >
                                                    <line x1="18" y1="6" x2="6" y2="18" />
                                                    <line x1="6" y1="6" x2="18" y2="18" />
                                                </svg>
                                            </button>
                                        )}
                                    </div>
                                )}
                                <div
                                    className="flow-area"
                                    onClick={() => {
                                        setActiveRightSidePanel(activeRightSidePinnedPanel);
                                        setActiveSidePanel(activeSidePanelPinned);
                                        setActiveBottomSidePanel(activeBottomSidePanelPinned);
                                    }}
                                >
                                    <div
                                        className={
                                            activeBottomSidePanel
                                                ? "canvas-workflow-wrapper"
                                                : "canvas-workflow-wrapper-close"
                                        }
                                        id={"canvas-workflow-wrapper"}
                                    >
                                        <ReactFlow
                                            id={"canvas-workflow-wrapper-ReactFlow"}
                                            defaultZoom={isWorkflowViewDashboard ? 0 : 1}
                                            snapToGrid={true}
                                            nodes={nodes}
                                            edges={edges}
                                            onNodesChange={handleWorkflowNodesChange}
                                            onEdgesChange={(edge) => {
                                                onEdgesChange(edge);
                                            }}
                                            onConnect={onConnect}
                                            onDrop={onDrop}
                                            onDragOver={onDragOver}
                                            onConnectStart={onConnectStart}
                                            onConnectEnd={onConnectEnd}
                                            onNodeClick={(event, node) =>
                                                handleNodeClick(
                                                    event,
                                                    node,

                                                    ViewParam === "1" ? true : IsWorkFlowIsRunning,
                                                    WorkFlowMachineStatus,
                                                    WorkFlowMachineUse,
                                                )
                                            }
                                            onEdgeClick={(Event, Edge) =>
                                                handleEdgeClick(Event, Edge)
                                            }
                                            onNodeMouseEnter={handleNodeMouseEnter}
                                            onNodeMouseLeave={handleNodeMouseLeave}
                                            onEdgeMouseEnter={handleEdgeMouseEnter}
                                            onEdgeMouseLeave={handleEdgeMouseLeave}
                                            edgeTypes={edgeTypes}
                                            style={{ backgroundColor: "#FFFFFF" }}
                                        >
                                            <Background color="gray" gap={30} variant={variant} />
                                            <Controls />

                                            <MiniMap nodeClassName={(node) => node.className} />

                                        </ReactFlow>

                                        {!isWorkflowViewDashboard &&
                                            (getWorkflowPopup || ViewParam === "1") &&
                                            flowDetails && (
                                                <div
                                                    className={
                                                        getWorkflowPopup
                                                            ? "reactflow-running-right main-running-status-flownew flowrunningstatus"
                                                            : "reactflow-running-right"
                                                    }
                                                >
                                                    <SiderWorkflowComponent
                                                        running={getWorkflowPopup}
                                                        view={ViewParam}
                                                    />
                                                </div>
                                            )}
                                        {!isWorkflowViewDashboard &&
                                            flowDetails &&
                                            flowDetails.runningworkflows &&
                                            flowDetails.runningworkflows.indexOf("[") >= 0 && (
                                                <>
                                                    <div className="workflowpage-allrunning-workflow">
                                                        <div className="workflowpage-allrunning-workflow-header">
                                                            Parallel Running Workflow (
                                                            {JSON.parse(flowDetails.runningworkflows).length})
                                                        </div>
                                                        <div className="workflowpage-allrunning-workflow-item-container">
                                                            {JSON.parse(flowDetails.runningworkflows).map(
                                                                (pw, index) => {
                                                                    return (
                                                                        <>
                                                                            <div
                                                                                className={`workflowpage-allrunning-workflow-item ${flowDetails.currentdataworkflowulogid === pw.workflowulogid ? "active" : ""}`}
                                                                            >
                                                                                <div>
                                                                                    {commonservices.convertDateAndTimeInLocalTimeZone(
                                                                                        pw.starton,
                                                                                        "MM/DD/YYYY HH:mm:ss",
                                                                                    )}{" "}
                                                                                    <span className="workflowulogid ">
                                                                                        ({pw.workflowulogid.slice(-7)})
                                                                                    </span>
                                                                                    {pw.argostatus.toUpperCase() ===
                                                                                        "SUSPEND" && (
                                                                                            <>
                                                                                                <button
                                                                                                    className="btn-view yellow"
                                                                                                    title="Resume"
                                                                                                    onClick={() =>
                                                                                                        fnRunworkflow(
                                                                                                            "resume",
                                                                                                            flowDetails?.workflowkey,
                                                                                                            flowDetails?.workflowid,
                                                                                                            pw.workflowulogid,
                                                                                                            flowDetails.currentdataworkflowulogid,
                                                                                                        )
                                                                                                    }
                                                                                                >
                                                                                                    <img
                                                                                                        src={Resumeicon}
                                                                                                        alt="Resume"
                                                                                                    />
                                                                                                </button>
                                                                                            </>
                                                                                        )}
                                                                                    {(pw.argostatus.toUpperCase() ===
                                                                                        "RUNNING" ||
                                                                                        pw.argostatus.toUpperCase() ===
                                                                                        "RESUME") && (
                                                                                            <>
                                                                                                <button
                                                                                                    className="btn-view yellow"
                                                                                                    title="Suspend"
                                                                                                    onClick={() =>
                                                                                                        fnRunworkflow(
                                                                                                            "suspend",
                                                                                                            flowDetails?.workflowkey,
                                                                                                            flowDetails?.workflowid,
                                                                                                            pw.workflowulogid,
                                                                                                            flowDetails.currentdataworkflowulogid,
                                                                                                        )
                                                                                                    }
                                                                                                >
                                                                                                    <img
                                                                                                        src={Suspendicon}
                                                                                                        alt="Suspend"
                                                                                                    />
                                                                                                </button>
                                                                                                <button
                                                                                                    className="btn-view red"
                                                                                                    title="Stop"
                                                                                                    onClick={() =>
                                                                                                        fnRunworkflow(
                                                                                                            "stop",
                                                                                                            flowDetails?.workflowkey,
                                                                                                            flowDetails?.workflowid,
                                                                                                            pw.workflowulogid,
                                                                                                            flowDetails.currentdataworkflowulogid,
                                                                                                        )
                                                                                                    }
                                                                                                >
                                                                                                    <img
                                                                                                        src={Stopicon}
                                                                                                        alt="Stop"
                                                                                                    />
                                                                                                </button>
                                                                                            </>
                                                                                        )}
                                                                                    {pw.argostatus.toUpperCase() ===
                                                                                        "STOP" && (
                                                                                            <>
                                                                                                <button
                                                                                                    className="btn-view red"
                                                                                                    title="Delete"
                                                                                                    onClick={() =>
                                                                                                        fnRunworkflow(
                                                                                                            "delete",
                                                                                                            flowDetails?.workflowkey,
                                                                                                            flowDetails?.workflowid,
                                                                                                            pw.workflowulogid,
                                                                                                            flowDetails.currentdataworkflowulogid,
                                                                                                        )
                                                                                                    }
                                                                                                >
                                                                                                    <img
                                                                                                        src={Deleteicon}
                                                                                                        alt="Delete"
                                                                                                    />
                                                                                                </button>
                                                                                            </>
                                                                                        )}
                                                                                    {flowDetails.currentdataworkflowulogid !==
                                                                                        pw.workflowulogid && (
                                                                                            <button
                                                                                                className="btn-view blue"
                                                                                                title="View"
                                                                                                onClick={() => {
                                                                                                    BindDataByID(
                                                                                                        pw.workflowid,
                                                                                                        pw.workflowulogid,
                                                                                                    );
                                                                                                }}
                                                                                            >
                                                                                                <img
                                                                                                    src={viewAction}
                                                                                                    alt="View"
                                                                                                />
                                                                                            </button>
                                                                                        )}
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    );
                                                                },
                                                            )}
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                    </div>
                                </div>

                                {isWorkflowViewDashboard &&
                                    (activeRightSidePanel === "machine" ||
                                        activeRightSidePanel === "summary" ||
                                        activeRightSidePanel === "costSummary") && (
                                        <div
                                            className="workflow-diagram-machine-drawer"
                                            ref={machineDrawerRef}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <button
                                                type="button"
                                                className="workflow-diagram-machine-drawer-close"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setActiveRightSidePanel("sm-panel");
                                                }}
                                                title="Close"
                                                aria-label="Close"
                                            >
                                                ✕
                                            </button>
                                            <div className="workflow-diagram-machine-drawer-content">
                                                {activeRightSidePanel === "machine" && selectedNode && (
                                                    <WorkFlowMachineSetupModel
                                                        isViewMode={isWorkflowViewDashboard}
                                                        selectedNode={selectedNode}
                                                        FnForSetTrackState={FnForSetTrackState}
                                                        activeRightSidePinnedPanel={activeRightSidePinnedPanel}
                                                        NewMachineInfo={NewMachineInfo}
                                                        activeTab={activeTab}
                                                        state={{ ...(state || {}), isViewMode: isWorkflowViewDashboard }}
                                                        FnForsetActiveRightSidePanel={setActiveRightSidePanel}
                                                        FnForsetActiveRightSidePinnedPanel={
                                                            FnForsetActiveRightSidePinnedPanel
                                                        }
                                                        nodes={nodes}
                                                        FnForSetNodes={FnForSetNodes}
                                                        FnForsetSelectedNode={FnForsetSelectedNode}
                                                        ProjectTermList={ProjectTermList}
                                                        allMachineList={allMachineList}
                                                        parametersforworkflow={parametersforworkflow}
                                                        loop_sample_data={loop_sample_data}
                                                        edges={edges}
                                                    />
                                                )}
                                                {activeRightSidePanel === "summary" && (
                                                    <WorkFlowStatusModel
                                                        NetworkUsageChart={NetworkUsageChart}
                                                        MemoryUsageChart={MemoryUsageChart}
                                                        CPUUsageChart={CPUUsageChart}
                                                        id={id}
                                                        NewMachineInfo={NewMachineInfo}
                                                        FnForsetIsWorkFlowIsRunning={setIsWorkFlowIsRunning}
                                                        IsWorkFlowIsRunning={IsWorkFlowIsRunning}
                                                        FnForsetActiveRightSidePanel={setActiveRightSidePanel}
                                                        activeRightSidePinnedPanel={activeRightSidePinnedPanel}
                                                        FnForsetActiveRightSidePinnedPanel={
                                                            FnForsetActiveRightSidePinnedPanel
                                                        }
                                                        flowDetails={flowDetails}
                                                        BindDataByID={BindDataByID}
                                                        FunForsetActiveSidePanelPinned={
                                                            FunForsetActiveSidePanelPinned
                                                        }
                                                        FunForsetActiveSidePanel={FunForsetActiveSidePanel}
                                                        laststatus={""}
                                                        isViewMode={isWorkflowViewDashboard}
                                                    />
                                                )}
                                                {activeRightSidePanel === "costSummary" && (
                                                    <WorkflowCostSummaryModel
                                                        isViewMode={isWorkflowViewDashboard}
                                                        activeRightSidePinnedPanel={activeRightSidePinnedPanel}
                                                        FnForsetActiveRightSidePanel={setActiveRightSidePanel}
                                                        FnForsetActiveRightSidePinnedPanel={
                                                            FnForsetActiveRightSidePinnedPanel
                                                        }
                                                        nodes={nodes}
                                                        WorkFlowMachineStatus={WorkFlowMachineStatus}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    )}
                            </div>

                            {isWorkflowViewDashboard && (
                                <>
                                    <section className="workflow-dashboard-card workflow-dashboard-summary">
                                        <div className="workflow-dashboard-card-header">
                                            <h2>
                                                <img
                                                    src={fileGrey}
                                                    alt="Workflow Summary"
                                                    className="workflow-card-header-icon"
                                                />
                                                Workflow Summary
                                            </h2>
                                            {/* <button type="button" className="workflow-dashboard-link">
                        Edit
                      </button> */}
                                        </div>
                                        {!flowDetails ? (
                                            <Loader type={LoaderType.WorkflowSummary} />
                                        ) : (
                                            <dl className="workflow-summary-list">
                                                <div>
                                                    <dt>Name</dt>
                                                    <dd>{flowDetails?.workflowname ?? "--"}</dd>
                                                </div>
                                                <div>
                                                    <dt>Status</dt>
                                                    <dd>
                                                        <span
                                                            className="workflow-status-pill"
                                                            style={{
                                                                backgroundColor: getWorkflowStatusColor(
                                                                    flowDetails?.workflowsavestatus,
                                                                ).backColor,
                                                                color: getWorkflowStatusColor(
                                                                    flowDetails?.workflowsavestatus,
                                                                ).foreColor,
                                                            }}
                                                        >
                                                            {flowDetails?.workflowsavestatus ?? "--"}
                                                        </span>
                                                    </dd>
                                                </div>
                                                <div>
                                                    <dt>Total Machines</dt>
                                                    <dd>{flowDetails?.totalmachine ?? "0"}</dd>
                                                </div>
                                                <div>
                                                    <dt>Start Date</dt>
                                                    <dd>
                                                        {commonservices.getDateInFormatCustom(
                                                            flowDetails?.startondatetime,
                                                            null,
                                                            "MM/DD/yyyy",
                                                        ) ?? "--"}
                                                    </dd>
                                                </div>
                                                <div>
                                                    <dt>End Date</dt>
                                                    <dd>
                                                        {commonservices.getDateInFormatCustom(
                                                            flowDetails?.endondatetime,
                                                            null,
                                                            "MM/DD/yyyy",
                                                        ) ?? "--"}
                                                    </dd>
                                                </div>
                                                <div>
                                                    <dt>Timezone</dt>
                                                    <dd>{flowDetails?.timezone ?? "--"}</dd>
                                                </div>
                                                <div>
                                                    <dt>Schedule</dt>
                                                    <dd>
                                                        <span className="workflow-schedule-pill">
                                                            <svg
                                                                width="13"
                                                                height="13"
                                                                viewBox="0 0 24 24"
                                                                fill="none"
                                                                stroke="currentColor"
                                                                strokeWidth="2"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            >
                                                                <circle cx="12" cy="12" r="10" />
                                                                <polyline points="12 6 12 12 16 14" />
                                                            </svg>
                                                            {" " + flowDetails?.cronexpression ?? "--"}
                                                        </span>
                                                    </dd>
                                                </div>
                                                <div>
                                                    <dt>Created By</dt>
                                                    <dd>{flowDetails?.displayname ?? "--"}</dd>
                                                </div>
                                                <div>
                                                    <dt>Created On</dt>
                                                    <dd>
                                                        {commonservices.getDateInFormatCustom(
                                                            flowDetails?.createdon,
                                                            null,
                                                            "MM/DD/yyyy",
                                                        ) +
                                                            " " +
                                                            commonservices.getTimeInFormat(
                                                                flowDetails?.createdon,
                                                            ) ?? "--"}
                                                    </dd>
                                                </div>
                                                <div>
                                                    <dt>Last Published</dt>
                                                    <dd>
                                                        {commonservices.getDateInFormatCustom(
                                                            flowDetails?.updatedon,
                                                            null,
                                                            "MM/DD/yyyy",
                                                        ) +
                                                            " " +
                                                            commonservices.getTimeInFormat(
                                                                flowDetails?.updatedon,
                                                            ) ?? "--"}
                                                    </dd>
                                                </div>
                                                <div>
                                                    <dt>Last Status</dt>
                                                    <dd>
                                                        {commonservices?.getlogPopupStatusCapsule(
                                                            flowDetails?.laststatus,
                                                        ) ?? "--"}
                                                    </dd>
                                                </div>
                                                <div>
                                                    <dt>Next Scheduled</dt>
                                                    <dd>
                                                        {commonservices.getDateInFormatCustom(
                                                            flowDetails?.nextrunon,
                                                            null,
                                                            "MM/DD/yyyy",
                                                        ) +
                                                            " " +
                                                            commonservices.getTimeInFormat(
                                                                flowDetails?.nextrunon,
                                                            ) ?? "--"}
                                                    </dd>
                                                </div>
                                                <div>
                                                    <dt>Description</dt>
                                                    <dd>{flowDetails?.description ?? "--"}</dd>
                                                </div>
                                            </dl>
                                        )}
                                    </section>

                                    <section className="workflow-dashboard-card workflow-dashboard-cost">
                                        <div className="workflow-dashboard-card-header">
                                            <h2>
                                                <img
                                                    src={dollar}
                                                    alt="Cost Summary"
                                                    className="workflow-card-header-icon"
                                                />
                                                Cost Summary
                                            </h2>
                                        </div>
                                        {!flowDetails ? (
                                            <Loader type={LoaderType.WorkflowCostSummary} />
                                        ) : (
                                            <>
                                                <div className="workflow-dashboard-card-title"><h3>Execution Cost Summary</h3></div>
                                                <div className="workflow-dashboard-table workflow-cost-table">
                                                    <div className="workflow-dashboard-table-head">
                                                        <span>Machines</span>
                                                        <span>Last Run</span>
                                                        <span>Avg. Run</span>
                                                    </div>
                                                    {WorkFlowMachineStatus?.map((item, index) => {
                                                        const machineName =
                                                            commonservices.makeMachineDisplayName(
                                                                item?.machinename,
                                                                0,
                                                                item?.assemblyname,
                                                                item?.workflowmachinename,
                                                            );

                                                        return (
                                                            <div
                                                                className="workflow-dashboard-table-row"
                                                                key={`${item?.workflowmachinename || "machine"}-${index}`}
                                                            >
                                                                <span title={machineName}>{machineName}</span>
                                                                <span>
                                                                    {item?.consumptioncost
                                                                        ? `$ ${item.consumptioncost.toFixed(5)}`
                                                                        : "-"}
                                                                </span>
                                                                <span>
                                                                    {item?.avgconsumptioncost
                                                                        ? `$ ${item.avgconsumptioncost.toFixed(5)}`
                                                                        : "-"}
                                                                </span>
                                                            </div>
                                                        );
                                                    })}
                                                    {!WorkFlowMachineStatus?.length && (
                                                        <div className="workflow-dashboard-table-row">
                                                            <span>--</span>
                                                            <span>-</span>
                                                            <span>-</span>
                                                        </div>
                                                    )}
                                                    <div className="workflow-dashboard-table-row workflow-dashboard-total">
                                                        <span>Total</span>
                                                        <span>$ {dashboardLastRunTotal.toFixed(5)}</span>
                                                        <span>$ {dashboardPreviousRunTotal.toFixed(5)}</span>
                                                    </div>
                                                </div>
                                                <h3>Machines Use in this Workflow</h3>
                                                <div className="workflow-dashboard-table workflow-usage-table">
                                                    <div className="workflow-dashboard-table-head">
                                                        <span>Machines</span>
                                                        <span>Usage Type</span>
                                                    </div>
                                                    {dashboardUniqueNodes?.map((item, index) => (
                                                        <div
                                                            className="workflow-dashboard-table-row"
                                                            key={`${item?.typeid || "machine"}-${index}`}
                                                        >
                                                            <span title={item?.typeName}>{item?.typeName}</span>
                                                            <span>{item?.price ? `$${item.price}` : "Free"}</span>
                                                        </div>
                                                    ))}
                                                    {!dashboardUniqueNodes?.length && (
                                                        <div className="workflow-dashboard-table-row">
                                                            <span>--</span>
                                                            <span>--</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        )}
                                    </section>
                                </>
                            )}
                        </div>

                        {isWorkflowViewDashboard && (
                            <div className="workflow-dashboard-bottom-row">
                                <section className="workflow-dashboard-card workflow-dashboard-runs">
                                    <div className="workflow-dashboard-card-header">
                                        <h2>
                                            <img
                                                src={clockhistory}
                                                alt="Recent Runs"
                                                className="workflow-card-header-icon"
                                            />
                                            Recent Runs
                                        </h2>
                                        <span
                                            style={{
                                                color: "#2571F1",
                                                fontWeight: "600",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => setModalShow1(!modalShow1)}
                                        >
                                            View All
                                        </span>
                                    </div>
                                    <div className="workflow-dashboard-table workflow-runs-table">
                                        <div className="workflow-dashboard-table-head">
                                            <span>Date</span>
                                            <span>Run At</span>
                                            <span>Duration</span>
                                            <span>Status</span>
                                            <span className="text-end">Action</span>
                                        </div>
                                        {RecentRunsLoader ? (
                                            <div className="my-2">
                                                <Loader type={LoaderType.Line} count={5} />
                                            </div>
                                        ) : RecentRunsList?.length > 0 ? (
                                            RecentRunsList.map((item, index) => (
                                                <div
                                                    className="workflow-dashboard-table-row"
                                                    key={item?.workflowschedulelogid || index}
                                                >
                                                    <span>
                                                        {commonservices.getDateInFormatCustom(
                                                            item?.starton,
                                                            null,
                                                            "MM/DD/yyyy",
                                                        )}
                                                    </span>
                                                    <span>
                                                        {commonservices.getTimeInFormat(item?.starton)}
                                                    </span>
                                                    <span>
                                                        {item?.status !== "start"
                                                            ? commonservices.calculateDuration(
                                                                item?.starton,
                                                                item?.endon,
                                                            )
                                                            : "--"}
                                                    </span>
                                                    <span>
                                                        {commonservices?.getlogPopupStatus(item?.status)}
                                                    </span>
                                                    <span className="text-end">
                                                        <img
                                                            className="cursor-pointer"
                                                            src={viewActionIcon}
                                                            alt="View"
                                                            title="View"
                                                            height={"16px"}
                                                            width={"16px"}
                                                            onClick={() => {
                                                                setRecentRunLogId(item.workflowschedulelogid);
                                                                setRecentRunDetailShow(true);
                                                            }}
                                                        />
                                                    </span>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="workflow-dashboard-table-row">
                                                <span>--</span>
                                                <span>--</span>
                                                <span>--</span>
                                                <span>--</span>
                                                <span>--</span>
                                            </div>
                                        )}
                                    </div>
                                </section>

                                <section className="workflow-dashboard-card workflow-dashboard-schedule">
                                    <div className="workflow-dashboard-card-header">
                                        <h2>
                                            <img
                                                src={contacts}
                                                alt="Team Members"
                                                className="workflow-card-header-icon"
                                            />
                                            Team Members ({contactList.length})
                                        </h2>
                                    </div>
                                    <div className="workflow-header-main-team">
                                        {" "}
                                        {contactList.map((member) => (
                                            <div className="workflow-team-row" key={member.userid}>
                                                <img
                                                    src={member?.profilepicurl || profileicon}
                                                    alt={member?.firstname}
                                                    title={member?.firstname}
                                                    key={member.userid}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = profileicon;
                                                    }}
                                                />
                                                <span
                                                    title={member?.firstname + " " + member?.lastname}
                                                >
                                                    {commonservices.truncateText(
                                                        member?.firstname + " " + member?.lastname,
                                                        20,
                                                    )}
                                                </span>
                                                <small>{member?.rolename}</small>
                                            </div>
                                        ))}
                                    </div>
                                </section>

                                <section className="workflow-dashboard-card workflow-dashboard-trend">
                                    <div className="workflow-dashboard-card-header">
                                        <h2>
                                            <img
                                                src={charticon}
                                                alt="Usage Trend"
                                                className="workflow-card-header-icon"
                                            />
                                            Usage Trend (Last 7 Days)
                                        </h2>
                                    </div>
                                    {UsageTrendChartLoader ? (
                                        <div className="my-2">
                                            <Loader type={LoaderType.ChartThinLine} />
                                        </div>
                                    ) : UsageTrendChartData?.datasets?.length > 0 ? (
                                        <div className="workflow-trend-chart-wrapper">
                                            <StackedBarChart
                                                barthickness="10"
                                                data={UsageTrendChartData}
                                            />
                                        </div>
                                    ) : (
                                        <Nodata />
                                    )}
                                </section>
                            </div>
                        )}

                        {/*<div*/}
                        {/*    className={`panel bottom-panel ai-enhanced-box ${activeBottomSidePanel ? "open" : "closed"*/}
                        {/*        }`}*/}
                        {/*    style={{*/}
                        {/*        left: `${leftOffset}px`,*/}
                        {/*        right: `${rightOffset}px`,*/}
                        {/*    }}*/}
                        {/*>*/}
                        {/*    <div className="panel-header">*/}
                        {/*        <div className="ai-enhanced-machine-top justify-content-between">*/}
                        {/*            <div className="d-flex align-items-center gap-2 tourWorkflowAI">*/}
                        {/*                <h4*/}
                        {/*                    onClick={() => {*/}
                        {/*                        if (!state?.isViewMode) {*/}
                        {/*                            setActiveBottomSidePanel(!activeBottomSidePanel);*/}
                        {/*                        }*/}
                        {/*                    }}*/}
                        {/*                    style={{ cursor: "pointer" }}*/}
                        {/*                >*/}
                        {/*                    AI-Enhanced Machine*/}
                        {/*                </h4>*/}
                        {/*                <span className="light-yellow-badge">Recommendation</span>*/}
                        {/*            </div>*/}

                        {/*            <div className="d-flex gap-2">*/}
                        {/*                {" "}*/}
                        {/*                <>*/}
                        {/*                    {!state?.isViewMode && (*/}
                        {/*                        <button*/}
                        {/*                            className="blue-btn mw-fit-content"*/}
                        {/*                            // ref = { target1 }*/}
                        {/*                            onClick={(e) => {*/}
                        {/*                                e.preventDefault();*/}
                        {/*                                if (descriptionName?.length > 250) {*/}
                        {/*                                    setAiEnhanceState(true);*/}
                        {/*                                    setAIEnhanceLoader(true);*/}
                        {/*                                    dispatch(*/}
                        {/*                                        GetMachines({*/}
                        {/*                                            thread_id: AIMachineList?.thread_id || "",*/}
                        {/*                                            query: AIPromptData || descriptionName,*/}
                        {/*                                            machine: nodes,*/}
                        {/*                                        })*/}
                        {/*                                    )?.then((res) => {*/}
                        {/*                                        setAI_ActiveBox(*/}
                        {/*                                            res?.payload?.machines?.[0]?.machine_id*/}
                        {/*                                        );*/}
                        {/*                                        setAIEnhanceLoader(false);*/}
                        {/*                                    });*/}
                        {/*                                } else {*/}
                        {/*                                    toast.error(*/}
                        {/*                                        "Please enter a description of more than 250 characters."*/}
                        {/*                                    );*/}
                        {/*                                    setEditstatusfordes(true);*/}
                        {/*                                    setworkFlowDiscriptionPopupstate(*/}
                        {/*                                        !workFlowDiscriptionPopupstate*/}
                        {/*                                    );*/}
                        {/*                                    workFlowDiscriptionPopup();*/}
                        {/*                                }*/}
                        {/*                            }}*/}
                        {/*                        >*/}
                        {/*                            Get AI Suggestion*/}
                        {/*                        </button>*/}
                        {/*                    )}*/}
                        {/*                </>*/}
                        {/*                {activeBottomSidePanel && (*/}
                        {/*                    <img*/}
                        {/*                        src={activeBottomSidePanelPinned ? pinned : unpinned}*/}
                        {/*                        onClick={() =>*/}
                        {/*                            activeBottomSidePanelPinned*/}
                        {/*                                ? setActiveBottomSidePanelPinned(false)*/}
                        {/*                                : setActiveBottomSidePanelPinned(true)*/}
                        {/*                        }*/}
                        {/*                        alt="pinned"*/}
                        {/*                        style={{ cursor: "pointer" }}*/}
                        {/*                    />*/}
                        {/*                )}*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*    <div className="panel-content">*/}
                        {/*        <div className="ai-enhanced-machine-bottom">*/}
                        {/*            <div className="d-flex gap-2 machine-with-image-single-diff-wrapper">*/}
                        {/*                <div>*/}
                        {/*                    <img src={robot} alt="robot" className="robot-gif" />*/}
                        {/*                </div>*/}
                        {/*                <div className="ai-enhanced-machine-bottom-left">*/}
                        {/*                    {AIEnhanceLoader ? (*/}
                        {/*                        <Loader type={LoaderType.AiEnhancedMachine} />*/}
                        {/*                    ) : (*/}
                        {/*                        <>*/}
                        {/*                            {" "}*/}
                        {/*                            {(AIMachineListOnNodes?.machines?.length > 0 &&*/}
                        {/*                                AIMachineListOnNodes?.machines*/}
                        {/*                                    ?.filter((item) => item?.machinelogo)*/}
                        {/*                                    ?.map((itm) => {*/}
                        {/*                                        return (*/}
                        {/*                                            <>*/}
                        {/*                                                {" "}*/}
                        {/*                                                <div*/}
                        {/*                                                    onClick={() =>*/}
                        {/*                                                        setAI_ActiveBox(itm?.machine_id)*/}
                        {/*                                                    }*/}
                        {/*                                                    className="machine-with-image-single"*/}
                        {/*                                                >*/}
                        {/*                                                    <h5>{itm?.machine_name}</h5>*/}
                        {/*                                                    <img*/}
                        {/*                                                        src={itm?.machinelogo || analatics}*/}
                        {/*                                                        alt="analatics"*/}
                        {/*                                                    />*/}
                        {/*                                                </div>*/}
                        {/*                                                {ai_ActiveBox === itm?.machine_id && (*/}
                        {/*                                                    <>*/}
                        {/*                                                        <p>{itm?.description}</p>*/}
                        {/*                                                        <AddApplyButton*/}
                        {/*                                                            machineid={itm?.machine_id}*/}
                        {/*                                                        />*/}
                        {/*                                                    </>*/}
                        {/*                                                )}*/}
                        {/*                                            </>*/}
                        {/*                                        );*/}
                        {/*                                    })) ||*/}
                        {/*                                (AIMachineList?.suggested_machines?.length > 0 &&*/}
                        {/*                                    AIMachineList?.suggested_machines?.map((item) => {*/}
                        {/*                                        return (*/}
                        {/*                                            <>*/}
                        {/*                                                {" "}*/}
                        {/*                                                <div*/}
                        {/*                                                    onClick={() =>*/}
                        {/*                                                        setAI_ActiveBox(item?.machine_id)*/}
                        {/*                                                    }*/}
                        {/*                                                    className="machine-with-image-single"*/}
                        {/*                                                >*/}
                        {/*                                                    <h5>{item?.machine_name}</h5>*/}
                        {/*                                                    <img*/}
                        {/*                                                        src={item?.machinelogo || analatics}*/}
                        {/*                                                        alt="analatics"*/}
                        {/*                                                    />*/}
                        {/*                                                </div>*/}
                        {/*                                                {ai_ActiveBox === item?.machine_id && (*/}
                        {/*                                                    <>*/}
                        {/*                                                        <p>{item?.description}</p>*/}

                        {/*                                                        <AddApplyButton*/}
                        {/*                                                            machineid={item?.machine_id}*/}
                        {/*                                                        />*/}
                        {/*                                                    </>*/}
                        {/*                                                )}*/}
                        {/*                                            </>*/}
                        {/*                                        );*/}
                        {/*                                    }))}*/}
                        {/*                        </>*/}
                        {/*                    )}*/}
                        {/*                </div>*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                </>
            </div>
            {trackStatePopup && (
                <FlowSaveConfirmPopup
                    show={trackStatePopup}
                    onHide={(e) => setTrackStatePopup(false)}
                />
            )}
            {modalShow && (
                <DeleteModal
                    payload={DeletePayload}
                    url={API_URL.WORKFLOW.UPDATE_WORKFLOW_STATUS}
                    show={modalShow}
                    bindlist={() => {
                        if (RedirectParam === "dc" || RedirectParam === "dl") {
                            navigate("/dashboard", {
                                state: {
                                    param: RedirectParam,
                                },
                            });
                        } else if (RedirectParam === "wc" || RedirectParam === "wl") {
                            navigate("/workflows", {
                                state: {
                                    param: RedirectParam,
                                },
                            });
                        } else if (RedirectParam === "sl") {
                            navigate("/scheduler", {
                                state: {
                                    param: RedirectParam,
                                },
                            });
                        } else if (RedirectParam === "wa") {
                            navigate("/management-listing", {
                                state: "workflow",
                            });
                        } else {
                            navigate("/dashboard");
                        }
                    }}
                    onHide={(e) => setModalShow(false)}
                />
            )}
            {showSaveAsCopyModel && (
                <SaveAsCopyModal
                    flowName={flowName ? flowName.trim() : flowName}
                    handleWorkFlowCopy={handleWorkFlowCopy}
                    show={showSaveAsCopyModel}
                    onHide={() => {
                        handleFlowOperations("Publish");
                        setShowSaveAsCopyModel(false);
                    }}
                />
            )}
            {modalShow1 && (
                <WorkFlowLogModal
                    show={modalShow1}
                    id={id}
                    onHide={() => setModalShow1(false)}
                />
            )}
            {recentRunDetailShow && recentRunLogId > 0 && (
                <WorkFlowMachineLogDetailModal
                    show={recentRunDetailShow}
                    id={recentRunLogId}
                    onHide={() => setRecentRunDetailShow(false)}
                />
            )}
            {supportShowModel && (
                <SupportModel
                    relatedToLabel={flowName ? flowName.trim() : flowName}
                    case_Type={"Data Factory"}
                    user_Type={Userdata?.associationtype}
                    ass_Id={id}
                    ass_Type={"Workflow"}
                    show={supportShowModel}
                    onHide={() => setSupportShowModel(false)}
                />
            )}

            {marketPlacePopup && (
                <MarketPlaceDetailPopup
                    show={marketPlacePopup}
                    onHide={() => setMarketPlacePopup(false)}
                    id={marketPlacePopupID}
                    pagename="Marketplace"
                    endCall={getMachineListBySubscriberIdAgain}
                />
            )}

            {IsOpenDataProfileConfiguration && (
                <DataMapping
                    data={DataProfileDetails}
                    show={IsOpenDataProfileConfiguration}
                    onHide={() => setIsOpenDataProfileConfiguration(false)}
                    fnSetDataProfiling={fnSetDataProfiling}
                    fnSetCondition={fnSetCondition}
                    conditionStartIndex={(() => {
                        let count = 0;
                        for (let i = 0; i < nodes.length; i++) {
                            if (nodes[i].id === DataProfileDetails?.nodeid) break;
                            count += nodes[i].condition_list?.length || 0;
                        }
                        return count;
                    })()}
                />
            )}
        </>
    );
};

export default DataNewFlowPage;
